import Icon, {LoadingOutlined} from "@ant-design/icons";
import type {CustomIconComponentProps} from "@ant-design/icons/lib/components/Icon";
import {StyledLogoSvg} from "../brand-image/brand-image.style";
import {motion} from "framer-motion";
import React from "react";

const TwitterSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.0647C6.20156 2.0647 1.5 6.76626 1.5 12.5647C1.5 18.3631 6.20156 23.0647 12 23.0647C17.7984 23.0647 22.5 18.3631 22.5 12.5647C22.5 6.76626 17.7984 2.0647 12 2.0647ZM17.0461 9.97954C17.0531 10.0897 17.0531 10.2045 17.0531 10.317C17.0531 13.7577 14.4328 17.7209 9.64453 17.7209C8.16797 17.7209 6.79922 17.292 5.64609 16.5538C5.85703 16.5772 6.05859 16.5866 6.27422 16.5866C7.49297 16.5866 8.61328 16.1741 9.50625 15.4756C8.3625 15.4522 7.40156 14.7022 7.07344 13.6709C7.47422 13.7295 7.83516 13.7295 8.24766 13.6241C7.65873 13.5044 7.12939 13.1846 6.74957 12.7189C6.36974 12.2532 6.16286 11.6703 6.16406 11.0694V11.0366C6.50859 11.2311 6.91406 11.3506 7.33828 11.367C6.98166 11.1294 6.6892 10.8074 6.48682 10.4296C6.28445 10.0518 6.17841 9.62998 6.17813 9.20142C6.17813 8.71626 6.30469 8.27329 6.53203 7.88892C7.18571 8.69361 8.0014 9.35175 8.92609 9.82055C9.85078 10.2894 10.8638 10.5583 11.8992 10.61C11.5312 8.84048 12.8531 7.40845 14.4422 7.40845C15.1922 7.40845 15.8672 7.72251 16.343 8.22876C16.9312 8.1186 17.4937 7.89829 17.9953 7.60298C17.8008 8.20532 17.393 8.71392 16.8516 9.03501C17.3766 8.97876 17.8828 8.83345 18.3516 8.62954C17.9977 9.14985 17.5547 9.61157 17.0461 9.97954Z"
      fill="#597EF7"
    />
  </svg>
);
const TwitterSVGSm = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.03847 10.504C7.66147 10.504 9.75747 7.69104 9.75747 5.02154C9.75747 4.94804 10.2725 4.50604 10.493 3.58454C10.538 3.39754 10.356 3.25004 10.1845 3.32854C9.74447 3.53054 9.29797 3.37054 9.10397 3.14054C8.35797 2.32704 7.11047 2.28804 6.31697 3.05304C5.80547 3.54654 5.58847 4.28154 5.74697 4.98304C4.07147 5.10254 2.92097 4.30854 1.97497 3.22004C1.85297 3.07854 1.62647 3.15304 1.60097 3.34004C1.46097 4.38104 1.41697 6.91204 3.92497 8.36554C3.48947 8.99154 2.63697 9.36104 1.68797 9.51954C1.47797 9.55504 1.42797 9.84604 1.61997 9.94004C2.37197 10.31 3.19847 10.5035 4.03847 10.5025"
      fill="#231F20"
    />
    <mask
      id="mask0_9110_18879"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="10"
      height="9"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.03847 10.504C7.66147 10.504 9.75747 7.69104 9.75747 5.02154C9.75747 4.94804 10.2725 4.50604 10.493 3.58454C10.538 3.39754 10.356 3.25004 10.1845 3.32854C9.74447 3.53054 9.29797 3.37054 9.10397 3.14054C8.35797 2.32704 7.11047 2.28804 6.31697 3.05304C5.80547 3.54654 5.58847 4.28154 5.74697 4.98304C4.07147 5.10254 2.92097 4.30854 1.97497 3.22004C1.85297 3.07854 1.62647 3.15304 1.60097 3.34004C1.46097 4.38104 1.41697 6.91204 3.92497 8.36554C3.48947 8.99154 2.63697 9.36104 1.68797 9.51954C1.47797 9.55504 1.42797 9.84604 1.61997 9.94004C2.37197 10.31 3.19847 10.5035 4.03847 10.5025"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9110_18879)">
      <rect y="0.503906" width="12" height="12" fill="#00ACEE" />
    </g>
  </svg>
);

const InstagramSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9992 7.19384C9.33904 7.19384 7.19216 9.34071 7.19216 12.0009C7.19216 14.661 9.33904 16.8079 11.9992 16.8079C14.6594 16.8079 16.8062 14.661 16.8062 12.0009C16.8062 9.34071 14.6594 7.19384 11.9992 7.19384ZM11.9992 15.1251C10.2789 15.1251 8.87498 13.7212 8.87498 12.0009C8.87498 10.2806 10.2789 8.87665 11.9992 8.87665C13.7195 8.87665 15.1234 10.2806 15.1234 12.0009C15.1234 13.7212 13.7195 15.1251 11.9992 15.1251ZM17.0031 5.87665C16.382 5.87665 15.8804 6.37821 15.8804 6.99931C15.8804 7.6204 16.382 8.12196 17.0031 8.12196C17.6242 8.12196 18.1258 7.62274 18.1258 6.99931C18.1259 6.85182 18.097 6.70576 18.0407 6.56946C17.9843 6.43317 17.9016 6.30934 17.7974 6.20505C17.6931 6.10077 17.5692 6.01808 17.4329 5.96173C17.2967 5.90538 17.1506 5.87646 17.0031 5.87665ZM21.3695 12.0009C21.3695 10.7071 21.3812 9.42509 21.3086 8.13368C21.2359 6.63368 20.8937 5.30243 19.7969 4.20556C18.6976 3.10634 17.3687 2.76649 15.8687 2.69384C14.575 2.62118 13.2929 2.6329 12.0015 2.6329C10.7078 2.6329 9.42576 2.62118 8.13435 2.69384C6.63435 2.76649 5.3031 3.10868 4.20623 4.20556C3.10701 5.30477 2.76716 6.63368 2.69451 8.13368C2.62185 9.42743 2.63357 10.7095 2.63357 12.0009C2.63357 13.2923 2.62185 14.5766 2.69451 15.8681C2.76716 17.3681 3.10935 18.6993 4.20623 19.7962C5.30545 20.8954 6.63435 21.2352 8.13435 21.3079C9.4281 21.3806 10.7101 21.3688 12.0015 21.3688C13.2953 21.3688 14.5773 21.3806 15.8687 21.3079C17.3687 21.2352 18.7 20.8931 19.7969 19.7962C20.8961 18.697 21.2359 17.3681 21.3086 15.8681C21.3836 14.5766 21.3695 13.2946 21.3695 12.0009ZM19.307 17.5274C19.1359 17.954 18.9297 18.2727 18.5992 18.6009C18.2687 18.9313 17.9523 19.1376 17.5258 19.3087C16.2929 19.7985 13.3656 19.6884 11.9992 19.6884C10.6328 19.6884 7.7031 19.7985 6.47029 19.311C6.04373 19.1399 5.72498 18.9337 5.39685 18.6032C5.06638 18.2727 4.86013 17.9563 4.68904 17.5298C4.20154 16.2946 4.3117 13.3673 4.3117 12.0009C4.3117 10.6345 4.20154 7.70477 4.68904 6.47196C4.86013 6.0454 5.06638 5.72665 5.39685 5.39852C5.72732 5.0704 6.04373 4.86181 6.47029 4.69071C7.7031 4.20321 10.6328 4.31337 11.9992 4.31337C13.3656 4.31337 16.2953 4.20321 17.5281 4.69071C17.9547 4.86181 18.2734 5.06806 18.6015 5.39852C18.932 5.72899 19.1383 6.0454 19.3094 6.47196C19.7969 7.70477 19.6867 10.6345 19.6867 12.0009C19.6867 13.3673 19.7969 16.2946 19.307 17.5274Z"
      fill="#1C1726"
    />
  </svg>
);
const FacebookSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.625 3.1897H3.375C2.96016 3.1897 2.625 3.52485 2.625 3.9397V21.1897C2.625 21.6045 2.96016 21.9397 3.375 21.9397H20.625C21.0398 21.9397 21.375 21.6045 21.375 21.1897V3.9397C21.375 3.52485 21.0398 3.1897 20.625 3.1897ZM18.4594 8.66235H16.9617C15.7875 8.66235 15.5602 9.22017 15.5602 10.0405V11.8475H18.3633L17.9977 14.6764H15.5602V21.9397H12.6375V14.6788H10.193V11.8475H12.6375V9.76157C12.6375 7.34048 14.1164 6.02095 16.2773 6.02095C17.3133 6.02095 18.2016 6.09829 18.4617 6.13345V8.66235H18.4594Z"
      fill="#2F54EB"
    />
  </svg>
);
const FacebookSVGSm = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 2.25391C8.5 2.11591 8.3875 2.00391 8.25 2.00391H7C5.619 2.00391 4.5 3.01141 4.5 4.25391V5.60391H3.25C3.112 5.60391 3 5.71591 3 5.85391V7.15391C3 7.29191 3.112 7.40391 3.25 7.40391H4.5V10.7539C4.5 10.8919 4.612 11.0039 4.75 11.0039H6.25C6.3875 11.0039 6.5 10.8919 6.5 10.7539V7.40391H7.8095C7.922 7.40391 8.0205 7.32891 8.051 7.22091L8.4115 5.92091C8.456 5.76191 8.336 5.60391 8.171 5.60391H6.5V4.25391C6.5 4.00541 6.7235 3.80391 7 3.80391H8.25C8.3875 3.80391 8.5 3.69191 8.5 3.55391V2.25391Z"
      fill="#231F20"
    />
    <mask
      id="mask0_9110_18876"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="3"
      y="2"
      width="6"
      height="10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 2.25391C8.5 2.11591 8.3875 2.00391 8.25 2.00391H7C5.619 2.00391 4.5 3.01141 4.5 4.25391V5.60391H3.25C3.112 5.60391 3 5.71591 3 5.85391V7.15391C3 7.29191 3.112 7.40391 3.25 7.40391H4.5V10.7539C4.5 10.8919 4.612 11.0039 4.75 11.0039H6.25C6.3875 11.0039 6.5 10.8919 6.5 10.7539V7.40391H7.8095C7.922 7.40391 8.0205 7.32891 8.051 7.22091L8.4115 5.92091C8.456 5.76191 8.336 5.60391 8.171 5.60391H6.5V4.25391C6.5 4.00541 6.7235 3.80391 7 3.80391H8.25C8.3875 3.80391 8.5 3.69191 8.5 3.55391V2.25391Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9110_18876)">
      <rect y="0.503906" width="12" height="12" fill="#3B5998" />
    </g>
  </svg>
);
const LinkedinSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.625 3.1897H3.375C2.96016 3.1897 2.625 3.52485 2.625 3.9397V21.1897C2.625 21.6045 2.96016 21.9397 3.375 21.9397H20.625C21.0398 21.9397 21.375 21.6045 21.375 21.1897V3.9397C21.375 3.52485 21.0398 3.1897 20.625 3.1897ZM8.18672 19.167H5.40469V10.2186H8.18672V19.167ZM6.79688 8.99517C6.47795 8.99517 6.16619 8.90059 5.90102 8.72341C5.63584 8.54623 5.42917 8.29439 5.30712 7.99974C5.18507 7.7051 5.15314 7.38088 5.21536 7.06808C5.27758 6.75529 5.43115 6.46797 5.65667 6.24246C5.88218 6.01694 6.1695 5.86337 6.48229 5.80115C6.79509 5.73893 7.11931 5.77086 7.41395 5.89291C7.7086 6.01496 7.96044 6.22163 8.13762 6.48681C8.3148 6.75198 8.40937 7.06374 8.40937 7.38267C8.40703 8.27329 7.68516 8.99517 6.79688 8.99517ZM18.6023 19.167H15.8227V14.8147C15.8227 13.7764 15.8039 12.4428 14.3766 12.4428C12.9305 12.4428 12.7078 13.5725 12.7078 14.7397V19.167H9.93047V10.2186H12.5977V11.442H12.6352C13.0055 10.7389 13.9125 9.99595 15.2672 9.99595C18.0844 9.99595 18.6023 11.8499 18.6023 14.2592V19.167Z"
      fill="#0A66C2"
    />
  </svg>
);
const YoutubeSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.0617 7.50454C21.9422 7.05932 21.7078 6.6533 21.382 6.32713C21.0563 6.00095 20.6505 5.76605 20.2055 5.64595C18.5672 5.20532 12 5.20532 12 5.20532C12 5.20532 5.43281 5.20532 3.79453 5.6436C3.34927 5.76332 2.94334 5.99808 2.61751 6.32432C2.29169 6.65056 2.05744 7.05678 1.93828 7.5022C1.5 9.14282 1.5 12.5647 1.5 12.5647C1.5 12.5647 1.5 15.9866 1.93828 17.6249C2.17969 18.5295 2.89219 19.242 3.79453 19.4834C5.43281 19.9241 12 19.9241 12 19.9241C12 19.9241 18.5672 19.9241 20.2055 19.4834C21.1102 19.242 21.8203 18.5295 22.0617 17.6249C22.5 15.9866 22.5 12.5647 22.5 12.5647C22.5 12.5647 22.5 9.14282 22.0617 7.50454ZM9.91406 15.7053V9.42407L15.3516 12.5413L9.91406 15.7053Z"
      fill="#F5222D"
    />
  </svg>
);
const DribbleSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8227 8.25923C15.1287 7.64176 14.2953 7.20172 13.394 6.9768C12.4928 6.75189 11.5504 6.74881 10.6477 6.96782C10.807 7.1811 11.8547 8.6061 12.7992 10.3428C14.85 9.57407 15.7172 8.40688 15.8227 8.25923ZM12.9844 13.5209C9.73359 14.653 8.56406 16.91 8.46094 17.1209C9.43828 17.8827 10.6664 18.3374 12 18.3374C12.7992 18.3374 13.5609 18.1756 14.2523 17.8803C14.1656 17.3741 13.8328 15.6116 13.0219 13.5069L12.9844 13.5209ZM14.1023 13.242C14.857 15.3139 15.1641 17.0014 15.2227 17.353C16.5164 16.4788 17.4375 15.0936 17.693 13.4881C17.4961 13.4272 15.9094 12.9538 14.1023 13.242ZM12 2.0647C6.20156 2.0647 1.5 6.76626 1.5 12.5647C1.5 18.3631 6.20156 23.0647 12 23.0647C17.7984 23.0647 22.5 18.3631 22.5 12.5647C22.5 6.76626 17.7984 2.0647 12 2.0647ZM12 19.3147C8.27812 19.3147 5.25 16.2866 5.25 12.5647C5.25 8.84282 8.27812 5.8147 12 5.8147C15.7219 5.8147 18.75 8.84282 18.75 12.5647C18.75 16.2866 15.7219 19.3147 12 19.3147ZM13.2445 11.2006C13.3781 11.4749 13.507 11.7538 13.6266 12.035C13.6688 12.1334 13.7109 12.2319 13.7508 12.3327C15.668 12.0913 17.5758 12.478 17.7656 12.5178C17.7539 11.1561 17.2664 9.90689 16.4648 8.92485C16.3406 9.09126 15.375 10.3311 13.2445 11.2006ZM11.6859 10.6897C10.7297 8.99048 9.70078 7.56314 9.54844 7.35454C7.93594 8.11626 6.72891 9.6022 6.35625 11.3905C6.61406 11.3952 8.99063 11.4069 11.6859 10.6897ZM12.4031 12.6233C12.4781 12.5999 12.5531 12.5764 12.6305 12.5553C12.4852 12.2272 12.3281 11.8991 12.1641 11.578C9.28594 12.4405 6.48984 12.403 6.23906 12.3983C6.23672 12.4569 6.23672 12.5155 6.23672 12.5741C6.23672 14.0553 6.79687 15.4077 7.71797 16.4295C7.84687 16.2045 9.42891 13.5842 12.4031 12.6233Z"
      fill="#E94C89"
    />
  </svg>
);
const BehanceSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.85078 11.5874C10.0547 11.4397 10.1531 11.1959 10.1531 10.8608C10.1602 10.7014 10.1273 10.5444 10.057 10.4014C9.99375 10.2866 9.9 10.1905 9.78516 10.1225C9.66608 10.0503 9.53382 10.0025 9.39609 9.98188C9.24609 9.95376 9.09375 9.9397 8.94375 9.94204H7.29609V11.81H9.07969C9.38672 11.8124 9.64687 11.7374 9.85078 11.5874ZM10.1273 13.2749C9.89766 13.0991 9.59062 13.0124 9.20859 13.0124H7.29141V15.2155H9.17109C9.34687 15.2155 9.50859 15.1991 9.66562 15.1663C9.8142 15.1372 9.95582 15.0799 10.0828 14.9975C10.2023 14.9202 10.2984 14.8147 10.3711 14.6788C10.4414 14.5428 10.4766 14.3694 10.4766 14.1608C10.4766 13.7459 10.3594 13.453 10.1273 13.2749ZM12 2.0647C6.20156 2.0647 1.5 6.76626 1.5 12.5647C1.5 18.3631 6.20156 23.0647 12 23.0647C17.7984 23.0647 22.5 18.3631 22.5 12.5647C22.5 6.76626 17.7984 2.0647 12 2.0647ZM14.0273 8.78892H17.2711V9.57876H14.0273V8.78892ZM12 15.3022C11.8483 15.5902 11.6316 15.8389 11.3672 16.0288C11.0906 16.2209 10.7836 16.3616 10.4578 16.4436C10.117 16.5349 9.76536 16.5799 9.4125 16.5772H5.53125V8.58267H9.30469C9.68672 8.58267 10.0336 8.61782 10.35 8.68345C10.6641 8.74907 10.9312 8.86157 11.1562 9.01392C11.3789 9.16626 11.5547 9.37017 11.6789 9.62329C11.8008 9.87407 11.8641 10.1881 11.8641 10.5608C11.8641 10.9639 11.7727 11.2967 11.5898 11.5663C11.4047 11.8358 11.1375 12.0538 10.7742 12.2249C11.2688 12.3655 11.632 12.6163 11.8711 12.9678C12.1148 13.3241 12.2344 13.7506 12.2344 14.2522C12.2344 14.66 12.157 15.0092 12 15.3022ZM18.5344 14.0647H14.3531C14.3531 14.5194 14.5102 14.9553 14.7469 15.1897C14.9859 15.4217 15.3281 15.5389 15.7758 15.5389C16.0992 15.5389 16.3734 15.4569 16.6078 15.2952C16.8398 15.1334 16.9805 14.9624 17.032 14.7842H18.4336C18.2086 15.4803 17.8664 15.9772 17.4023 16.2772C16.943 16.5772 16.3805 16.7272 15.7266 16.7272C15.2695 16.7272 14.8594 16.6522 14.4914 16.5092C14.1375 16.3709 13.8188 16.16 13.5563 15.8881C13.2974 15.6089 13.0974 15.2806 12.968 14.9225C12.825 14.5264 12.7547 14.1092 12.7594 13.6897C12.7594 13.2561 12.832 12.853 12.9727 12.478C13.2422 11.7491 13.8023 11.1655 14.5172 10.8631C14.8992 10.7038 15.3094 10.6241 15.7242 10.6288C16.2164 10.6288 16.643 10.7225 17.0133 10.9147C17.3698 11.0982 17.6793 11.3612 17.918 11.6834C18.1547 12.0045 18.3211 12.3702 18.4266 12.7827C18.5273 13.1881 18.5625 13.6147 18.5344 14.0647ZM15.675 11.8241C15.4219 11.8241 15.2086 11.8686 15.0445 11.9553C14.8805 12.042 14.7445 12.1499 14.6414 12.2741C14.5432 12.394 14.4706 12.5328 14.4281 12.6819C14.3906 12.8061 14.3648 12.9327 14.3555 13.0616H16.9453C16.9078 12.6561 16.7672 12.3561 16.5797 12.1452C16.3828 11.9366 16.0664 11.8241 15.675 11.8241Z"
      fill="#1C1726"
    />
  </svg>
);
const GithubSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9906 2.35217C6.19453 2.34983 1.5 7.04202 1.5 12.8334C1.5 17.4131 4.43672 21.3061 8.52656 22.7358C9.07734 22.8741 8.99297 22.4826 8.99297 22.2155V20.399C5.8125 20.7717 5.68359 18.667 5.47031 18.3155C5.03906 17.5795 4.01953 17.392 4.32422 17.0405C5.04844 16.6678 5.78672 17.1342 6.64219 18.3975C7.26094 19.3139 8.46797 19.1592 9.07969 19.0069C9.21328 18.4561 9.49922 17.9639 9.89297 17.5819C6.59766 16.9912 5.22422 14.9803 5.22422 12.5897C5.22422 11.4295 5.60625 10.3631 6.35625 9.50296C5.87812 8.08499 6.40078 6.87092 6.47109 6.69045C7.83281 6.56858 9.24844 7.66546 9.35859 7.75217C10.132 7.54358 11.0156 7.43342 12.0047 7.43342C12.9984 7.43342 13.8844 7.54827 14.6648 7.75921C14.9297 7.55764 16.2422 6.61546 17.5078 6.7303C17.5758 6.91077 18.0867 8.09671 17.6367 9.49592C18.3961 10.3584 18.7828 11.4342 18.7828 12.5967C18.7828 14.992 17.4 17.0053 14.0953 17.5865C14.3784 17.8649 14.6031 18.1969 14.7564 18.5631C14.9098 18.9293 14.9886 19.3224 14.9883 19.7194V22.3561C15.007 22.567 14.9883 22.7756 15.3398 22.7756C19.4906 21.3764 22.4789 17.4553 22.4789 12.8358C22.4789 7.04202 17.782 2.35217 11.9906 2.35217Z"
      fill="#1C1726"
    />
  </svg>
);
const GlobalSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.025 19.3358C20.0297 19.3288 20.0367 19.3217 20.0414 19.3147C21.5766 17.4889 22.5 15.1358 22.5 12.5647C22.5 9.9936 21.5766 7.64048 20.0438 5.8147C20.0391 5.80767 20.032 5.80298 20.0273 5.79595C20.0016 5.76548 19.9781 5.73735 19.9523 5.70923C19.943 5.69751 19.9336 5.68813 19.9242 5.67642L19.8281 5.56626L19.8258 5.56392C19.7906 5.52407 19.7531 5.48423 19.718 5.44438L19.7156 5.44204C19.6406 5.36235 19.5656 5.28267 19.4883 5.20532L19.4859 5.20298L19.3734 5.09048L19.3664 5.08345C19.3312 5.04829 19.2961 5.01548 19.2609 4.98267C19.2492 4.97095 19.2375 4.95923 19.2234 4.94751C19.2 4.92407 19.1766 4.90298 19.1531 4.88188C19.1461 4.87485 19.1367 4.86782 19.1297 4.85845C17.2594 3.12407 14.7539 2.0647 12 2.0647C9.24609 2.0647 6.74062 3.12407 4.86797 4.85845C4.86094 4.86548 4.85156 4.87251 4.84453 4.88188C4.82109 4.90298 4.79766 4.92642 4.77422 4.94985C4.7625 4.96157 4.75078 4.97329 4.73672 4.98501C4.70156 5.01782 4.66641 5.05298 4.63125 5.08579L4.62422 5.09282L4.51172 5.20532L4.50937 5.20767C4.43203 5.28501 4.35703 5.3647 4.28203 5.44438L4.27969 5.44673C4.24219 5.48657 4.20703 5.52642 4.17188 5.56626L4.16953 5.5686C4.13672 5.60376 4.10391 5.64126 4.07344 5.67876C4.06406 5.69048 4.05469 5.69985 4.04531 5.71157C4.01953 5.7397 3.99609 5.77017 3.97031 5.79829C3.96562 5.80532 3.95859 5.81001 3.95391 5.81704C2.42344 7.64048 1.5 9.9936 1.5 12.5647C1.5 15.1358 2.42344 17.4889 3.95625 19.3147C3.96094 19.3217 3.96797 19.3288 3.97266 19.3358L4.04531 19.4225C4.05469 19.4342 4.06406 19.4436 4.07344 19.4553L4.16953 19.5655C4.16953 19.5678 4.17188 19.5678 4.17188 19.5702C4.20703 19.61 4.24219 19.6499 4.27969 19.6874L4.28203 19.6897C4.35703 19.7694 4.43203 19.8491 4.50703 19.9264L4.50937 19.9288C4.54687 19.9663 4.58203 20.0038 4.61953 20.0389L4.62656 20.0459C4.70391 20.1233 4.78359 20.1983 4.86328 20.2709C6.74062 22.0053 9.24609 23.0647 12 23.0647C14.7539 23.0647 17.2594 22.0053 19.132 20.2709C19.2119 20.1978 19.29 20.1227 19.3664 20.0459L19.3734 20.0389C19.4109 20.0014 19.4484 19.9663 19.4836 19.9288L19.4859 19.9264C19.5633 19.8491 19.6383 19.7694 19.7109 19.6897L19.7133 19.6874C19.7484 19.6475 19.7859 19.61 19.8211 19.5702C19.8211 19.5678 19.8234 19.5678 19.8234 19.5655C19.8562 19.5303 19.8891 19.4928 19.9195 19.4553C19.9289 19.4436 19.9383 19.4342 19.9477 19.4225C19.9742 19.3943 19.9999 19.3653 20.025 19.3358ZM20.1211 15.9936C19.7977 16.7577 19.3711 17.4655 18.8508 18.1077C18.2648 17.6012 17.6241 17.1618 16.9406 16.7975C17.2125 15.6983 17.3813 14.4913 17.4258 13.2209H20.7891C20.7188 14.1795 20.4937 15.11 20.1211 15.9936ZM20.7891 11.9084H17.4258C17.3813 10.6381 17.2125 9.4311 16.9406 8.33188C17.6273 7.96626 18.2672 7.52563 18.8508 7.02173C19.9818 8.41386 20.6584 10.1195 20.7891 11.9084ZM15.4289 4.4436C16.3594 4.83735 17.2055 5.3811 17.9508 6.06548C17.5178 6.43413 17.0518 6.76208 16.5586 7.04517C16.1906 5.99048 15.7195 5.07407 15.1711 4.34048C15.2578 4.37329 15.3445 4.40845 15.4289 4.4436ZM13.3055 20.8639C13.0898 21.0327 12.8742 21.1616 12.6562 21.2483V16.9006C13.5862 16.9655 14.5008 17.1726 15.368 17.5147C15.1734 18.0913 14.9484 18.6233 14.6883 19.1038C14.2805 19.8631 13.8023 20.4702 13.3055 20.8639ZM14.6883 6.02563C14.9461 6.50845 15.1734 7.04048 15.368 7.6147C14.5008 7.95678 13.5862 8.16388 12.6562 8.22876V3.88345C12.8719 3.97017 13.0898 4.09673 13.3055 4.26782C13.8023 4.65923 14.2805 5.26626 14.6883 6.02563ZM12.6562 15.5858V13.2209H16.1133C16.0758 14.2569 15.9469 15.2624 15.7313 16.2163L15.7242 16.2444C14.7406 15.8714 13.7063 15.6494 12.6562 15.5858ZM12.6562 11.9084V9.5436C13.7297 9.47798 14.7609 9.25063 15.7242 8.88501L15.7313 8.91314C15.9469 9.86704 16.0758 10.8702 16.1133 11.9084H12.6562ZM11.3438 13.2209V15.5858C10.2703 15.6514 9.23906 15.8788 8.27578 16.2444L8.26875 16.2163C8.05312 15.2624 7.92422 14.2592 7.88672 13.2209H11.3438ZM7.88672 11.9084C7.92422 10.8725 8.05312 9.86704 8.26875 8.91314L8.27578 8.88501C9.23906 9.25063 10.268 9.47798 11.3438 9.5436V11.9084H7.88672ZM11.3438 16.9006V21.2459C11.1281 21.1592 10.9102 21.0327 10.6945 20.8616C10.1977 20.4702 9.71719 19.8608 9.30938 19.1014C9.05156 18.6186 8.82422 18.0866 8.62969 17.5124C9.50156 17.1702 10.4086 16.9663 11.3438 16.9006ZM11.3438 8.22876C10.4138 8.16388 9.49924 7.95678 8.63203 7.6147C8.82656 7.03813 9.05156 6.5061 9.31172 6.02563C9.71953 5.26626 10.1977 4.65688 10.6969 4.26548C10.9125 4.09673 11.1281 3.96782 11.3461 3.8811V8.22876H11.3438ZM8.57109 4.4436C8.65781 4.40845 8.74219 4.37329 8.82891 4.34048C8.28047 5.07407 7.80937 5.99048 7.44141 7.04517C6.94922 6.76392 6.48281 6.43579 6.04922 6.06548C6.79453 5.3811 7.64063 4.83735 8.57109 4.4436ZM3.87891 9.13579C4.20234 8.37173 4.62891 7.66392 5.14922 7.02173C5.73281 7.52563 6.37266 7.96626 7.05938 8.33188C6.7875 9.4311 6.61875 10.6381 6.57422 11.9084H3.21094C3.28125 10.9499 3.50625 10.0194 3.87891 9.13579ZM3.21094 13.2209H6.57422C6.61875 14.4913 6.7875 15.6983 7.05938 16.7975C6.37589 17.1618 5.73521 17.6012 5.14922 18.1077C4.01819 16.7155 3.34164 15.0098 3.21094 13.2209ZM8.57109 20.6858C7.64063 20.292 6.79453 19.7483 6.04922 19.0639C6.48281 18.6936 6.94922 18.3678 7.44141 18.0842C7.80937 19.1389 8.28047 20.0553 8.82891 20.7889C8.74219 20.7561 8.65547 20.7209 8.57109 20.6858ZM15.4289 20.6858C15.3422 20.7209 15.2578 20.7561 15.1711 20.7889C15.7195 20.0553 16.1906 19.1389 16.5586 18.0842C17.0508 18.3655 17.5172 18.6936 17.9508 19.0639C17.2096 19.7454 16.3565 20.2941 15.4289 20.6858Z"
      fill="#222222"
    />
  </svg>
);
const TwitchSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 16.5647V4.5647H19.5V13.5647L16.5 16.5647H12L9 19.5647V16.5647H6Z"
      fill="white"
    />
    <path
      d="M4.5 3.0647L3 6.6262V19.5647H7.5V22.0647H10L12.5 19.5647H16L21 14.5647V3.0647H4.5ZM19 13.5647L16.5 16.0647H12L9.5 18.5647V16.0647H6.5V5.0647H19V13.5647Z"
      fill="#8E24AA"
    />
    <path
      d="M16 13.0647H13.5V8.0647H16V13.0647ZM12 13.0647H9.5V8.0647H12V13.0647Z"
      fill="#8E24AA"
    />
  </svg>
);
const DiscordSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.98 5.73405C18.0693 4.19656 15.0468 3.93593 14.9175 3.92655C14.7168 3.90968 14.5256 4.02218 14.4431 4.20781C14.4356 4.21906 14.37 4.37093 14.2968 4.60718C15.5606 4.82093 17.1131 5.25031 18.5175 6.12218C18.7425 6.26093 18.8118 6.55718 18.6731 6.78218C18.5812 6.9303 18.4256 7.01093 18.2643 7.01093C18.1781 7.01093 18.09 6.98655 18.0112 6.9378C15.5962 5.43968 12.5812 5.36468 12 5.36468C11.4187 5.36468 8.40184 5.43968 5.98871 6.9378C5.76371 7.07843 5.46746 7.00905 5.32871 6.78405C5.18809 6.55718 5.25746 6.2628 5.48246 6.12218C6.88684 5.25218 8.43934 4.82093 9.70309 4.60906C9.62996 4.37093 9.56434 4.22093 9.55871 4.20781C9.47434 4.02218 9.28496 3.90593 9.08246 3.92655C8.95309 3.93593 5.93059 4.19656 3.99371 5.75468C2.98309 6.69031 0.959961 12.1578 0.959961 16.8847C0.959961 16.9691 0.982461 17.0497 1.02371 17.1228C2.41871 19.5753 6.22684 20.2166 7.09496 20.2447C7.09871 20.2447 7.10434 20.2447 7.10996 20.2447C7.26371 20.2447 7.40809 20.1716 7.49809 20.0478L8.37559 18.8403C6.00746 18.2291 4.79809 17.1903 4.72871 17.1284C4.52996 16.9541 4.51121 16.6503 4.68746 16.4516C4.86184 16.2528 5.16559 16.2341 5.36434 16.4084C5.39246 16.4347 7.61996 18.3247 12 18.3247C16.3875 18.3247 18.615 16.4272 18.6375 16.4084C18.8362 16.2359 19.1381 16.2528 19.3143 16.4534C19.4887 16.6522 19.47 16.9541 19.2712 17.1284C19.2018 17.1903 17.9925 18.2291 15.6243 18.8403L16.5018 20.0478C16.5918 20.1716 16.7362 20.2447 16.89 20.2447C16.8956 20.2447 16.9012 20.2447 16.905 20.2447C17.7731 20.2166 21.5812 19.5753 22.9762 17.1228C23.0175 17.0497 23.04 16.9691 23.04 16.8847C23.04 12.1578 21.0168 6.69031 19.98 5.73405ZM8.87996 14.9647C7.95184 14.9647 7.19996 14.1059 7.19996 13.0447C7.19996 11.9834 7.95184 11.1247 8.87996 11.1247C9.80809 11.1247 10.56 11.9834 10.56 13.0447C10.56 14.1059 9.80809 14.9647 8.87996 14.9647ZM15.12 14.9647C14.1918 14.9647 13.44 14.1059 13.44 13.0447C13.44 11.9834 14.1918 11.1247 15.12 11.1247C16.0481 11.1247 16.8 11.9834 16.8 13.0447C16.8 14.1059 16.0481 14.9647 15.12 14.9647Z"
      fill="#404EED"
    />
  </svg>
);
const TiktokSVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.6799 2.48474H4.31992C2.99656 2.48474 1.91992 3.56138 1.91992 4.88474V20.2447C1.91992 21.5681 2.99656 22.6447 4.31992 22.6447H19.6799C21.0033 22.6447 22.0799 21.5681 22.0799 20.2447V4.88474C22.0799 3.56138 21.0033 2.48474 19.6799 2.48474ZM17.7628 11.2798C17.6538 11.2899 17.5434 11.2966 17.4316 11.2966C16.1726 11.2966 15.0662 10.6491 14.4225 9.67034C14.4225 12.2379 14.4225 15.1591 14.4225 15.2081C14.4225 17.4684 12.5898 19.3011 10.3295 19.3011C8.0692 19.3011 6.23656 17.4684 6.23656 15.2081C6.23656 12.9478 8.0692 11.1151 10.3295 11.1151C10.415 11.1151 10.4985 11.1228 10.5825 11.1281V13.1451C10.4985 13.135 10.4159 13.1196 10.3295 13.1196C9.1756 13.1196 8.24056 14.0547 8.24056 15.2086C8.24056 16.3625 9.1756 17.2975 10.3295 17.2975C11.4834 17.2975 12.5025 16.3884 12.5025 15.2345C12.5025 15.1889 12.5226 5.82938 12.5226 5.82938H14.4503C14.6318 7.55306 16.0233 8.91338 17.7628 9.03818V11.2798Z"
      fill="black"
    />
  </svg>
);
const CoachliLoaderSVG = () => (
  <svg
    id="logo-svg"
    width="113"
    height="28"
    viewBox="0 0 113 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.336 26.3839C8.60805 26.3839 7.05071 25.9892 5.66405 25.1999C4.29871 24.3892 3.22138 23.3012 2.43205 21.9359C1.64271 20.5492 1.24805 18.9919 1.24805 17.2639C1.24805 15.5359 1.64271 13.9892 2.43205 12.6239C3.22138 11.2585 4.29871 10.1812 5.66405 9.39188C7.05071 8.60254 8.60805 8.20788 10.336 8.20788C11.5734 8.20788 12.7254 8.43188 13.792 8.87988C14.8587 9.30655 15.776 9.90388 16.544 10.6719C17.3334 11.4185 17.8987 12.3145 18.24 13.3599L14.56 14.9599C14.24 14.0852 13.696 13.3812 12.928 12.8479C12.1814 12.3145 11.3174 12.0479 10.336 12.0479C9.41871 12.0479 8.59738 12.2719 7.87205 12.7199C7.16805 13.1679 6.61338 13.7865 6.20805 14.5759C5.80271 15.3652 5.60005 16.2719 5.60005 17.2959C5.60005 18.3199 5.80271 19.2265 6.20805 20.0159C6.61338 20.8052 7.16805 21.4239 7.87205 21.8719C8.59738 22.3199 9.41871 22.5439 10.336 22.5439C11.3387 22.5439 12.2134 22.2772 12.96 21.7439C13.7067 21.2105 14.24 20.4959 14.56 19.5999L18.24 21.2639C17.8987 22.2452 17.344 23.1305 16.576 23.9199C15.808 24.6879 14.8907 25.2959 13.824 25.7439C12.7574 26.1705 11.5947 26.3839 10.336 26.3839Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    <path
      d="M29.9328 26.3839C28.2261 26.3839 26.6688 25.9892 25.2608 25.1999C23.8741 24.4105 22.7648 23.3332 21.9328 21.9679C21.1221 20.6025 20.7168 19.0452 20.7168 17.2959C20.7168 15.5465 21.1221 13.9892 21.9328 12.6239C22.7648 11.2585 23.8741 10.1812 25.2608 9.39188C26.6475 8.60254 28.2048 8.20788 29.9328 8.20788C31.6395 8.20788 33.1861 8.60254 34.5728 9.39188C35.9595 10.1812 37.0581 11.2585 37.8688 12.6239C38.7008 13.9679 39.1168 15.5252 39.1168 17.2959C39.1168 19.0452 38.7008 20.6025 37.8688 21.9679C37.0368 23.3332 35.9275 24.4105 34.5408 25.1999C33.1541 25.9892 31.6181 26.3839 29.9328 26.3839ZM29.9328 22.5439C30.8715 22.5439 31.6928 22.3199 32.3968 21.8719C33.1221 21.4239 33.6875 20.8052 34.0928 20.0159C34.5195 19.2052 34.7328 18.2985 34.7328 17.2959C34.7328 16.2719 34.5195 15.3759 34.0928 14.6079C33.6875 13.8185 33.1221 13.1999 32.3968 12.7519C31.6928 12.2825 30.8715 12.0479 29.9328 12.0479C28.9728 12.0479 28.1301 12.2825 27.4048 12.7519C26.6795 13.1999 26.1035 13.8185 25.6768 14.6079C25.2715 15.3759 25.0688 16.2719 25.0688 17.2959C25.0688 18.2985 25.2715 19.2052 25.6768 20.0159C26.1035 20.8052 26.6795 21.4239 27.4048 21.8719C28.1301 22.3199 28.9728 22.5439 29.9328 22.5439Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    <path
      d="M47.5758 26.3839C46.3598 26.3839 45.3038 26.1812 44.4078 25.7759C43.5118 25.3705 42.8185 24.7945 42.3278 24.0479C41.8371 23.2799 41.5918 22.3945 41.5918 21.3919C41.5918 20.4319 41.8051 19.5785 42.2318 18.8319C42.6585 18.0639 43.3198 17.4239 44.2158 16.9119C45.1118 16.3999 46.2425 16.0372 47.6078 15.8239L53.3038 14.8959V18.0959L48.4078 18.9279C47.5758 19.0772 46.9571 19.3439 46.5518 19.7279C46.1465 20.1119 45.9438 20.6132 45.9438 21.2319C45.9438 21.8292 46.1678 22.3092 46.6158 22.6719C47.0851 23.0132 47.6611 23.1839 48.3438 23.1839C49.2185 23.1839 49.9865 23.0025 50.6478 22.6399C51.3305 22.2559 51.8531 21.7332 52.2158 21.0719C52.5998 20.4105 52.7918 19.6852 52.7918 18.8959V14.4159C52.7918 13.6692 52.4931 13.0505 51.8958 12.5599C51.3198 12.0479 50.5518 11.7919 49.5918 11.7919C48.6958 11.7919 47.8958 12.0372 47.1918 12.5279C46.5091 12.9972 46.0078 13.6265 45.6878 14.4159L42.2638 12.7519C42.6051 11.8345 43.1385 11.0452 43.8638 10.3839C44.6105 9.70121 45.4851 9.16788 46.4878 8.78388C47.4905 8.39988 48.5785 8.20788 49.7518 8.20788C51.1811 8.20788 52.4398 8.47455 53.5278 9.00788C54.6158 9.51988 55.4585 10.2452 56.0558 11.1839C56.6745 12.1012 56.9838 13.1785 56.9838 14.4159V25.9999H53.0158V23.0239L53.9118 22.9599C53.4638 23.7065 52.9305 24.3359 52.3118 24.8479C51.6931 25.3385 50.9891 25.7225 50.1998 25.9999C49.4105 26.2559 48.5358 26.3839 47.5758 26.3839Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    <path
      d="M69.2423 26.3839C67.5143 26.3839 65.957 25.9892 64.5703 25.1999C63.205 24.3892 62.1276 23.3012 61.3383 21.9359C60.549 20.5492 60.1543 18.9919 60.1543 17.2639C60.1543 15.5359 60.549 13.9892 61.3383 12.6239C62.1276 11.2585 63.205 10.1812 64.5703 9.39188C65.957 8.60254 67.5143 8.20788 69.2423 8.20788C70.4796 8.20788 71.6316 8.43188 72.6983 8.87988C73.765 9.30655 74.6823 9.90388 75.4503 10.6719C76.2396 11.4185 76.805 12.3145 77.1463 13.3599L73.4663 14.9599C73.1463 14.0852 72.6023 13.3812 71.8343 12.8479C71.0876 12.3145 70.2236 12.0479 69.2423 12.0479C68.325 12.0479 67.5036 12.2719 66.7783 12.7199C66.0743 13.1679 65.5196 13.7865 65.1143 14.5759C64.709 15.3652 64.5063 16.2719 64.5063 17.2959C64.5063 18.3199 64.709 19.2265 65.1143 20.0159C65.5196 20.8052 66.0743 21.4239 66.7783 21.8719C67.5036 22.3199 68.325 22.5439 69.2423 22.5439C70.245 22.5439 71.1196 22.2772 71.8663 21.7439C72.613 21.2105 73.1463 20.4959 73.4663 19.5999L77.1463 21.2639C76.805 22.2452 76.2503 23.1305 75.4823 23.9199C74.7143 24.6879 73.797 25.2959 72.7303 25.7439C71.6636 26.1705 70.501 26.3839 69.2423 26.3839Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    <path
      d="M80.327 25.9999V1.77588H84.519V12.0159L83.943 11.4079C84.3484 10.3625 85.0097 9.57321 85.927 9.03988C86.8657 8.48521 87.9537 8.20788 89.191 8.20788C90.471 8.20788 91.6017 8.48521 92.583 9.03988C93.5857 9.59455 94.3644 10.3732 94.919 11.3759C95.4737 12.3572 95.751 13.4985 95.751 14.7999V25.9999H91.559V15.7919C91.559 15.0239 91.4097 14.3625 91.111 13.8079C90.8124 13.2532 90.3964 12.8265 89.863 12.5279C89.351 12.2079 88.743 12.0479 88.039 12.0479C87.3564 12.0479 86.7484 12.2079 86.215 12.5279C85.6817 12.8265 85.2657 13.2532 84.967 13.8079C84.6684 14.3625 84.519 15.0239 84.519 15.7919V25.9999H80.327Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    <path
      d="M99.2958 25.9999V1.77588H103.488V25.9999H99.2958Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    <path
      d="M107.358 25.9999V8.59188H111.55V25.9999H107.358ZM107.358 6.63988V2.15988H111.55V6.63988H107.358Z"
      stroke="#222222"
      strokeWidth="2"
      mask="url(#path-1-outside-1_3202_33496)"
      className="path-to-check"
    />
    {/* <mask
      id="path-1-outside-1_3202_33496"
      maskUnits="userSpaceOnUse"
      x="0.248047"
      y="0.775879"
      width="113"
      height="27"
      fill="black"
    >
      <rect fill="white" x="0.248047" y="0.775879" width="113" height="27" />
      <path d="M10.336 26.3839C8.60805 26.3839 7.05071 25.9892 5.66405 25.1999C4.29871 24.3892 3.22138 23.3012 2.43205 21.9359C1.64271 20.5492 1.24805 18.9919 1.24805 17.2639C1.24805 15.5359 1.64271 13.9892 2.43205 12.6239C3.22138 11.2585 4.29871 10.1812 5.66405 9.39188C7.05071 8.60254 8.60805 8.20788 10.336 8.20788C11.5734 8.20788 12.7254 8.43188 13.792 8.87988C14.8587 9.30655 15.776 9.90388 16.544 10.6719C17.3334 11.4185 17.8987 12.3145 18.24 13.3599L14.56 14.9599C14.24 14.0852 13.696 13.3812 12.928 12.8479C12.1814 12.3145 11.3174 12.0479 10.336 12.0479C9.41871 12.0479 8.59738 12.2719 7.87205 12.7199C7.16805 13.1679 6.61338 13.7865 6.20805 14.5759C5.80271 15.3652 5.60005 16.2719 5.60005 17.2959C5.60005 18.3199 5.80271 19.2265 6.20805 20.0159C6.61338 20.8052 7.16805 21.4239 7.87205 21.8719C8.59738 22.3199 9.41871 22.5439 10.336 22.5439C11.3387 22.5439 12.2134 22.2772 12.96 21.7439C13.7067 21.2105 14.24 20.4959 14.56 19.5999L18.24 21.2639C17.8987 22.2452 17.344 23.1305 16.576 23.9199C15.808 24.6879 14.8907 25.2959 13.824 25.7439C12.7574 26.1705 11.5947 26.3839 10.336 26.3839Z" />
      <path d="M29.9328 26.3839C28.2261 26.3839 26.6688 25.9892 25.2608 25.1999C23.8741 24.4105 22.7648 23.3332 21.9328 21.9679C21.1221 20.6025 20.7168 19.0452 20.7168 17.2959C20.7168 15.5465 21.1221 13.9892 21.9328 12.6239C22.7648 11.2585 23.8741 10.1812 25.2608 9.39188C26.6475 8.60254 28.2048 8.20788 29.9328 8.20788C31.6395 8.20788 33.1861 8.60254 34.5728 9.39188C35.9595 10.1812 37.0581 11.2585 37.8688 12.6239C38.7008 13.9679 39.1168 15.5252 39.1168 17.2959C39.1168 19.0452 38.7008 20.6025 37.8688 21.9679C37.0368 23.3332 35.9275 24.4105 34.5408 25.1999C33.1541 25.9892 31.6181 26.3839 29.9328 26.3839ZM29.9328 22.5439C30.8715 22.5439 31.6928 22.3199 32.3968 21.8719C33.1221 21.4239 33.6875 20.8052 34.0928 20.0159C34.5195 19.2052 34.7328 18.2985 34.7328 17.2959C34.7328 16.2719 34.5195 15.3759 34.0928 14.6079C33.6875 13.8185 33.1221 13.1999 32.3968 12.7519C31.6928 12.2825 30.8715 12.0479 29.9328 12.0479C28.9728 12.0479 28.1301 12.2825 27.4048 12.7519C26.6795 13.1999 26.1035 13.8185 25.6768 14.6079C25.2715 15.3759 25.0688 16.2719 25.0688 17.2959C25.0688 18.2985 25.2715 19.2052 25.6768 20.0159C26.1035 20.8052 26.6795 21.4239 27.4048 21.8719C28.1301 22.3199 28.9728 22.5439 29.9328 22.5439Z" />
      <path d="M47.5758 26.3839C46.3598 26.3839 45.3038 26.1812 44.4078 25.7759C43.5118 25.3705 42.8185 24.7945 42.3278 24.0479C41.8371 23.2799 41.5918 22.3945 41.5918 21.3919C41.5918 20.4319 41.8051 19.5785 42.2318 18.8319C42.6585 18.0639 43.3198 17.4239 44.2158 16.9119C45.1118 16.3999 46.2425 16.0372 47.6078 15.8239L53.3038 14.8959V18.0959L48.4078 18.9279C47.5758 19.0772 46.9571 19.3439 46.5518 19.7279C46.1465 20.1119 45.9438 20.6132 45.9438 21.2319C45.9438 21.8292 46.1678 22.3092 46.6158 22.6719C47.0851 23.0132 47.6611 23.1839 48.3438 23.1839C49.2185 23.1839 49.9865 23.0025 50.6478 22.6399C51.3305 22.2559 51.8531 21.7332 52.2158 21.0719C52.5998 20.4105 52.7918 19.6852 52.7918 18.8959V14.4159C52.7918 13.6692 52.4931 13.0505 51.8958 12.5599C51.3198 12.0479 50.5518 11.7919 49.5918 11.7919C48.6958 11.7919 47.8958 12.0372 47.1918 12.5279C46.5091 12.9972 46.0078 13.6265 45.6878 14.4159L42.2638 12.7519C42.6051 11.8345 43.1385 11.0452 43.8638 10.3839C44.6105 9.70121 45.4851 9.16788 46.4878 8.78388C47.4905 8.39988 48.5785 8.20788 49.7518 8.20788C51.1811 8.20788 52.4398 8.47455 53.5278 9.00788C54.6158 9.51988 55.4585 10.2452 56.0558 11.1839C56.6745 12.1012 56.9838 13.1785 56.9838 14.4159V25.9999H53.0158V23.0239L53.9118 22.9599C53.4638 23.7065 52.9305 24.3359 52.3118 24.8479C51.6931 25.3385 50.9891 25.7225 50.1998 25.9999C49.4105 26.2559 48.5358 26.3839 47.5758 26.3839Z" />
      <path d="M69.2423 26.3839C67.5143 26.3839 65.957 25.9892 64.5703 25.1999C63.205 24.3892 62.1276 23.3012 61.3383 21.9359C60.549 20.5492 60.1543 18.9919 60.1543 17.2639C60.1543 15.5359 60.549 13.9892 61.3383 12.6239C62.1276 11.2585 63.205 10.1812 64.5703 9.39188C65.957 8.60254 67.5143 8.20788 69.2423 8.20788C70.4796 8.20788 71.6316 8.43188 72.6983 8.87988C73.765 9.30655 74.6823 9.90388 75.4503 10.6719C76.2396 11.4185 76.805 12.3145 77.1463 13.3599L73.4663 14.9599C73.1463 14.0852 72.6023 13.3812 71.8343 12.8479C71.0876 12.3145 70.2236 12.0479 69.2423 12.0479C68.325 12.0479 67.5036 12.2719 66.7783 12.7199C66.0743 13.1679 65.5196 13.7865 65.1143 14.5759C64.709 15.3652 64.5063 16.2719 64.5063 17.2959C64.5063 18.3199 64.709 19.2265 65.1143 20.0159C65.5196 20.8052 66.0743 21.4239 66.7783 21.8719C67.5036 22.3199 68.325 22.5439 69.2423 22.5439C70.245 22.5439 71.1196 22.2772 71.8663 21.7439C72.613 21.2105 73.1463 20.4959 73.4663 19.5999L77.1463 21.2639C76.805 22.2452 76.2503 23.1305 75.4823 23.9199C74.7143 24.6879 73.797 25.2959 72.7303 25.7439C71.6636 26.1705 70.501 26.3839 69.2423 26.3839Z" />
      <path d="M80.327 25.9999V1.77588H84.519V12.0159L83.943 11.4079C84.3484 10.3625 85.0097 9.57321 85.927 9.03988C86.8657 8.48521 87.9537 8.20788 89.191 8.20788C90.471 8.20788 91.6017 8.48521 92.583 9.03988C93.5857 9.59455 94.3644 10.3732 94.919 11.3759C95.4737 12.3572 95.751 13.4985 95.751 14.7999V25.9999H91.559V15.7919C91.559 15.0239 91.4097 14.3625 91.111 13.8079C90.8124 13.2532 90.3964 12.8265 89.863 12.5279C89.351 12.2079 88.743 12.0479 88.039 12.0479C87.3564 12.0479 86.7484 12.2079 86.215 12.5279C85.6817 12.8265 85.2657 13.2532 84.967 13.8079C84.6684 14.3625 84.519 15.0239 84.519 15.7919V25.9999H80.327Z" />
      <path d="M99.2958 25.9999V1.77588H103.488V25.9999H99.2958Z" />
      <path d="M107.358 25.9999V8.59188H111.55V25.9999H107.358ZM107.358 6.63988V2.15988H111.55V6.63988H107.358Z" />
    </mask> */}
  </svg>
);

const SVG2 = () => (
  <svg id="svg-2" viewBox="0 0 1320 300">
    <text x="50%" y="50%" dy=".35em" textAnchor="middle">
      Coachli
    </text>
  </svg>
);

const HeartSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
      />
    </svg>
  );
};
const BookSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
      />
    </svg>
  );
};
export const DesktopSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"
      />
    </svg>
  );
};
export const SmileSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"
      />
    </svg>
  );
};
export const CameraSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"
      />
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"
      />
    </svg>
  );
};
export const UserGroupSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
      />
    </svg>
  );
};
export const CalendarSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z"
      />
    </svg>
  );
};
export const MicrophoneSVG: React.FC<{style: React.CSSProperties}> = ({style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      width="1em"
      height="1em"
      style={style}
    >
      <motion.path
        initial={{pathLength: 0}}
        animate={{pathLength: 1}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
      />
    </svg>
  );
};

const RecordSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z" />
    <path d="M12 1.5C6.20102 1.5 1.5 6.20102 1.5 12C1.5 17.799 6.20102 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20102 17.799 1.5 12 1.5ZM3 12C3 7.02944 7.02944 3 12 3C16.9705 3 21 7.02944 21 12C21 16.9705 16.9705 21 12 21C7.02944 21 3 16.9705 3 12Z" />
  </svg>
);

const CopySVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 12V13H5.667C5.299 13 5 12.701 5 12.333V5.667C5 5.299 5.299 5 5.667 5H12.333C12.701 5 13 5.299 13 5.667V9H12C10.346 9 9 10.346 9 12ZM18 9H15V5.667C15 4.196 13.804 3 12.333 3H5.667C4.196 3 3 4.196 3 5.667V12.333C3 13.804 4.196 15 5.667 15H9V18C9 19.654 10.346 21 12 21H18C19.654 21 21 19.654 21 18V12C21 10.346 19.654 9 18 9Z"
      fill="#231F20"
    />
    <mask
      id="mask0_4486_4996"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 12V13H5.667C5.299 13 5 12.701 5 12.333V5.667C5 5.299 5.299 5 5.667 5H12.333C12.701 5 13 5.299 13 5.667V9H12C10.346 9 9 10.346 9 12ZM18 9H15V5.667C15 4.196 13.804 3 12.333 3H5.667C4.196 3 3 4.196 3 5.667V12.333C3 13.804 4.196 15 5.667 15H9V18C9 19.654 10.346 21 12 21H18C19.654 21 21 19.654 21 18V12C21 10.346 19.654 9 18 9Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4486_4996)">
      <rect width="24" height="24" fill="#9254DE" />
    </g>
  </svg>
);
const CopySVGSm = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 6.50391V7.00391H2.8335C2.6495 7.00391 2.5 6.85441 2.5 6.67041V3.33741C2.5 3.15341 2.6495 3.00391 2.8335 3.00391H6.1665C6.3505 3.00391 6.5 3.15341 6.5 3.33741V5.00391H6C5.173 5.00391 4.5 5.67691 4.5 6.50391ZM9 5.00391H7.5V3.33741C7.5 2.60191 6.902 2.00391 6.1665 2.00391H2.8335C2.098 2.00391 1.5 2.60191 1.5 3.33741V6.67041C1.5 7.40591 2.098 8.00391 2.8335 8.00391H4.5V9.50391C4.5 10.3309 5.173 11.0039 6 11.0039H9C9.827 11.0039 10.5 10.3309 10.5 9.50391V6.50391C10.5 5.67691 9.827 5.00391 9 5.00391Z"
      fill="#231F20"
    />
    <mask
      id="mask0_9110_18873"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="10"
      height="10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6.50391V7.00391H2.8335C2.6495 7.00391 2.5 6.85441 2.5 6.67041V3.33741C2.5 3.15341 2.6495 3.00391 2.8335 3.00391H6.1665C6.3505 3.00391 6.5 3.15341 6.5 3.33741V5.00391H6C5.173 5.00391 4.5 5.67691 4.5 6.50391ZM9 5.00391H7.5V3.33741C7.5 2.60191 6.902 2.00391 6.1665 2.00391H2.8335C2.098 2.00391 1.5 2.60191 1.5 3.33741V6.67041C1.5 7.40591 2.098 8.00391 2.8335 8.00391H4.5V9.50391C4.5 10.3309 5.173 11.0039 6 11.0039H9C9.827 11.0039 10.5 10.3309 10.5 9.50391V6.50391C10.5 5.67691 9.827 5.00391 9 5.00391Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9110_18873)">
      <rect y="0.503906" width="12" height="12" fill="#9254DE" />
    </g>
  </svg>
);
const FlutterwaveSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
  >
    <g clipPath="url(#clip0_8445_36802)">
      <path
        d="M0 2.15992C0 1.51744 0.184091 0.970644 0.579545 0.581055L1.26136 1.26455C0.504545 2.02322 1.16591 4.38126 3.32727 6.54793C5.48864 8.71459 7.84091 9.37758 8.59773 8.61891L9.27955 9.3024C7.99773 10.5874 5.08636 9.67148 2.64545 7.23142C0.954545 5.52953 0 3.60892 0 2.15992Z"
        fill="#009A46"
      />
      <path
        d="M4.30205 9.8902C3.66114 9.8902 3.11569 9.70566 2.72705 9.30923L3.40887 8.62574C4.16569 9.38442 6.51796 8.72143 8.67932 6.55476C10.8407 4.3881 11.5021 2.03006 10.7452 1.27138L11.4271 0.587891C12.7089 1.87285 11.7952 4.79136 9.36114 7.23826C7.66341 8.93331 5.74069 9.8902 4.30205 9.8902Z"
        fill="#FF5805"
      />
      <path
        d="M9.57978 6.26027C9.16387 5.06416 8.31842 3.78603 7.20024 2.66511C4.75933 0.218213 1.84796 -0.69083 0.566145 0.587298C0.477508 0.682987 0.559326 0.908538 0.743417 1.09308C0.927508 1.27762 1.15933 1.35964 1.24796 1.27079C2.00478 0.512114 4.35705 1.1751 6.51842 3.34177C7.54114 4.367 8.30478 5.51527 8.67296 6.57468C8.99342 7.50422 8.96614 8.25606 8.59114 8.63198C8.50251 8.72084 8.57751 8.94639 8.76842 9.13777C8.95933 9.32914 9.18433 9.40433 9.27296 9.31547C9.92751 8.65249 10.0366 7.56574 9.57978 6.26027Z"
        fill="#F5AFCB"
      />
      <path
        d="M11.4203 0.587616C10.7658 -0.068535 9.68169 -0.177894 8.37942 0.27321C7.18624 0.69014 5.91124 1.53767 4.79306 2.65859C2.35215 5.10549 1.44533 8.024 2.72715 9.30896C2.81578 9.39781 3.0476 9.32263 3.23169 9.13125C3.41578 8.93987 3.4976 8.71432 3.40897 8.62547C2.65215 7.86679 3.31351 5.50875 5.47487 3.34208C6.4976 2.31685 7.64306 1.55134 8.69306 1.18225C9.62033 0.861012 10.3703 0.888352 10.7453 1.26427C10.834 1.35313 11.059 1.27794 11.2499 1.08656C11.4408 0.895187 11.5158 0.683305 11.4203 0.587616Z"
        fill="#FF9B00"
      />
    </g>
    <defs>
      <clipPath id="clip0_8445_36802">
        <rect width="12" height="9.89011" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const PayPalSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9.49304 3.45534C9.51979 2.06409 8.37179 0.996094 6.79329 0.996094H3.52879C3.45269 0.996118 3.3791 1.0233 3.32126 1.07275C3.26342 1.1222 3.22513 1.19068 3.21329 1.26584L1.90504 9.43984C1.89918 9.47688 1.90143 9.51475 1.91161 9.55083C1.9218 9.58692 1.93968 9.62037 1.96404 9.64888C1.98839 9.6774 2.01864 9.70029 2.05269 9.71599C2.08674 9.7317 2.12379 9.73983 2.16129 9.73984H4.09554L3.79304 11.6328C3.78718 11.6699 3.78943 11.7078 3.79963 11.7439C3.80983 11.78 3.82774 11.8135 3.85212 11.842C3.8765 11.8705 3.90678 11.8934 3.94086 11.9091C3.97494 11.9248 4.01202 11.9329 4.04954 11.9328H5.62504C5.70129 11.9328 5.76904 11.9053 5.82679 11.8561C5.88454 11.8066 5.89404 11.7383 5.90579 11.6631L6.36829 8.94184C6.38004 8.86684 6.41829 8.76934 6.47629 8.71984C6.53404 8.67034 6.58454 8.64334 6.66054 8.64309H7.62504C9.17079 8.64309 10.4825 7.54459 10.7223 6.01634C10.8918 4.93134 10.4265 3.94459 9.49304 3.45534Z"
      fill="#001C64"
    />
    <path
      d="M4.51399 6.72508L4.03224 9.78008L3.72974 11.6961C3.72389 11.7331 3.72614 11.771 3.73634 11.8071C3.74654 11.8432 3.76445 11.8767 3.78883 11.9052C3.81321 11.9337 3.84348 11.9566 3.87756 11.9723C3.91165 11.988 3.94872 11.9961 3.98624 11.9961H5.65374C5.7298 11.996 5.80332 11.9688 5.86111 11.9193C5.9189 11.8699 5.95715 11.8015 5.96899 11.7263L6.40849 8.94133C6.42034 8.86623 6.4586 8.79782 6.51639 8.74841C6.57419 8.69901 6.64771 8.67185 6.72374 8.67183H7.70549C9.25124 8.67183 10.5627 7.54433 10.8025 6.01608C10.9725 4.93133 10.4265 3.94458 9.49299 3.45508C9.49049 3.57058 9.48049 3.68583 9.46274 3.80008C9.22299 5.32808 7.91124 6.45583 6.36549 6.45583H4.82924C4.75325 6.45584 4.67975 6.48296 4.62197 6.53232C4.56418 6.58167 4.52589 6.65002 4.51399 6.72508Z"
      fill="#0070E0"
    />
    <path
      d="M4.03199 9.78004H2.09199C2.05448 9.78007 2.01741 9.77196 1.98334 9.75627C1.94927 9.74059 1.91901 9.71769 1.89464 9.68917C1.87028 9.66065 1.8524 9.62718 1.84223 9.59107C1.83206 9.55497 1.82985 9.51708 1.83574 9.48004L3.14374 1.18454C3.1556 1.10939 3.1939 1.04095 3.25174 0.991544C3.30958 0.942134 3.38317 0.915003 3.45924 0.915039H6.79349C8.37174 0.915039 9.51974 2.06379 9.49299 3.45504C9.10024 3.24904 8.63874 3.13129 8.13299 3.13129H5.35324C5.27723 3.13136 5.20373 3.15854 5.14595 3.20793C5.08816 3.25733 5.04989 3.32571 5.03799 3.40079L4.51424 6.72504L4.03199 9.78004Z"
      fill="#003087"
    />
  </svg>
);
const ProductBagSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path d="M12.0184 7.96631H29.9999V29.9773H12.0184V7.96631Z" fill="#F06292" />
    <path d="M17.0283 7.96631H20.0298V29.9773H17.0283V7.96631Z" fill="#F48FB1" />
    <path d="M22.0208 7.96631H25.0223V29.9773H22.0208V7.96631Z" fill="#F48FB1" />
    <path d="M26.9957 7.96631H29.9972V29.9773H26.9957V7.96631Z" fill="#F48FB1" />
    <path d="M12.0184 7.96631H15.0199V29.9773H12.0184V7.96631Z" fill="#F48FB1" />
    <path
      opacity="0.2"
      d="M29.247 8.71668V29.2269H12.7688V8.71668H29.247ZM29.9974 7.96631H12.0184V29.9773H29.9999V7.96631H29.9974Z"
      fill="#424242"
    />
    <path
      d="M26.7759 11.4258C27.3285 11.4258 27.7764 10.9779 27.7764 10.4253C27.7764 9.87274 27.3285 9.4248 26.7759 9.4248C26.2233 9.4248 25.7754 9.87274 25.7754 10.4253C25.7754 10.9779 26.2233 11.4258 26.7759 11.4258Z"
      fill="#AD1457"
    />
    <path
      d="M15.2703 11.4258C15.8228 11.4258 16.2708 10.9779 16.2708 10.4253C16.2708 9.87274 15.8228 9.4248 15.2703 9.4248C14.7177 9.4248 14.2698 9.87274 14.2698 10.4253C14.2698 10.9779 14.7177 11.4258 15.2703 11.4258Z"
      fill="#AD1457"
    />
    <path
      d="M27.5264 6.49538C27.5264 2.90358 24.6149 -0.00537109 21.0257 -0.00537109C17.4339 -0.00537109 14.5249 2.90608 14.5249 6.49538V10.2373C14.5249 10.6525 14.8601 10.9876 15.2753 10.9876C15.6905 10.9876 16.0257 10.6525 16.0257 10.2373V9.48687H16.0232V6.61794C16.0232 3.90909 18.1242 1.60043 20.8306 1.49788C23.6745 1.39033 26.0232 3.67397 26.0232 6.49538V9.48687H26.0056V10.2272C26.0056 10.6475 26.3458 10.9876 26.766 10.9876C27.1862 10.9876 27.5264 10.6475 27.5264 10.2272V6.49538Z"
      fill="url(#paint0_linear_8273_7969)"
    />
    <path
      opacity="0.2"
      d="M21.0257 0.244754C24.4724 0.244754 27.2763 3.04866 27.2763 6.49538V10.2272C27.2763 10.5074 27.0487 10.7375 26.766 10.7375C26.4834 10.7375 26.2558 10.5099 26.2558 10.2272V9.57942C26.2683 9.54941 26.2733 9.51939 26.2733 9.48687V6.49538C26.2733 3.59893 23.9171 1.24525 21.0232 1.24525C20.9556 1.24525 20.8881 1.24776 20.8205 1.25026C18.0392 1.35531 15.7755 3.76401 15.7755 6.61794V9.48687C15.7755 9.49688 15.7755 9.50688 15.778 9.51689V10.2347C15.778 10.5099 15.5529 10.735 15.2778 10.735C15.0026 10.735 14.7775 10.5099 14.7775 10.2347V6.49538C14.775 3.04866 17.5789 0.244754 21.0257 0.244754ZM21.0257 -0.00537109C17.4339 -0.00537109 14.5249 2.90608 14.5249 6.49538V10.2373C14.5249 10.6525 14.8601 10.9876 15.2753 10.9876C15.6905 10.9876 16.0257 10.6525 16.0257 10.2373V9.48687H16.0232V6.61794C16.0232 3.90909 18.1242 1.60043 20.8306 1.49788C20.8956 1.49538 20.9606 1.49538 21.0232 1.49538C23.782 1.49538 26.0232 3.739 26.0232 6.49538V9.48687H26.0056V10.2272C26.0056 10.6475 26.3458 10.9876 26.766 10.9876C27.1862 10.9876 27.5264 10.6475 27.5264 10.2272V6.49538C27.5264 2.90608 24.6174 -0.00537109 21.0257 -0.00537109Z"
      fill="#424242"
    />
    <path
      opacity="0.4"
      d="M25.1375 29.9772H17.8839V16.9082L25.1375 29.9772Z"
      fill="url(#paint1_linear_8273_7969)"
    />
    <path d="M0 16.9985H18.009V30.005H0V16.9985Z" fill="#C5E1A5" />
    <path d="M18.009 19.0234V22.0249H3.05176e-05V19.0234H18.009Z" fill="#AED581" />
    <path d="M18.009 25.0264V28.0279H2.67029e-05V25.0264H18.009Z" fill="#AED581" />
    <path
      d="M14.0195 20.1797C14.5721 20.1797 15.02 19.7318 15.02 19.1792C15.02 18.6267 14.5721 18.1787 14.0195 18.1787C13.467 18.1787 13.019 18.6267 13.019 19.1792C13.019 19.7318 13.467 20.1797 14.0195 20.1797Z"
      fill="#7CB342"
    />
    <path
      d="M4.01442 20.1797C4.56698 20.1797 5.01492 19.7318 5.01492 19.1792C5.01492 18.6267 4.56698 18.1787 4.01442 18.1787C3.46186 18.1787 3.01392 18.6267 3.01392 19.1792C3.01392 19.7318 3.46186 20.1797 4.01442 20.1797Z"
      fill="#7CB342"
    />
    <path
      d="M3.24652 20.2498C3.24652 23.4314 5.8053 26.0101 8.95938 26.0101C12.1135 26.0101 14.6722 23.4314 14.6722 20.2498V19.1517C14.6722 18.784 14.3771 18.4864 14.0119 18.4864C13.6467 18.4864 13.3516 18.784 13.3516 19.1517V19.8146H13.3541V20.1397C13.3541 22.5384 11.5082 24.5844 9.12946 24.677C6.62821 24.772 4.56468 22.7485 4.56468 20.2498V19.8146H4.57969V19.1567C4.57969 18.784 4.28204 18.4839 3.91185 18.4839C3.54417 18.4839 3.24402 18.784 3.24402 19.1567V20.2498H3.24652Z"
      fill="#F06292"
    />
    <path
      opacity="0.2"
      d="M14.0119 18.7365C14.237 18.7365 14.4221 18.9241 14.4221 19.1517V20.2498C14.4221 23.2888 11.9709 25.76 8.95938 25.76C5.94787 25.76 3.49664 23.2888 3.49664 20.2498V19.1592C3.49664 18.9266 3.68424 18.7365 3.91435 18.7365C4.14447 18.7365 4.33206 18.9266 4.33206 19.1592V19.727C4.32206 19.7545 4.31706 19.7845 4.31706 19.8146V20.2498C4.31706 22.8311 6.4006 24.9296 8.96188 24.9296C9.02191 24.9296 9.08194 24.9296 9.14197 24.9271C11.6032 24.8321 13.6067 22.686 13.6067 20.1422V19.8171C13.6067 19.807 13.6067 19.797 13.6042 19.787V19.1517C13.6017 18.9241 13.7843 18.7365 14.0119 18.7365ZM14.0119 18.4864C13.6467 18.4864 13.3516 18.784 13.3516 19.1517V19.8146H13.3541V20.1397C13.3541 22.5384 11.5082 24.5844 9.12946 24.677C9.07193 24.6795 9.0169 24.6795 8.95938 24.6795C6.53566 24.6795 4.56468 22.691 4.56468 20.2498V19.8146H4.57969V19.1567C4.57969 18.784 4.28204 18.4839 3.91185 18.4839C3.54417 18.4839 3.24402 18.784 3.24402 19.1567V20.2473C3.24402 23.4289 5.8028 26.0076 8.95688 26.0076C12.111 26.0076 14.6697 23.4289 14.6697 20.2473V19.1492C14.6722 18.784 14.3771 18.4864 14.0119 18.4864Z"
      fill="#424242"
    />
    <path
      opacity="0.2"
      d="M17.2586 17.7489V29.2547H0.750375V17.7489H17.2586ZM18.009 16.9985H0V30.005H18.009V16.9985Z"
      fill="#424242"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8273_7969"
        x1="21.0259"
        y1="0.462363"
        x2="21.0259"
        y2="11.0194"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.4739" stopColor="#AED581" />
        <stop offset="1" stopColor="#8BC34A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8273_7969"
        x1="17.4244"
        y1="23.4427"
        x2="24.2621"
        y2="23.4427"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.3169" stopColor="#E91E63" />
        <stop offset="0.8143" stopColor="#F06292" stop-opacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);
const MailIconSVGSm = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.50317 3.50391L6.25067 5.73791C6.09717 5.82541 5.90917 5.82541 5.75567 5.73791L2.50317 3.50391H9.50317ZM9.50317 2.50391H2.50317C1.67617 2.50391 1.00317 3.17691 1.00317 4.00391V9.00391C1.00317 9.83091 1.67617 10.5039 2.50317 10.5039H9.50317C10.3302 10.5039 11.0032 9.83091 11.0032 9.00391V4.00391C11.0032 3.17691 10.3302 2.50391 9.50317 2.50391Z"
      fill="#231F20"
    />
    <mask
      id="mask0_9110_18882"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="11"
      height="9"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50317 3.50391L6.25067 5.73791C6.09717 5.82541 5.90917 5.82541 5.75567 5.73791L2.50317 3.50391H9.50317ZM9.50317 2.50391H2.50317C1.67617 2.50391 1.00317 3.17691 1.00317 4.00391V9.00391C1.00317 9.83091 1.67617 10.5039 2.50317 10.5039H9.50317C10.3302 10.5039 11.0032 9.83091 11.0032 9.00391V4.00391C11.0032 3.17691 10.3302 2.50391 9.50317 2.50391Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9110_18882)">
      <rect y="0.503906" width="12" height="12" fill="#DB4437" />
    </g>
  </svg>
);
const VideoCameraSvg = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33333 9.33301H0.943333C0.421667 9.33301 0 8.91134 0 8.38967V2.27634C0 1.75467 0.421667 1.33301 0.943333 1.33301H1.33333V9.33301Z"
      fill="url(#paint0_linear_8031_6930)"
    />
    <path
      d="M19.5183 4.86966L18.6667 4.24966V1.33799L19.5183 0.717995C19.74 0.556328 20 0.791328 20 1.15299V4.43633C20 4.79633 19.74 5.03133 19.5183 4.86966Z"
      fill="url(#paint1_linear_8031_6930)"
    />
    <path
      d="M16 1.33887H18.6667V4.2522H16V1.33887Z"
      fill="url(#paint2_radial_8031_6930)"
    />
    <path
      d="M1.33334 1.33301H4.66667V9.33301H1.33334V1.33301Z"
      fill="url(#paint3_radial_8031_6930)"
    />
    <path
      opacity="0.2"
      d="M4.16667 1.83301V8.83301H1.33333H0.943333C0.698333 8.83301 0.5 8.63467 0.5 8.38967V2.27634C0.5 2.03134 0.698333 1.83301 0.943333 1.83301H1.33333H4.16667ZM4.66667 1.33301H1.33333H0.943333C0.421667 1.33301 0 1.75467 0 2.27634V8.39134C0 8.91134 0.421667 9.33301 0.943333 9.33301H1.33333H4.66667V1.33301Z"
      fill="#424242"
    />
    <path
      opacity="0.2"
      d="M19.5 1.34935V4.23768L18.9617 3.84602L18.83 3.75102H16.5V1.83768H18.83L18.9617 1.74268L19.5 1.34935ZM19.6667 0.666016C19.6167 0.666016 19.5667 0.682683 19.5183 0.717683L18.6667 1.33768H16V4.24935H18.6667L19.5183 4.86935C19.5667 4.90435 19.6183 4.92102 19.6667 4.92102C19.8417 4.92102 20 4.71602 20 4.43435V1.15102C20 0.871016 19.8417 0.666016 19.6667 0.666016Z"
      fill="#424242"
    />
    <path
      d="M16.6667 16H4.00001C3.26334 16 2.66667 15.4033 2.66667 14.6667V1.33333C2.66667 0.596667 3.26334 0 4.00001 0H16.6667C17.4033 0 18 0.596667 18 1.33333V14.6667C18 15.4033 17.4033 16 16.6667 16Z"
      fill="url(#paint4_radial_8031_6930)"
    />
    <path
      opacity="0.2"
      d="M16.6667 0.5C17.1267 0.5 17.5 0.873333 17.5 1.33333V14.6667C17.5 15.1267 17.1267 15.5 16.6667 15.5H4.00001C3.54001 15.5 3.16667 15.1267 3.16667 14.6667V1.33333C3.16667 0.873333 3.54001 0.5 4.00001 0.5H16.6667ZM16.6667 0H4.00001C3.26334 0 2.66667 0.596667 2.66667 1.33333V14.6667C2.66667 15.4033 3.26334 16 4.00001 16H16.6667C17.4033 16 18 15.4033 18 14.6667V1.33333C18 0.596667 17.4033 0 16.6667 0Z"
      fill="#424242"
    />
    <g opacity="0.2">
      <path
        d="M10 4.00065C10.3684 4.00065 10.6667 4.29898 10.6667 4.66732C10.6667 5.03565 10.3684 5.33398 10 5.33398C9.63171 5.33398 9.33338 5.03565 9.33338 4.66732C9.33338 4.29898 9.63171 4.00065 10 4.00065ZM10 3.83398C9.54004 3.83398 9.16671 4.20732 9.16671 4.66732C9.16671 5.12732 9.54004 5.50065 10 5.50065C10.46 5.50065 10.8334 5.12732 10.8334 4.66732C10.8334 4.20732 10.46 3.83398 10 3.83398Z"
        fill="#1565C0"
      />
      <path
        d="M12 4.00065C12.3684 4.00065 12.6667 4.29898 12.6667 4.66732C12.6667 5.03565 12.3684 5.33398 12 5.33398C11.6317 5.33398 11.3334 5.03565 11.3334 4.66732C11.3334 4.29898 11.6317 4.00065 12 4.00065ZM12 3.83398C11.54 3.83398 11.1667 4.20732 11.1667 4.66732C11.1667 5.12732 11.54 5.50065 12 5.50065C12.46 5.50065 12.8334 5.12732 12.8334 4.66732C12.8334 4.20732 12.46 3.83398 12 3.83398Z"
        fill="#1565C0"
      />
      <path
        d="M15.3334 4.00065C15.7 4.00065 16 4.30065 16 4.66732C16 5.03398 15.7 5.33398 15.3334 5.33398H14C13.6334 5.33398 13.3334 5.03398 13.3334 4.66732C13.3334 4.30065 13.6334 4.00065 14 4.00065H15.3334ZM15.3334 3.83398H14C13.54 3.83398 13.1667 4.20732 13.1667 4.66732C13.1667 5.12732 13.54 5.50065 14 5.50065H15.3334C15.7934 5.50065 16.1667 5.12732 16.1667 4.66732C16.1667 4.20732 15.7934 3.83398 15.3334 3.83398Z"
        fill="#1565C0"
      />
    </g>
    <path
      opacity="0.2"
      d="M15.3333 6.5H6.66667C6.20667 6.5 5.83334 6.87333 5.83334 7.33333V7.81667C5.78334 7.785 5.72334 7.76667 5.66001 7.76667H5.32667C5.14334 7.76667 4.99334 7.91667 4.99334 8.1V11.7667C4.99334 11.95 5.14334 12.1 5.32667 12.1H5.66001C5.72334 12.1 5.78334 12.0817 5.83334 12.05V12.6667C5.83334 13.1267 6.20667 13.5 6.66667 13.5H15.3333C15.7933 13.5 16.1667 13.1267 16.1667 12.6667V7.33333C16.1667 6.87333 15.7933 6.5 15.3333 6.5ZM5.82667 11.7667C5.82667 11.8583 5.75167 11.9333 5.66001 11.9333H5.32667C5.23501 11.9333 5.16001 11.8583 5.16001 11.7667V8.1C5.16001 8.00833 5.23501 7.93333 5.32667 7.93333H5.66001C5.75167 7.93333 5.82667 8.00833 5.82667 8.1V11.7667ZM16 12.6667C16 13.035 15.7017 13.3333 15.3333 13.3333H6.66667C6.29834 13.3333 6.00001 13.035 6.00001 12.6667V7.33333C6.00001 6.965 6.29834 6.66667 6.66667 6.66667H15.3333C15.7017 6.66667 16 6.965 16 7.33333V12.6667Z"
      fill="#1565C0"
    />
    <path
      d="M15.3333 13.3337H6.66666C6.29833 13.3337 6 13.0353 6 12.667V7.33366C6 6.96533 6.29833 6.66699 6.66666 6.66699H15.3333C15.7017 6.66699 16 6.96533 16 7.33366V12.667C16 13.0353 15.7017 13.3337 15.3333 13.3337Z"
      fill="url(#paint5_radial_8031_6930)"
    />
    <path
      d="M14.6667 12.6663H7.33334C6.965 12.6663 6.66667 12.368 6.66667 11.9997V7.99967C6.66667 7.63134 6.965 7.33301 7.33334 7.33301H14.6667C15.035 7.33301 15.3333 7.63134 15.3333 7.99967V11.9997C15.3333 12.368 15.035 12.6663 14.6667 12.6663Z"
      fill="url(#paint6_radial_8031_6930)"
    />
    <path
      d="M5.66 11.9336H5.32667C5.235 11.9336 5.16 11.8586 5.16 11.7669V8.10026C5.16 8.00859 5.235 7.93359 5.32667 7.93359H5.66C5.75167 7.93359 5.82667 8.00859 5.82667 8.10026V11.7669C5.82667 11.8586 5.75167 11.9336 5.66 11.9336Z"
      fill="url(#paint7_linear_8031_6930)"
    />
    <path
      d="M10 5.33333C10.3682 5.33333 10.6667 5.03486 10.6667 4.66667C10.6667 4.29848 10.3682 4 10 4C9.63181 4 9.33333 4.29848 9.33333 4.66667C9.33333 5.03486 9.63181 5.33333 10 5.33333Z"
      fill="url(#paint8_linear_8031_6930)"
    />
    <path
      d="M12 5.33333C12.3682 5.33333 12.6667 5.03486 12.6667 4.66667C12.6667 4.29848 12.3682 4 12 4C11.6318 4 11.3333 4.29848 11.3333 4.66667C11.3333 5.03486 11.6318 5.33333 12 5.33333Z"
      fill="url(#paint9_linear_8031_6930)"
    />
    <path
      d="M15.3333 5.33333H14C13.6333 5.33333 13.3333 5.03333 13.3333 4.66667C13.3333 4.3 13.6333 4 14 4H15.3333C15.7 4 16 4.3 16 4.66667C16 5.03333 15.7 5.33333 15.3333 5.33333Z"
      fill="url(#paint10_linear_8031_6930)"
    />
    <g opacity="0.2">
      <path
        d="M4.99996 1.99935C5.18329 1.99935 5.33329 2.14935 5.33329 2.33268C5.33329 2.51602 5.18329 2.66602 4.99996 2.66602C4.81663 2.66602 4.66663 2.51602 4.66663 2.33268C4.66663 2.14935 4.81663 1.99935 4.99996 1.99935ZM4.99996 1.66602C4.63163 1.66602 4.33329 1.96435 4.33329 2.33268C4.33329 2.70102 4.63163 2.99935 4.99996 2.99935C5.36829 2.99935 5.66663 2.70102 5.66663 2.33268C5.66663 1.96435 5.36829 1.66602 4.99996 1.66602Z"
        fill="#1565C0"
      />
      <path
        d="M4.99996 3.33236C5.18329 3.33236 5.33329 3.48236 5.33329 3.66569C5.33329 3.84902 5.18329 3.99902 4.99996 3.99902C4.81663 3.99902 4.66663 3.84902 4.66663 3.66569C4.66663 3.48236 4.81663 3.33236 4.99996 3.33236ZM4.99996 2.99902C4.63163 2.99902 4.33329 3.29736 4.33329 3.66569C4.33329 4.03402 4.63163 4.33236 4.99996 4.33236C5.36829 4.33236 5.66663 4.03402 5.66663 3.66569C5.66663 3.29736 5.36829 2.99902 4.99996 2.99902Z"
        fill="#1565C0"
      />
    </g>
    <path
      d="M5.00001 2.66667C5.1841 2.66667 5.33334 2.51743 5.33334 2.33333C5.33334 2.14924 5.1841 2 5.00001 2C4.81591 2 4.66667 2.14924 4.66667 2.33333C4.66667 2.51743 4.81591 2.66667 5.00001 2.66667Z"
      fill="url(#paint11_linear_8031_6930)"
    />
    <path
      d="M5.00001 3.99967C5.1841 3.99967 5.33334 3.85044 5.33334 3.66634C5.33334 3.48225 5.1841 3.33301 5.00001 3.33301C4.81591 3.33301 4.66667 3.48225 4.66667 3.66634C4.66667 3.85044 4.81591 3.99967 5.00001 3.99967Z"
      fill="url(#paint12_linear_8031_6930)"
    />
    <path
      opacity="0.2"
      d="M14.6667 12.6663H7.33334C6.965 12.6663 6.66667 12.368 6.66667 11.9997V7.99967C6.66667 7.63134 6.965 7.33301 7.33334 7.33301H14.6667C15.035 7.33301 15.3333 7.63134 15.3333 7.99967V11.9997C15.3333 12.368 15.035 12.6663 14.6667 12.6663Z"
      stroke="#1565C0"
      strokeWidth="3.264"
      strokeMiterlimit="10"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8031_6930"
        x1="0.666667"
        y1="1.24967"
        x2="0.666667"
        y2="9.11884"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BBDEFB" />
        <stop offset="0.9913" stopColor="#64B5F6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8031_6930"
        x1="19.3333"
        y1="0.582995"
        x2="19.3333"
        y2="5.02783"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BBDEFB" />
        <stop offset="0.9913" stopColor="#64B5F6" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_8031_6930"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.0833 1.38937) scale(2.8355)"
      >
        <stop stopColor="#90CAF9" />
        <stop offset="0.989" stopColor="#42A5F5" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_8031_6930"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2 1.38851) scale(8.07467)"
      >
        <stop stopColor="#90CAF9" />
        <stop offset="0.989" stopColor="#42A5F5" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_8031_6930"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.3333 0.138833) scale(18.1933)"
      >
        <stop stopColor="#BBDEFB" />
        <stop offset="0.196" stopColor="#ACD7FA" />
        <stop offset="0.5712" stopColor="#85C5F8" />
        <stop offset="0.8503" stopColor="#64B5F6" />
        <stop offset="0.9956" stopColor="#64B5F6" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_8031_6930"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.8888 6.77816) scale(6.65883)"
      >
        <stop stopColor="#64B5F6" />
        <stop offset="1" stopColor="#42A5F5" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_8031_6930"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.9723 7.58296) rotate(90) scale(6.5835 7.86136)"
      >
        <stop stopColor="#B3E5FC" />
        <stop offset="1" stopColor="#4FC3F7" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_8031_6930"
        x1="5.493"
        y1="7.05576"
        x2="5.493"
        y2="11.1551"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64B5F6" />
        <stop offset="0.2136" stopColor="#5EB2F6" />
        <stop offset="0.5112" stopColor="#4CAAF5" />
        <stop offset="0.8566" stopColor="#2E9CF4" />
        <stop offset="0.9867" stopColor="#2196F3" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_8031_6930"
        x1="10"
        y1="3.88883"
        x2="10"
        y2="5.723"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64B5F6" />
        <stop offset="0.2136" stopColor="#5EB2F6" />
        <stop offset="0.5112" stopColor="#4CAAF5" />
        <stop offset="0.8566" stopColor="#2E9CF4" />
        <stop offset="0.9867" stopColor="#2196F3" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_8031_6930"
        x1="12"
        y1="3.88883"
        x2="12"
        y2="5.723"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64B5F6" />
        <stop offset="0.2136" stopColor="#5EB2F6" />
        <stop offset="0.5112" stopColor="#4CAAF5" />
        <stop offset="0.8566" stopColor="#2E9CF4" />
        <stop offset="0.9867" stopColor="#2196F3" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_8031_6930"
        x1="14.6667"
        y1="3.88883"
        x2="14.6667"
        y2="5.723"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#64B5F6" />
        <stop offset="0.2136" stopColor="#5EB2F6" />
        <stop offset="0.5112" stopColor="#4CAAF5" />
        <stop offset="0.8566" stopColor="#2E9CF4" />
        <stop offset="0.9867" stopColor="#2196F3" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_8031_6930"
        x1="5.00001"
        y1="1.95833"
        x2="5.00001"
        y2="2.628"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1744" />
        <stop offset="1" stopColor="#D50000" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_8031_6930"
        x1="5.00001"
        y1="3.29134"
        x2="5.00001"
        y2="3.96101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#76FF03" />
        <stop offset="1" stopColor="#64DD17" />
      </linearGradient>
    </defs>
  </svg>
);

const ProductSvg = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 7.33333C10.1313 7.33333 9.83333 7.632 9.83333 8C9.83333 8.73533 9.23533 9.33333 8.5 9.33333C7.76467 9.33333 7.16667 8.73533 7.16667 8C7.16667 7.632 6.86867 7.33333 6.5 7.33333C6.13133 7.33333 5.83333 7.632 5.83333 8C5.83333 9.47067 7.02933 10.6667 8.5 10.6667C9.97067 10.6667 11.1667 9.47067 11.1667 8C11.1667 7.632 10.8687 7.33333 10.5 7.33333ZM12.5 12.6667H4.5C4.132 12.6667 3.83333 12.3673 3.83333 12V6H13.1667V12C13.1667 12.3673 12.868 12.6667 12.5 12.6667ZM5.914 3.52867C6.03867 3.40467 6.21 3.33333 6.38533 3.33333H10.6147C10.79 3.33333 10.9613 3.40467 11.086 3.52867L12.224 4.66667H4.776L5.914 3.52867ZM13.914 4.47133L12.0287 2.586C11.6513 2.208 11.1487 2 10.6147 2H6.38533C5.85133 2 5.34867 2.208 4.97133 2.586L3.086 4.47133C2.708 4.84867 2.5 5.35133 2.5 5.886V12C2.5 13.1027 3.39733 14 4.5 14H12.5C13.6027 14 14.5 13.1027 14.5 12V5.886C14.5 5.35133 14.292 4.84867 13.914 4.47133Z"
      fill="#222222"
    />
    <mask
      id="mask0_8031_6973"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="13"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 7.33333C10.1313 7.33333 9.83333 7.632 9.83333 8C9.83333 8.73533 9.23533 9.33333 8.5 9.33333C7.76467 9.33333 7.16667 8.73533 7.16667 8C7.16667 7.632 6.86867 7.33333 6.5 7.33333C6.13133 7.33333 5.83333 7.632 5.83333 8C5.83333 9.47067 7.02933 10.6667 8.5 10.6667C9.97067 10.6667 11.1667 9.47067 11.1667 8C11.1667 7.632 10.8687 7.33333 10.5 7.33333ZM12.5 12.6667H4.5C4.132 12.6667 3.83333 12.3673 3.83333 12V6H13.1667V12C13.1667 12.3673 12.868 12.6667 12.5 12.6667ZM5.914 3.52867C6.03867 3.40467 6.21 3.33333 6.38533 3.33333H10.6147C10.79 3.33333 10.9613 3.40467 11.086 3.52867L12.224 4.66667H4.776L5.914 3.52867ZM13.914 4.47133L12.0287 2.586C11.6513 2.208 11.1487 2 10.6147 2H6.38533C5.85133 2 5.34867 2.208 4.97133 2.586L3.086 4.47133C2.708 4.84867 2.5 5.35133 2.5 5.886V12C2.5 13.1027 3.39733 14 4.5 14H12.5C13.6027 14 14.5 13.1027 14.5 12V5.886C14.5 5.35133 14.292 4.84867 13.914 4.47133Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_8031_6973)">
      <rect x="0.5" width="16" height="16" fill="#222222" />
    </g>
  </svg>
);

const ProductNavSvg = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 11.5039C14.447 11.5039 14 11.9519 14 12.5039C14 13.6069 13.103 14.5039 12 14.5039C10.897 14.5039 10 13.6069 10 12.5039C10 11.9519 9.553 11.5039 9 11.5039C8.447 11.5039 8 11.9519 8 12.5039C8 14.7099 9.794 16.5039 12 16.5039C14.206 16.5039 16 14.7099 16 12.5039C16 11.9519 15.553 11.5039 15 11.5039ZM18 19.5039H6C5.448 19.5039 5 19.0549 5 18.5039V9.50391H19V18.5039C19 19.0549 18.552 19.5039 18 19.5039ZM8.121 5.79691C8.308 5.61091 8.565 5.50391 8.828 5.50391H15.172C15.435 5.50391 15.692 5.61091 15.879 5.79691L17.586 7.50391H6.414L8.121 5.79691ZM20.121 7.21091L17.293 4.38291C16.727 3.81591 15.973 3.50391 15.172 3.50391H8.828C8.027 3.50391 7.273 3.81591 6.707 4.38291L3.879 7.21091C3.312 7.77691 3 8.53091 3 9.33291V18.5039C3 20.1579 4.346 21.5039 6 21.5039H18C19.654 21.5039 21 20.1579 21 18.5039V9.33291C21 8.53091 20.688 7.77691 20.121 7.21091Z"
      fill="#8C8C8C"
    />
    <mask
      id="mask0_7592_30835"
      style={{maskType: "luminance"}}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="19"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11.5039C14.447 11.5039 14 11.9519 14 12.5039C14 13.6069 13.103 14.5039 12 14.5039C10.897 14.5039 10 13.6069 10 12.5039C10 11.9519 9.553 11.5039 9 11.5039C8.447 11.5039 8 11.9519 8 12.5039C8 14.7099 9.794 16.5039 12 16.5039C14.206 16.5039 16 14.7099 16 12.5039C16 11.9519 15.553 11.5039 15 11.5039ZM18 19.5039H6C5.448 19.5039 5 19.0549 5 18.5039V9.50391H19V18.5039C19 19.0549 18.552 19.5039 18 19.5039ZM8.121 5.79691C8.308 5.61091 8.565 5.50391 8.828 5.50391H15.172C15.435 5.50391 15.692 5.61091 15.879 5.79691L17.586 7.50391H6.414L8.121 5.79691ZM20.121 7.21091L17.293 4.38291C16.727 3.81591 15.973 3.50391 15.172 3.50391H8.828C8.027 3.50391 7.273 3.81591 6.707 4.38291L3.879 7.21091C3.312 7.77691 3 8.53091 3 9.33291V18.5039C3 20.1579 4.346 21.5039 6 21.5039H18C19.654 21.5039 21 20.1579 21 18.5039V9.33291C21 8.53091 20.688 7.77691 20.121 7.21091Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_7592_30835)">
      <rect y="0.503906" width="24" height="24" fill="#8C8C8C" />
    </g>
  </svg>
);
const CalendarColoredSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_10341_16282)">
      <path d="M18.3158 5.6842H5.68433V18.3157H18.3158V5.6842Z" fill="white" />
      <path
        d="M18.3158 24.0001L24.0001 18.3158L21.158 17.8309L18.3158 18.3158L17.7971 20.9155L18.3158 24.0001Z"
        fill="#EA4335"
      />
      <path
        d="M0 18.3158V22.1053C0 23.1522 0.847875 24.0001 1.89469 24.0001H5.68425L6.26784 21.1579L5.68425 18.3158L2.58741 17.8309L0 18.3158Z"
        fill="#188038"
      />
      <path
        d="M24.0001 5.68425V1.89469C24.0001 0.847875 23.1522 0 22.1054 0H18.3158C17.9701 1.40963 17.7971 2.44697 17.7971 3.11212C17.7971 3.77719 17.9701 4.63462 18.3158 5.68425C19.573 6.04425 20.5204 6.22425 21.158 6.22425C21.7956 6.22425 22.7429 6.04425 24.0001 5.68425Z"
        fill="#1967D2"
      />
      <path d="M23.9999 5.6842H18.3157V18.3157H23.9999V5.6842Z" fill="#FBBC04" />
      <path d="M18.3158 18.3158H5.68433V24H18.3158V18.3158Z" fill="#34A853" />
      <path
        d="M18.3158 0H1.89478C0.847875 0 0 0.847875 0 1.89469V18.3158H5.68425V5.68425H18.3158V0Z"
        fill="#4285F4"
      />
      <path
        d="M8.27529 15.4832C7.80316 15.1642 7.47626 14.6985 7.29785 14.0825L8.39369 13.631C8.49307 14.01 8.66679 14.3037 8.91476 14.5121C9.16104 14.7205 9.46104 14.8232 9.81157 14.8232C10.17 14.8232 10.4779 14.7142 10.7352 14.4962C10.9926 14.2784 11.1221 14.0005 11.1221 13.6642C11.1221 13.32 10.9863 13.0389 10.7148 12.821C10.4432 12.6032 10.1021 12.4942 9.69476 12.4942H9.06157V11.4095H9.62998C9.98051 11.4095 10.2757 11.3147 10.5157 11.1252C10.7557 10.9358 10.8757 10.6768 10.8757 10.3468C10.8757 10.0532 10.7684 9.81943 10.5537 9.64421C10.339 9.4689 10.0673 9.38049 9.73732 9.38049C9.41519 9.38049 9.15945 9.46581 8.96998 9.63784C8.78061 9.81041 8.63824 10.0283 8.55626 10.271L7.47157 9.81943C7.6152 9.41209 7.87891 9.05209 8.26573 8.74103C8.65263 8.42996 9.14679 8.27368 9.74679 8.27368C10.1905 8.27368 10.59 8.35899 10.9437 8.53103C11.2973 8.70315 11.5752 8.94156 11.7757 9.24474C11.9764 9.54943 12.0757 9.89049 12.0757 10.2694C12.0757 10.6562 11.9826 10.9832 11.7964 11.2516C11.61 11.52 11.381 11.7252 11.1094 11.8689V11.9336C11.4601 12.0782 11.7647 12.3157 11.9905 12.6205C12.2194 12.9284 12.3348 13.2962 12.3348 13.7258C12.3348 14.1552 12.2257 14.5389 12.0079 14.8752C11.79 15.2116 11.4885 15.4768 11.1063 15.6694C10.7226 15.8621 10.2916 15.9601 9.81316 15.9601C9.25891 15.9616 8.74741 15.8021 8.27529 15.4832ZM15.0062 10.0452L13.8031 10.9152L13.2015 10.0026L15.3599 8.44571H16.1872V15.7894H15.0062V10.0452Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <clipPath id="clip0_10341_16282">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const NigeriaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12320_19407)">
      <path
        d="M4 5C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H12V5H4Z"
        fill="#009A49"
      />
      <path d="M12 5H24V31H12V5Z" fill="#EEEEEE" />
      <path
        d="M32 5H24V31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#009A49"
      />
    </g>
    <defs>
      <clipPath id="clip0_12320_19407">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const UsaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12320_19451)">
      <path
        d="M35.445 7C34.752 5.809 33.477 5 32 5H18V7H35.445ZM0 25H36V27H0V25ZM18 17H36V19H18V17ZM18 13H36V15H18V13ZM0 21H36V23H0V21ZM4 31H32C33.477 31 34.752 30.191 35.445 29H0.555C1.248 30.191 2.523 31 4 31ZM18 9H36V11H18V9Z"
        fill="#B22334"
      />
      <path
        d="M0.068 27.679C0.085 27.772 0.104 27.865 0.127 27.956C0.153 28.057 0.185 28.154 0.219 28.252C0.308 28.511 0.416 28.761 0.552 28.995L0.555 29H35.445L35.447 28.996C35.5812 28.7602 35.6924 28.5121 35.779 28.255C35.8449 28.0673 35.8957 27.8747 35.931 27.679C35.972 27.459 36 27.233 36 27H0C0 27.233 0.028 27.458 0.068 27.679ZM0 23H36V25H0V23ZM0 19V21H36V19H18H0ZM18 15H36V17H18V15ZM18 11H36V13H18V11ZM0.128 8.044C0.153 7.942 0.188 7.845 0.22 7.747C0.185273 7.8447 0.15458 7.94378 0.128 8.044ZM18 9H36C36 8.767 35.972 8.541 35.931 8.32C35.896 8.12411 35.8448 7.93145 35.778 7.744C35.6913 7.48581 35.5798 7.23665 35.445 7H18V9Z"
        fill="#EEEEEE"
      />
      <path
        d="M18 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 19H18V5Z"
        fill="#3C3B6E"
      />
      <path
        d="M2.00098 7.726L2.61898 8.175L2.38298 8.9L2.99998 8.452L3.61798 8.9L3.38198 8.175L3.99998 7.726H3.23598L2.99998 7L2.76498 7.726H2.00098ZM4.00098 9.726L4.61898 10.175L4.38298 10.9L4.99998 10.452L5.61798 10.9L5.38198 10.175L5.99998 9.726H5.23598L4.99998 9L4.76498 9.726H4.00098ZM8.00098 9.726L8.61898 10.175L8.38298 10.9L8.99998 10.452L9.61798 10.9L9.38198 10.175L9.99998 9.726H9.23598L8.99998 9L8.76498 9.726H8.00098ZM12.001 9.726L12.619 10.175L12.383 10.9L13 10.452L13.618 10.9L13.382 10.175L14 9.726H13.236L13 9L12.765 9.726H12.001ZM4.00098 13.726L4.61898 14.175L4.38298 14.9L4.99998 14.452L5.61798 14.9L5.38198 14.175L5.99998 13.726H5.23598L4.99998 13L4.76498 13.726H4.00098ZM8.00098 13.726L8.61898 14.175L8.38298 14.9L8.99998 14.452L9.61798 14.9L9.38198 14.175L9.99998 13.726H9.23598L8.99998 13L8.76498 13.726H8.00098ZM12.001 13.726L12.619 14.175L12.383 14.9L13 14.452L13.618 14.9L13.382 14.175L14 13.726H13.236L13 13L12.765 13.726H12.001ZM6.00098 7.726L6.61898 8.175L6.38298 8.9L6.99998 8.452L7.61798 8.9L7.38198 8.175L7.99998 7.726H7.23598L6.99998 7L6.76498 7.726H6.00098ZM10.001 7.726L10.619 8.175L10.383 8.9L11 8.452L11.618 8.9L11.382 8.175L12 7.726H11.236L11 7L10.765 7.726H10.001ZM14.001 7.726L14.619 8.175L14.383 8.9L15 8.452L15.618 8.9L15.382 8.175L16 7.726H15.236L15 7L14.765 7.726H14.001ZM2.00098 11.726L2.61898 12.175L2.38298 12.9L2.99998 12.452L3.61798 12.9L3.38198 12.175L3.99998 11.726H3.23598L2.99998 11L2.76498 11.726H2.00098ZM6.38298 12.9L6.99998 12.452L7.61798 12.9L7.38198 12.175L7.99998 11.726H7.23598L6.99998 11L6.76498 11.726H6.00098L6.61898 12.175L6.38298 12.9ZM10.001 11.726L10.619 12.175L10.383 12.9L11 12.452L11.618 12.9L11.382 12.175L12 11.726H11.236L11 11L10.765 11.726H10.001ZM14.001 11.726L14.619 12.175L14.383 12.9L15 12.452L15.618 12.9L15.382 12.175L16 11.726H15.236L15 11L14.765 11.726H14.001ZM2.00098 15.726L2.61898 16.175L2.38298 16.9L2.99998 16.452L3.61798 16.9L3.38198 16.175L3.99998 15.726H3.23598L2.99998 15L2.76498 15.726H2.00098ZM6.38298 16.9L6.99998 16.452L7.61798 16.9L7.38198 16.175L7.99998 15.726H7.23598L6.99998 15L6.76498 15.726H6.00098L6.61898 16.175L6.38298 16.9ZM10.001 15.726L10.619 16.175L10.383 16.9L11 16.452L11.618 16.9L11.382 16.175L12 15.726H11.236L11 15L10.765 15.726H10.001ZM14.001 15.726L14.619 16.175L14.383 16.9L15 16.452L15.618 16.9L15.382 16.175L16 15.726H15.236L15 15L14.765 15.726H14.001Z"
        fill="#F5F5F5"
      />
    </g>
    <defs>
      <clipPath id="clip0_12320_19451">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const GbpFlagSvg = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12320_19439)">
      <path
        d="M0.5 9.059V13H6.128L0.5 9.059ZM5.164 31H13.5V25.163L5.164 31ZM23.5 25.164V31H31.835L23.5 25.164ZM0.5 23V26.941L6.13 23H0.5ZM31.837 5H23.5V10.837L31.837 5ZM36.5 26.942V23H30.869L36.5 26.942ZM36.5 13V9.059L30.871 13H36.5ZM13.5 5H5.164L13.5 10.837V5Z"
        fill="#00247D"
      />
      <path
        d="M25.64 23.0002L35.352 29.8012C35.8263 29.3126 36.1672 28.7104 36.342 28.0522L29.127 23.0002H25.64ZM13.5 23.0002H11.359L1.64798 29.8002C2.16898 30.3302 2.83698 30.7092 3.58598 30.8852L13.5 23.9432V23.0002ZM23.5 13.0002H25.641L35.352 6.20023C34.822 5.66251 34.1503 5.28626 33.415 5.11523L23.5 12.0572V13.0002ZM11.359 13.0002L1.64798 6.20023C1.17394 6.68921 0.832797 7.29128 0.656982 7.94923L7.87198 13.0002H11.359Z"
        fill="#CF1B2B"
      />
      <path
        d="M36.5 21H21.5V31H23.5V25.164L31.835 31H32.5C33.0313 31.0001 33.5572 30.8941 34.0469 30.6882C34.5367 30.4823 34.9804 30.1807 35.352 29.801L25.64 23H29.127L36.342 28.052C36.435 27.715 36.5 27.366 36.5 27V26.942L30.869 23H36.5V21ZM0.5 21V23H6.13L0.5 26.941V27C0.5 28.091 0.939 29.078 1.648 29.8L11.359 23H13.5V23.943L3.586 30.884C3.88 30.954 4.184 31 4.5 31H5.164L13.5 25.163V31H15.5V21H0.5ZM36.5 9C36.5006 7.95198 36.0881 6.94595 35.352 6.2L25.641 13H23.5V12.057L33.415 5.115C33.1155 5.04153 32.8084 5.00294 32.5 5H31.837L23.5 10.837V5H21.5V15H36.5V13H30.871L36.5 9.059V9ZM13.5 5V10.837L5.164 5H4.5C3.96862 4.99977 3.44257 5.10581 2.95278 5.3119C2.46299 5.51798 2.01936 5.81993 1.648 6.2L11.359 13H7.872L0.657 7.949C0.55778 8.29071 0.504973 8.64421 0.5 9L0.5 9.059L6.128 13H0.5V15H15.5V5H13.5Z"
        fill="#EEEEEE"
      />
      <path d="M21.5 15V5H15.5V15H0.5V21H15.5V31H21.5V21H36.5V15H21.5Z" fill="#CF1B2B" />
    </g>
    <defs>
      <clipPath id="clip0_12320_19439">
        <rect width="36" height="36" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
const EuroFlagSvg = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1131)">
      <path
        d="M32.5 5H4.5C3.43913 5 2.42172 5.42143 1.67157 6.17157C0.921427 6.92172 0.5 7.93913 0.5 9L0.5 27C0.5 28.0609 0.921427 29.0783 1.67157 29.8284C2.42172 30.5786 3.43913 31 4.5 31H32.5C33.5609 31 34.5783 30.5786 35.3284 29.8284C36.0786 29.0783 36.5 28.0609 36.5 27V9C36.5 7.93913 36.0786 6.92172 35.3284 6.17157C34.5783 5.42143 33.5609 5 32.5 5Z"
        fill="#003399"
      />
      <path
        d="M19.0391 9.70484L19.8881 9.08784H18.8391L18.5141 8.08984L18.1901 9.08784H17.1411L17.9901 9.70484L17.6651 10.7028L18.5141 10.0858L19.3631 10.7028L19.0391 9.70484ZM19.0391 27.0378L19.8881 26.4208H18.8391L18.5141 25.4228L18.1901 26.4208H17.1411L17.9901 27.0378L17.6651 28.0358L18.5141 27.4188L19.3631 28.0358L19.0391 27.0378ZM10.3731 18.3708L11.2221 17.7538H10.1721L9.84812 16.7558L9.52312 17.7538H8.47412L9.32312 18.3708L8.99912 19.3688L9.84812 18.7518L10.6971 19.3688L10.3731 18.3708ZM11.4801 14.0858L12.3291 13.4688H11.2791L10.9551 12.4708L10.6311 13.4688H9.58112L10.4301 14.0858L10.1061 15.0838L10.9551 14.4668L11.8041 15.0838L11.4801 14.0858ZM11.4801 22.7048L12.3291 22.0878H11.2791L10.9551 21.0898L10.6311 22.0878H9.58112L10.4301 22.7048L10.1061 23.7028L10.9551 23.0858L11.8041 23.7028L11.4801 22.7048ZM14.7061 10.8658L15.5551 10.2488H14.5051L14.1811 9.25084L13.8571 10.2488H12.8071L13.6561 10.8658L13.3321 11.8638L14.1811 11.2468L15.0301 11.8638L14.7061 10.8658ZM14.7061 25.9328L15.5551 25.3158H14.5051L14.1811 24.3178L13.8571 25.3158H12.8071L13.6561 25.9328L13.3321 26.9308L14.1811 26.3148L15.0301 26.9308L14.7061 25.9328ZM26.6271 18.3708L25.7781 17.7538H26.8281L27.1521 16.7558L27.4771 17.7538H28.5261L27.6771 18.3708L28.0011 19.3688L27.1521 18.7518L26.3031 19.3688L26.6271 18.3708ZM25.5201 14.0858L24.6711 13.4688H25.7211L26.0451 12.4708L26.3691 13.4688H27.4191L26.5701 14.0858L26.8941 15.0838L26.0451 14.4668L25.1961 15.0838L25.5201 14.0858ZM25.5201 22.7048L24.6711 22.0878H25.7211L26.0451 21.0898L26.3691 22.0878H27.4191L26.5701 22.7048L26.8941 23.7028L26.0451 23.0858L25.1961 23.7028L25.5201 22.7048ZM22.2941 10.8658L21.4451 10.2488H22.4951L22.8191 9.25084L23.1431 10.2488H24.1931L23.3441 10.8658L23.6681 11.8638L22.8191 11.2468L21.9701 11.8638L22.2941 10.8658ZM22.2941 25.9328L21.4451 25.3158H22.4951L22.8191 24.3178L23.1431 25.3158H24.1931L23.3441 25.9328L23.6681 26.9308L22.8191 26.3148L21.9701 26.9308L22.2941 25.9328Z"
        fill="#FFCC00"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1131">
        <rect width="36" height="36" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
const CanadaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_759)">
      <path
        d="M4 5C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H10V5H4ZM32 5H26V31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#D52B1E"
      />
      <path d="M10 5H26V31H10V5Z" fill="#EEEEEE" />
      <path
        d="M18.6151 22.1135C19.8131 22.2525 20.8871 22.3775 22.0841 22.5145L21.7791 21.5125C21.7567 21.4263 21.7598 21.3355 21.788 21.251C21.8162 21.1665 21.8684 21.092 21.9381 21.0365L25.4171 18.2025L24.6971 17.8635C24.3801 17.7505 24.4671 17.5715 24.5821 17.1415L25.1131 15.2055L23.0921 15.6325C22.8951 15.6625 22.7641 15.5375 22.7341 15.4175L22.4731 14.5065L20.8751 16.3005C20.6481 16.5885 20.1881 16.5885 20.3311 15.9245L21.0141 12.2905L20.0971 12.7655C19.8401 12.9095 19.5831 12.9335 19.4401 12.6765L18.1751 10.3105L16.9101 12.6765C16.7661 12.9335 16.5091 12.9095 16.2521 12.7655L15.3361 12.2905L16.0191 15.9245C16.1631 16.5885 15.7021 16.5885 15.4751 16.3005L13.8771 14.5075L13.6171 15.4185C13.5871 15.5385 13.4551 15.6635 13.2581 15.6335L11.2371 15.2065L11.7681 17.1425C11.8811 17.5725 11.9691 17.7515 11.6521 17.8645L10.9321 18.2035L14.4111 21.0375C14.5491 21.1445 14.6191 21.3375 14.5691 21.5135L14.2641 22.5155L17.7341 22.1145C17.8401 22.1145 17.9101 22.1735 17.9091 22.2955L17.6951 25.9995H18.6511L18.4381 22.2955C18.4401 22.1725 18.5091 22.1135 18.6151 22.1135Z"
        fill="#D52B1E"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_759">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const KenyaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 14.0625H36V21.9375H0V14.0625Z" fill="#EC1C24" />
    <path
      d="M0 12.375H36V14.0625H0V12.375ZM0 21.9375H36V23.625H0V21.9375Z"
      fill="#E6E7E8"
    />
    <path
      d="M30.375 5.625H5.625C1.89731 5.625 0 8.39531 0 11.8125V12.375H36V11.8125C36 8.39531 34.1027 5.625 30.375 5.625Z"
      fill="#25333A"
    />
    <path
      d="M0 24.1875C0 27.6047 1.89731 30.375 5.625 30.375H30.375C34.1027 30.375 36 27.6047 36 24.1875V23.625H0V24.1875Z"
      fill="#137A08"
    />
    <path
      d="M12.8452 26.8805L21.6821 12.0541C21.7454 11.3726 21.9742 10.7169 22.3487 10.1439C22.8099 9.43683 23.463 8.91033 24.2268 8.57227C24.2223 9.4087 23.999 10.2159 23.5361 10.9235C23.1923 11.4474 22.7354 11.8876 22.199 12.2116L13.2969 27.1488L12.8452 26.8805Z"
      fill="#F5F5F5"
    />
    <path
      d="M24.2268 26.8805L15.3905 12.0541C15.3272 11.3726 15.0984 10.7169 14.724 10.1439C14.2616 9.43683 13.6097 8.91033 12.8452 8.57227C12.8503 9.4087 13.0702 10.2159 13.5354 10.9235C13.8799 11.4471 14.3369 11.8871 14.873 12.2116L23.7735 27.1494L24.2268 26.8805Z"
      fill="#F5F5F5"
    />
    <path
      d="M18.536 10.1152C16.2635 11.427 14.6807 14.3998 14.6807 17.8592C14.6807 21.3185 16.2664 24.2897 18.536 25.6054C20.8029 24.2891 22.3914 21.3185 22.3914 17.8592C22.3914 14.4004 20.8057 11.427 18.536 10.1152Z"
      fill="#D9271E"
    />
    <path
      d="M15.3917 21.72C15.8485 20.5624 16.1044 19.249 16.1044 17.8585C16.1044 16.4669 15.8485 15.1551 15.3917 13.998C14.9389 15.1557 14.6802 16.4674 14.6802 17.8585C14.6807 19.2495 14.9395 20.563 15.3917 21.72ZM21.6805 21.72C22.1333 20.5624 22.3915 19.249 22.3915 17.8585C22.3915 16.4669 22.1333 15.1551 21.6805 13.998C21.2237 15.1557 20.9678 16.4674 20.9678 17.8585C20.9678 19.2495 21.2237 20.563 21.6805 21.72Z"
      fill="#25333A"
    />
    <path
      d="M18.536 19.1409C19.133 19.1409 19.6171 18.5672 19.6171 17.8595C19.6171 17.1518 19.133 16.5781 18.536 16.5781C17.9389 16.5781 17.4548 17.1518 17.4548 17.8595C17.4548 18.5672 17.9389 19.1409 18.536 19.1409Z"
      fill="#F5F5F5"
    />
    <path
      d="M18.275 19.5986C17.789 20.3135 17.4807 21.3289 17.4807 22.4578C17.4807 23.5884 17.789 24.602 18.275 25.3164V19.5986ZM18.7593 25.3187C19.2453 24.6037 19.5518 23.5884 19.5518 22.46C19.5518 21.3294 19.2453 20.3152 18.7593 19.6009V25.3187ZM18.2935 10.4434C17.8053 11.1577 17.501 12.1736 17.501 13.2992C17.501 14.4298 17.8053 15.4462 18.2935 16.1612V10.4434ZM18.7784 16.1612C19.2666 15.4445 19.571 14.4281 19.571 13.2992C19.571 12.1742 19.2666 11.1572 18.7784 10.4434V16.1612Z"
      fill="#F5F5F5"
    />
  </svg>
);
const GhanaFlagSvg = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12320_19402)">
      <path d="M0.5 14.0625H36.5V21.9375H0.5V14.0625Z" fill="#F9CB38" />
      <path
        d="M30.875 5.625H6.125C2.39731 5.625 0.5 8.39531 0.5 11.8125V14.0625H36.5V11.8125C36.5 8.39531 34.6027 5.625 30.875 5.625Z"
        fill="#EC1C24"
      />
      <path
        d="M0.5 24.1875C0.5 27.6047 2.39731 30.375 6.125 30.375H30.875C34.6027 30.375 36.5 27.6047 36.5 24.1875V21.9375H0.5V24.1875Z"
        fill="#137A08"
      />
      <path
        d="M18.3752 14.5273L19.4704 16.7464L21.9201 17.1053L20.1488 18.8333L20.5673 21.2706L18.3752 20.1192L16.1837 21.2706L16.6022 18.8333L14.8303 17.1053L17.2806 16.7464L18.3752 14.5273Z"
        fill="#25333A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12320_19402">
        <rect width="36" height="36" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
const UgandaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12320_19411)">
      <path
        d="M36 27V26H0V27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27Z"
        fill="#D90001"
      />
      <path d="M0 22H36V26H0V22Z" fill="#FCDC02" />
      <path d="M0 18H36V22H0V18Z" fill="#141414" />
      <path d="M0 14H36V18H0V14Z" fill="#D90001" />
      <path d="M0 10H36V14H0V10Z" fill="#FCDC02" />
      <path
        d="M0 9V10H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9Z"
        fill="#141414"
      />
      <path
        d="M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22Z"
        fill="#F5F5F5"
      />
      <path
        d="M17.3439 15.0315L17.0769 14.3285C17.0769 14.3285 17.6559 14.1255 18.2189 14.3285C18.6479 14.4835 18.6879 15.0315 18.6879 15.0315L18.0169 15.2345L17.3439 15.0315Z"
        fill="#D90000"
      />
      <path
        d="M17.594 14.9219V14.2379C17.594 14.2379 17.705 14.1949 18.017 14.2379C18.329 14.2809 18.47 14.4999 18.47 14.4999L18.032 15.0319L17.594 14.9219Z"
        fill="#FCDC02"
      />
      <path
        d="M17.745 16.8969C17.662 16.7509 17.745 15.8969 17.984 15.8349C18.223 15.7729 18.682 15.0229 17.984 14.7729C17.286 14.5229 17.14 15.2519 17.14 15.2519C17.14 15.2519 16.45 15.4549 16.536 15.6269C16.619 15.7939 17.203 15.5649 17.328 15.7099C17.453 15.8549 17.266 16.0639 16.766 16.6479C16.266 17.2319 16.599 18.0229 16.828 18.2269C17.057 18.4309 17.328 18.5859 17.536 18.7729C17.744 18.9599 17.984 19.0649 17.984 19.0649V19.6689C17.984 19.6689 17.286 19.7309 16.953 19.6899C16.62 19.6489 16.391 19.8779 16.307 20.1479C16.223 20.4179 16.432 20.5649 16.432 20.3569C16.432 20.1489 16.515 20.2729 16.534 20.4399C16.553 20.6069 16.702 20.5439 16.702 20.3359C16.702 20.1279 16.785 20.2109 16.806 20.3149C16.827 20.4189 16.973 20.2729 16.994 20.1479C17.015 20.0229 17.202 19.9599 17.369 19.9189C17.536 19.8779 17.983 19.9599 17.983 19.9599V21.0639C17.983 21.0639 17.056 21.1259 16.973 21.2519C16.89 21.3779 17.535 21.3559 17.535 21.3559C17.535 21.3559 17.347 21.7099 17.431 21.7309C17.515 21.7519 18.098 21.3769 18.327 21.3349C18.556 21.2929 18.91 21.4389 18.952 21.3349C18.994 21.2309 18.39 21.0849 18.327 20.9809C18.264 20.8769 18.139 19.9189 18.139 19.9189C18.139 19.9189 18.41 19.8969 18.744 19.9179C19.077 19.9389 18.994 19.6469 18.786 19.3559C18.578 19.0649 18.765 18.9809 19.119 19.0439C19.473 19.1069 19.744 19.0439 19.744 18.4809C19.744 17.9179 17.828 17.0429 17.745 16.8969ZM18.474 19.6049H18.245L18.328 19.1879C18.328 19.1889 18.62 19.6049 18.474 19.6049Z"
        fill="#141414"
      />
      <path
        d="M17.474 15.8121C17.503 15.5631 17.099 15.5831 17.078 15.8121C17.057 16.0411 17.433 16.1671 17.474 15.8121Z"
        fill="#D90000"
      />
      <path
        d="M17.7501 17.047C17.8651 17.006 19.1561 17.594 19.5001 17.75C19.8441 17.906 19.8031 18.5 19.7451 18.859C19.6871 19.218 19.4841 19.328 19.4841 19.328C19.4841 19.328 19.2591 18.748 18.5461 18.469C17.5891 18.094 17.3121 17.203 17.7501 17.047Z"
        fill="#9CA69C"
      />
      <path
        d="M19.203 17.7344C19.624 17.8444 20.515 18.0464 20.594 18.9534C20.672 19.8594 19.745 20.3914 19.745 20.3914L19.9 20.1104L19.625 20.2044L19.745 20.0004L19.312 20.0944C19.312 20.0944 20.037 19.5164 19.784 19.0004C19.803 19.4304 19.515 19.5474 19.515 19.5474C19.515 19.5474 19.763 18.9514 18.687 18.2974L18.968 18.2254L18.688 18.0004L19.282 18.2254L19 17.8754L19.562 18.0944L19.203 17.7344Z"
        fill="#D90000"
      />
      <path
        d="M17.5939 15.3364C17.5939 15.3634 17.5831 15.3894 17.564 15.4085C17.5449 15.4276 17.5189 15.4384 17.4919 15.4384C17.4648 15.4384 17.4389 15.4276 17.4198 15.4085C17.4006 15.3894 17.3899 15.3634 17.3899 15.3364C17.3899 15.3093 17.4006 15.2834 17.4198 15.2642C17.4389 15.2451 17.4648 15.2344 17.4919 15.2344C17.5189 15.2344 17.5449 15.2451 17.564 15.2642C17.5831 15.2834 17.5939 15.3093 17.5939 15.3364Z"
        fill="#9CA69C"
      />
    </g>
    <defs>
      <clipPath id="clip0_12320_19411">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const TanzaniaFlagSvg = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_626)">
      <path
        d="M4.5 5C3.43913 5 2.42172 5.42143 1.67157 6.17157C0.921427 6.92172 0.5 7.93913 0.5 9L0.5 24.627L26.956 5H4.5Z"
        fill="#1EB53A"
      />
      <path
        d="M32.5 31.0001C33.5609 31.0001 34.5783 30.5786 35.3284 29.8285C36.0786 29.0784 36.5 28.0609 36.5 27.0001V11.3301L9.979 31.0001H32.5Z"
        fill="#00A3DD"
      />
      <path
        d="M32.5 5H29.968L0.5 26.638V27C0.5 28.0609 0.921427 29.0783 1.67157 29.8284C2.42172 30.5786 3.43913 31 4.5 31H6.967L36.5 9.318V9C36.5 7.93913 36.0786 6.92172 35.3284 6.17157C34.5783 5.42143 33.5609 5 32.5 5Z"
        fill="#141414"
      />
      <path
        d="M26.956 5L0.5 24.627V26.638L29.968 5H26.956ZM9.979 31L36.5 11.33V9.318L6.967 31H9.979Z"
        fill="#FBD035"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_626">
        <rect width="36" height="36" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
const SouthAfricaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_656)">
      <path
        d="M32 5H6.5L19 13.5H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#DE3830"
      />
      <path
        d="M6.5 31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V22.5H19L6.5 31Z"
        fill="#002395"
      />
      <path d="M0 11V25L10.5 18L0 11Z" fill="#141414" />
      <path d="M0 9V11L10.5 18L0 25V27L13.5 18L0 9Z" fill="#FFB611" />
      <path
        d="M3.541 5.02734C2.56637 5.13993 1.6671 5.60678 1.01422 6.33913C0.361343 7.07148 0.000386962 8.01823 0 8.99934L13.5 17.9993L0 26.9993C0.000386962 27.9805 0.361343 28.9272 1.01422 29.6596C1.6671 30.3919 2.56637 30.8588 3.541 30.9713L18.5 20.4993H36V15.4993H18.5L3.541 5.02734Z"
        fill="#007A4D"
      />
      <path
        d="M6.50002 5H4.00002C3.84402 5 3.69202 5.011 3.54102 5.028L18.5 15.5H36V13.5H19L6.50002 5ZM3.54102 30.972C3.69202 30.989 3.84402 31 4.00002 31H6.50002L19 22.5H36V20.5H18.5L3.54102 30.972Z"
        fill="#EEEEEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_656">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const AustraliaFlagSvg = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_676)">
      <path
        d="M32.5 5H4.5C4.295 5 4.093 5.015 3.896 5.045L3.892 6.799L1.162 6.795C0.729151 7.44884 0.498868 8.21587 0.500004 9V27C0.500004 28.0609 0.921432 29.0783 1.67158 29.8284C2.42172 30.5786 3.43914 31 4.5 31H32.5C33.5609 31 34.5783 30.5786 35.3284 29.8284C36.0786 29.0783 36.5 28.0609 36.5 27V9C36.5 7.93913 36.0786 6.92172 35.3284 6.17157C34.5783 5.42143 33.5609 5 32.5 5Z"
        fill="#00247D"
      />
      <path
        d="M9.49991 26.0229L8.27791 27.1519L8.39891 25.4919L6.75391 25.2409L8.12691 24.3009L7.29791 22.8579L8.88891 23.3459L9.49991 21.7969L10.1119 23.3459L11.7029 22.8579L10.8729 24.3009L12.2469 25.2409L10.6019 25.4919L10.7229 27.1519L9.49991 26.0229ZM28.4499 9.56188L27.6509 10.2999L27.7299 9.21387L26.6529 9.04988L27.5519 8.43488L27.0099 7.49088L28.0499 7.80988L28.4499 6.79688L28.8509 7.80988L29.8919 7.49088L29.3489 8.43488L30.2469 9.04988L29.1709 9.21387L29.2499 10.2999L28.4499 9.56188ZM24.4499 15.5619L23.6509 16.3009L23.7299 15.2149L22.6529 15.0509L23.5519 14.4349L23.0099 13.4909L24.0499 13.8099L24.4499 12.7969L24.8509 13.8099L25.8919 13.4909L25.3489 14.4349L26.2469 15.0509L25.1709 15.2149L25.2499 16.3009L24.4499 15.5619ZM33.4499 13.5619L32.6509 14.3009L32.7299 13.2149L31.6529 13.0509L32.5519 12.4349L32.0099 11.4909L33.0499 11.8099L33.4499 10.7969L33.8509 11.8099L34.8919 11.4909L34.3489 12.4349L35.2469 13.0509L34.1709 13.2149L34.2499 14.3009L33.4499 13.5619ZM28.4499 27.5619L27.6509 28.3009L27.7299 27.2149L26.6529 27.0509L27.5519 26.4349L27.0099 25.4909L28.0499 25.8099L28.4499 24.7969L28.8509 25.8099L29.8919 25.4909L29.3489 26.4349L30.2469 27.0509L29.1709 27.2149L29.2499 28.3009L28.4499 27.5619ZM31.4999 15.9999L31.7939 16.5959L32.4509 16.6909L31.9759 17.1539L32.0879 17.8089L31.4999 17.4999L30.9119 17.8089L31.0239 17.1539L30.5489 16.6909L31.2059 16.5959L31.4999 15.9999Z"
        fill="#F5F5F5"
      />
      <path
        d="M19.5 18V5H4.5C4.18 5 3.896 5.045 3.896 5.045L3.892 6.799L1.162 6.795C1.162 6.795 1.12 6.854 1.035 7C0.683716 7.60795 0.499164 8.29786 0.500003 9V18H19.5Z"
        fill="#00247D"
      />
      <path
        d="M19.5 5H17.169L12.5 8.269V5H7.5V7.569L3.896 5.045C3.29485 5.1348 2.72261 5.36239 2.224 5.71L6.926 9H5.19L1.467 6.391C1.35721 6.51933 1.25535 6.65425 1.162 6.795L4.313 9H0.5V14H4.385L0.5 16.766V18H3.832L7.5 15.432V18H12.5V14.731L17.168 18H19.5V15.971L16.685 14H19.5V9H16.686L19.5 7.029V5Z"
        fill="#EEEEEE"
      />
      <path d="M11.5 5H8.5V10H0.5V13H8.5V18H11.5V13H19.5V10H11.5V5Z" fill="#CF1B2B" />
      <path
        d="M19.4999 5H18.0389L12.4999 8.879V9H14.0709L19.4999 5.198V5ZM2.22389 5.71C1.94392 5.90427 1.68958 6.13307 1.46689 6.391L5.18989 9H6.92489L2.22389 5.71ZM6.93689 14L1.23389 18H2.96089L7.49989 14.822V14H6.93689ZM19.4999 17.802V16.582L15.8129 14H14.0699L19.4999 17.802Z"
        fill="#CF1B2B"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_676">
        <rect width="36" height="36" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
const BrazilFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 27C36 28.0609 35.5786 29.0783 34.8284 29.8284C34.0783 30.5786 33.0609 31 32 31H4C2.93913 31 1.92172 30.5786 1.17157 29.8284C0.421427 29.0783 0 28.0609 0 27V9C0 7.93913 0.421427 6.92172 1.17157 6.17157C1.92172 5.42143 2.93913 5 4 5H32C33.0609 5 34.0783 5.42143 34.8284 6.17157C35.5786 6.92172 36 7.93913 36 9V27Z"
      fill="#009B3A"
    />
    <path d="M32.728 18L18 29.124L3.27197 18L18 6.875L32.728 18Z" fill="#FEDF01" />
    <path
      d="M17.9761 24.3828C21.5427 24.3828 24.4341 21.4915 24.4341 17.9248C24.4341 14.3581 21.5427 11.4668 17.9761 11.4668C14.4094 11.4668 11.5181 14.3581 11.5181 17.9248C11.5181 21.4915 14.4094 24.3828 17.9761 24.3828Z"
      fill="#002776"
    />
    <path
      d="M12.277 14.8868C11.9416 15.5189 11.7144 16.2027 11.605 16.9098C15.6 16.6198 21.022 18.8008 23.349 21.5048C23.751 20.9008 24.049 20.2248 24.232 19.5008C21.36 16.6928 16.315 14.8708 12.277 14.8868Z"
      fill="#CBE9D4"
    />
    <path
      d="M12 18.2324H13V19.2324H12V18.2324ZM13 20.2324H14V21.2324H13V20.2324Z"
      fill="#88C9F9"
    />
    <path
      d="M15 18.2324H16V19.2324H15V18.2324ZM17 19.2324H18V20.2324H17V19.2324ZM21 21.2324H22V22.2324H21V21.2324ZM18 22.2324H19V23.2324H18V22.2324ZM21 16.2324H22V17.2324H21V16.2324Z"
      fill="#55ACEE"
    />
    <path d="M19 20.2324H20V21.2324H19V20.2324Z" fill="#3B88C3" />
  </svg>
);

const BulgariaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_745)">
      <path
        d="M32 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 14H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#EEEEEE"
      />
      <path
        d="M0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V22H0V27Z"
        fill="#D62612"
      />
      <path d="M0 14H36V22H0V14Z" fill="#00966E" />
    </g>
    <defs>
      <clipPath id="clip0_12470_745">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CroatiaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_773)">
      <path d="M0 12.9004H36V23.1004H0V12.9004Z" fill="#EEEEEE" />
      <path
        d="M36 27C36 28.0609 35.5786 29.0783 34.8284 29.8284C34.0783 30.5786 33.0609 31 32 31H4C2.93913 31 1.92172 30.5786 1.17157 29.8284C0.421427 29.0783 0 28.0609 0 27V23H36V27Z"
        fill="#171796"
      />
      <path
        d="M32 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 13H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#D52B1E"
      />
      <path
        d="M11.4092 7.43555V18.9695C11.4092 20.7176 12.1036 22.394 13.3396 23.6301C14.5757 24.8661 16.2521 25.5605 18.0002 25.5605C19.7482 25.5605 21.4247 24.8661 22.6607 23.6301C23.8968 22.394 24.5912 20.7176 24.5912 18.9695V7.43555H11.4092Z"
        fill="#D52B1E"
      />
      <path
        d="M14.2502 18H16.7502V20.5H14.2502V18ZM16.7502 20.5H19.2502V23H16.7502V20.5ZM16.7502 15.5H19.2502V18H16.7502V15.5ZM19.2502 18H21.7502V20.5H19.2502V18ZM19.2502 13H21.7502V15.5H19.2502V13ZM21.7502 15.5H24.0912V18H21.7502V15.5ZM14.2502 13H16.7502V15.5H14.2502V13ZM21.7502 23H22.5552C23.1905 22.2834 23.6476 21.4268 23.8892 20.5H21.7502V23ZM19.2502 23V24.931C20.1623 24.7377 21.0178 24.337 21.7502 23.76V23H19.2502ZM14.2502 23V20.5H12.1112C12.3523 21.4269 12.8095 22.2836 13.4452 23H14.2502ZM11.9092 15.5H14.2502V18H11.9092V15.5ZM14.2502 23V23.76C14.9826 24.337 15.838 24.7377 16.7502 24.931V23H14.2502Z"
        fill="#F5F5F5"
      />
      <path
        d="M24.757 8.14122L22.759 8.93222L21.431 7.25022L19.602 8.37622L18 6.94922L16.397 8.37722L14.571 7.24922L13.24 8.93322L11.245 8.14022L10.123 10.2202L11.454 13.0822L11.63 13.0002C12.41 12.6372 13.233 12.3382 14.073 12.1122L14.113 12.1012C14.9397 11.8794 15.7837 11.7285 16.636 11.6502L16.7 11.6442C17.405 11.5842 18.596 11.5842 19.301 11.6442L19.359 11.6492C20.183 11.7232 21.037 11.8752 21.895 12.1022L21.928 12.1112C22.764 12.3362 23.586 12.6352 24.369 13.0002L24.544 13.0822L25.875 10.2212L24.757 8.14122Z"
        fill="#171796"
      />
      <path
        d="M16.6382 8.68175L16.8592 11.2448C17.1892 11.2188 17.5882 11.1937 18.0002 11.1937C18.4122 11.1937 18.8112 11.2188 19.1412 11.2448L19.3622 8.68175L18.0002 7.46875L16.6382 8.68175ZM24.5792 8.62875L22.8812 9.30175L22.2132 11.7908C22.9442 11.9967 23.6632 12.2588 24.3572 12.5698L25.4432 10.2337L24.5792 8.62875ZM11.4222 8.62675L10.5562 10.2328L11.6432 12.5687C12.3332 12.2587 13.0522 11.9967 13.7872 11.7897L13.1172 9.29975L11.4222 8.62675Z"
        fill="#0193DD"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_773">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CzechFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1124)">
      <path
        d="M1.38306 29.973C2.09175 30.6377 3.02842 31.0053 4.00006 31H32.0001C34.2091 31 36.0001 29.209 36.0001 26.5V18H17.5001L1.38306 29.973Z"
        fill="#D7141A"
      />
      <path
        d="M32 5H4C3.02452 4.99974 2.08292 5.35774 1.354 6.006L17.5 18H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#EEEEEE"
      />
      <path
        d="M1.383 29.9729L17.5 17.9999L1.354 6.00586C0.928425 6.37996 0.587524 6.84052 0.35404 7.3568C0.120556 7.87309 -0.000141693 8.43323 1.24831e-07 8.99986V26.4999C1.24831e-07 27.9799 0.537 29.1829 1.383 29.9729Z"
        fill="#11457E"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1124">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DenmarkFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1137)">
      <path
        d="M32 5H15V16H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5ZM15 31H32C34.209 31 36 29.209 36 26.5V20H15V31ZM0 20V26.5C0 29.209 1.791 31 4 31H11V20H0ZM11 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 16H11V5Z"
        fill="#C60C30"
      />
      <path d="M15 5H11V16H0V20H11V31H15V20H36V16H15V5Z" fill="#EEEEEE" />
    </g>
    <defs>
      <clipPath id="clip0_12470_1137">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const GibraltarFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1160)">
      <path
        d="M36 27C36 28.0609 35.5786 29.0783 34.8284 29.8284C34.0783 30.5786 33.0609 31 32 31H4C2.93913 31 1.92172 30.5786 1.17157 29.8284C0.421427 29.0783 0 28.0609 0 27V22H36V27Z"
        fill="#DA1C0B"
      />
      <path
        d="M32 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 23H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#EEEEEE"
      />
      <path
        d="M14.4511 10.3633V11.1423H13.6731V10.3633H12.1161V11.1423H11.3371V10.3633H10.5591V11.9203H11.3371V15.8123H14.4511V11.9203H15.2301V10.3633H14.4511Z"
        fill="#DA1C0B"
      />
      <path
        d="M15.241 14.2559V15.0349H14.462V14.2559H13.684V15.0349H12.127V14.2559H11.348V15.0349H10.57V14.2559H9.79199V15.8129H10.57V20.0669L9.79199 20.4829V21.2619H16.019V20.4829L15.241 20.0669V15.8129H16.019V14.2559H15.241Z"
        fill="#DA1C0B"
      />
      <path d="M12.116 13.4766H13.673V15.0336H12.116V13.4766Z" fill="black" />
      <path
        d="M13.6729 13.4767C13.6767 13.5811 13.6594 13.6853 13.622 13.7829C13.5846 13.8805 13.5279 13.9695 13.4553 14.0447C13.3828 14.12 13.2958 14.1798 13.1996 14.2206C13.1034 14.2615 13 14.2826 12.8954 14.2826C12.7909 14.2826 12.6875 14.2615 12.5913 14.2206C12.4951 14.1798 12.4081 14.12 12.3355 14.0447C12.263 13.9695 12.2063 13.8805 12.1689 13.7829C12.1315 13.6853 12.1142 13.5811 12.1179 13.4767C12.1252 13.2753 12.2102 13.0846 12.3553 12.9447C12.5003 12.8047 12.6939 12.7266 12.8954 12.7266C13.097 12.7266 13.2906 12.8047 13.4356 12.9447C13.5806 13.0846 13.6657 13.2753 13.6729 13.4767ZM13.6729 18.3797C13.6729 17.7587 13.5159 17.2547 12.8949 17.2547C12.2739 17.2547 12.1169 17.7587 12.1169 18.3797V19.7047H13.6739L13.6729 18.3797Z"
        fill="black"
      />
      <path
        d="M24.9101 10.3633V11.1423H24.1321V10.3633H22.5751V11.1423H21.7971V10.3633H21.0181V11.9203H21.7971V15.8123H24.9101V11.9203H25.6901V10.3633H24.9101Z"
        fill="#DA1C0B"
      />
      <path
        d="M25.69 14.2559V15.0349H24.91V14.2559H24.132V15.0349H22.575V14.2559H21.797V15.0349H21.018V14.2559H20.24V15.8129H21.018V20.0669L20.24 20.4829V21.2619H26.467V20.4829L25.69 20.0669V15.8129H26.467V14.2559H25.69Z"
        fill="#DA1C0B"
      />
      <path d="M22.575 13.4766H24.132V15.0336H22.575V13.4766Z" fill="black" />
      <path
        d="M24.1319 13.4772C24.1319 13.6836 24.05 13.8814 23.9041 14.0273C23.7582 14.1733 23.5603 14.2552 23.3539 14.2552C23.1476 14.2552 22.9497 14.1733 22.8038 14.0273C22.6579 13.8814 22.5759 13.6836 22.5759 13.4772C22.5759 13.2709 22.6579 13.073 22.8038 12.9271C22.9497 12.7812 23.1476 12.6992 23.3539 12.6992C23.5603 12.6992 23.7582 12.7812 23.9041 12.9271C24.05 13.073 24.1319 13.2709 24.1319 13.4772ZM24.1319 18.3802C24.1319 17.7592 23.9749 17.2552 23.3539 17.2552C22.7329 17.2552 22.5759 17.7592 22.5759 18.3802V19.7052H24.1329L24.1319 18.3802Z"
        fill="black"
      />
      <path d="M20 8V9H19V8H17V9H16V8H15V10H16V15H20V10H21V8H20Z" fill="#DA1C0B" />
      <path d="M21 13V14H20V13H19V14H17V13H16V14H15V13H14V22H22V13H21Z" fill="#DA1C0B" />
      <path d="M17 12H19V14H17V12Z" fill="black" />
      <path
        d="M18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13Z"
        fill="black"
      />
      <path
        d="M19.4439 18.2975C19.4439 17.9145 19.2918 17.5473 19.021 17.2765C18.7502 17.0057 18.3829 16.8535 17.9999 16.8535C17.6169 16.8535 17.2496 17.0057 16.9788 17.2765C16.708 17.5473 16.5559 17.9145 16.5559 18.2975V20.4645H19.4449L19.4439 18.2975Z"
        fill="black"
      />
      <path
        d="M18.162 23.3496V23.4826L19.241 24.5606L18.162 25.6386V30.3556H17.814V29.8286H16.623V29.1216H16.971V29.4826H17.814V28.4336H16.971V28.7886H16.623V28.0866H17.814V25.6366L16.734 24.5606L17.814 23.4866V23.3496H18.162Z"
        fill="#FFF100"
      />
      <path
        d="M17.24 24.5566L17.988 23.8086L18.736 24.5576L17.987 25.3056L17.24 24.5566Z"
        fill="#DA1C0B"
      />
      <path
        d="M18.1471 21.3203H17.8531C17.6101 21.3203 17.4131 21.6203 17.4131 21.9893V23.3273C17.4131 23.6963 17.6101 23.9963 17.8531 23.9963H18.1471C18.3901 23.9963 18.5871 23.6963 18.5871 23.3273V21.9893C18.5871 21.6203 18.3901 21.3203 18.1471 21.3203ZM18.2571 23.3493C18.2571 23.5583 18.1461 23.7263 18.0101 23.7263C17.8741 23.7263 17.7621 23.5583 17.7621 23.3493V22.0003C17.7621 21.7933 17.8731 21.6253 18.0101 21.6253C18.1471 21.6253 18.2571 21.7933 18.2571 22.0003V23.3493Z"
        fill="#FFF100"
      />
      <path
        d="M19.3261 20.2646C19.2191 20.2046 19.0761 20.2066 19.0081 20.2676L18.0001 21.1766L16.9921 20.2676C16.9241 20.2066 16.7811 20.2056 16.6741 20.2646C16.5661 20.3236 16.5341 20.4206 16.6021 20.4826L17.8341 21.5906C17.8721 21.6246 17.9341 21.6356 18.0001 21.6316C18.0661 21.6356 18.1271 21.6246 18.1661 21.5906L19.3981 20.4826C19.4671 20.4206 19.4351 20.3226 19.3261 20.2646Z"
        fill="#FFF100"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1160">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HongKongFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 27C36 28.0609 35.5786 29.0783 34.8284 29.8284C34.0783 30.5786 33.0609 31 32 31H4C2.93913 31 1.92172 30.5786 1.17157 29.8284C0.421427 29.0783 0 28.0609 0 27V9C0 7.93913 0.421427 6.92172 1.17157 6.17157C1.92172 5.42143 2.93913 5 4 5H32C33.0609 5 34.0783 5.42143 34.8284 6.17157C35.5786 6.92172 36 7.93913 36 9V27Z"
      fill="#DE2910"
    />
    <path
      d="M19.626 9.20063C19.022 8.88663 18.337 8.71963 17.591 8.89063C16.685 9.09863 15.58 10.0386 15.279 11.1306C15.137 11.6456 15.018 12.1006 15.025 12.5216C15.03 12.8116 15.029 13.2956 15.064 13.7736C15.088 14.1126 15.257 14.8446 15.525 15.4906L15.542 15.4846C15.689 15.9756 16.175 16.7376 16.651 17.3626C17.197 18.0796 17.624 18.4026 17.71 18.4016C17.6478 18.3666 17.5928 18.3201 17.548 18.2646C17.236 17.8736 16.924 17.1606 16.86 16.6776C16.736 15.7346 16.896 15.0526 17.157 14.2336C17.222 14.0286 17.357 13.9696 17.446 14.0226C17.453 14.0266 17.457 14.0356 17.464 14.0416C17.519 14.0926 17.553 14.1856 17.504 14.3556C17.379 14.7936 17.073 15.8956 17.236 16.6776C17.386 17.3986 17.6 17.8286 17.853 18.1326C17.7127 17.8196 17.6368 17.4816 17.63 17.1386C17.626 16.9146 17.607 16.6926 17.719 16.4916C17.907 16.1546 18.181 15.9736 18.498 15.8026C18.717 15.6846 18.923 15.5236 19.112 15.4026C19.972 14.8546 20.261 13.7706 20.237 13.3326L20.216 13.0056C20.234 12.8866 20.18 12.5596 20.037 12.2316C19.9242 11.9932 19.7861 11.7675 19.625 11.5586C19.556 11.4636 19.517 11.3546 19.479 11.2876C19.332 11.0326 19.332 10.7436 19.334 10.5606C19.335 10.3446 19.363 10.3196 19.425 10.2166C19.474 10.1346 19.527 10.0236 19.693 9.93463C19.815 9.87063 20.09 9.88963 20.252 9.97263C20.39 10.0416 20.416 10.0356 20.487 10.0746C20.551 10.1096 20.718 10.1976 20.708 10.1626C20.669 10.0306 20.185 9.49063 19.626 9.20063ZM15.888 19.0676C14.947 18.9386 14.33 18.6046 13.608 18.1366C13.429 18.0206 13.406 17.8756 13.478 17.8036L13.484 17.8006C13.543 17.7486 13.65 17.7346 13.816 17.8346C14.207 18.0706 15.189 18.6556 15.986 18.7056C16.635 18.7456 17.073 18.6746 17.416 18.5446C17.1176 18.5726 16.8166 18.5496 16.526 18.4766C16.309 18.4196 16.09 18.3776 15.926 18.2166C15.653 17.9456 15.552 17.6326 15.472 17.2806C15.417 17.0376 15.318 16.7966 15.252 16.5816C14.957 15.6056 13.991 15.0346 13.562 14.9396L13.242 14.8726C13.132 14.8226 12.802 14.7886 12.448 14.8356C12.1879 14.8799 11.9334 14.9523 11.689 15.0516C11.578 15.0936 11.464 15.1006 11.389 15.1196C11.103 15.1926 10.825 15.1146 10.65 15.0636C10.442 15.0036 10.425 14.9696 10.343 14.8816C10.277 14.8126 10.184 14.7336 10.143 14.5486C10.114 14.4146 10.207 14.1546 10.33 14.0206C10.434 13.9086 10.435 13.8806 10.491 13.8216C10.542 13.7686 10.672 13.6326 10.635 13.6336C10.499 13.6336 9.84897 13.9536 9.41997 14.4136C8.95397 14.9116 8.60797 15.5256 8.57197 16.2896C8.52897 17.2186 9.13597 18.5366 10.106 19.1216C10.562 19.3956 10.969 19.6346 11.377 19.7406C11.658 19.8136 12.123 19.9456 12.593 20.0416C12.926 20.1086 13.676 20.1456 14.37 20.0616V20.0426C14.883 20.0336 15.747 19.7706 16.476 19.4826C17.397 19.1166 17.847 18.7466 17.779 18.7126L17.767 18.7226C17.758 18.7326 17.741 18.7356 17.723 18.7386C17.684 18.7676 17.658 18.7986 17.598 18.8246C17.141 19.0206 16.37 19.1346 15.888 19.0676ZM18.404 20.2386C18.343 19.3746 18.176 18.8806 18.098 18.7996C18.104 18.8256 18.116 18.8376 18.12 18.8676C18.181 19.3636 18.073 20.1346 17.873 20.5796C17.484 21.4466 16.99 21.9436 16.338 22.5066C16.23 22.5986 16.124 22.6256 16.05 22.6056C16.0269 22.6007 16.0057 22.5892 15.989 22.5726C15.9724 22.5559 15.9609 22.5347 15.956 22.5116C15.941 22.4396 15.98 22.3356 16.106 22.2206C16.442 21.9116 17.281 21.1356 17.553 20.3826C17.763 19.7996 17.822 19.3736 17.803 19.0176C17.7427 19.3268 17.6265 19.6223 17.46 19.8896C17.341 20.0786 17.235 20.2746 17.031 20.3816C16.69 20.5606 16.361 20.5616 16.002 20.5296C15.755 20.5096 15.494 20.5316 15.269 20.5276C14.249 20.5136 13.413 21.2616 13.193 21.6416L13.032 21.9266C12.951 22.0156 12.819 22.3196 12.758 22.6716C12.711 22.9366 12.721 23.2316 12.733 23.4606C12.739 23.5786 12.711 23.6896 12.707 23.7676C12.689 24.0616 12.531 24.3036 12.429 24.4556C12.309 24.6346 12.272 24.6406 12.164 24.6926C12.079 24.7336 11.974 24.7986 11.785 24.7826C11.649 24.7696 11.429 24.6026 11.339 24.4446C11.263 24.3116 11.237 24.3026 11.198 24.2306C11.163 24.1666 11.073 24.0006 11.062 24.0366C11.021 24.1666 11.129 24.8836 11.437 25.4306C11.771 26.0266 12.252 26.5406 12.97 26.8066C13.841 27.1286 15.281 26.9496 16.132 26.2006C16.533 25.8486 16.883 25.5316 17.108 25.1766C17.263 24.9316 17.529 24.5286 17.763 24.1096C17.928 23.8136 18.188 23.1076 18.319 22.4216L18.302 22.4166C18.447 21.9256 18.459 21.0226 18.404 20.2386Z"
      fill="white"
    />
    <path
      d="M24.492 23.067C24.311 22.564 24.146 22.124 23.896 21.784C23.725 21.55 23.447 21.155 23.142 20.783C22.927 20.521 22.367 20.021 21.775 19.647L21.766 19.661C21.361 19.346 20.525 19.0039 19.776 18.7679C18.993 18.5219 18.465 18.483 18.323 18.516C18.3964 18.5082 18.4705 18.5154 18.541 18.537C19.021 18.678 19.685 19.0859 20.014 19.4449C20.655 20.1479 20.912 20.7989 21.169 21.6209C21.234 21.828 21.155 21.9549 21.049 21.9579C21.046 21.9579 21.046 21.963 21.043 21.963C21.038 21.963 21.037 21.9569 21.034 21.9549C20.959 21.9479 20.875 21.8909 20.816 21.7189C20.667 21.2879 20.288 20.2099 19.707 19.6599C19.172 19.1549 18.75 18.9249 18.368 18.8189C18.297 18.7999 18.26 18.7689 18.222 18.7399C18.217 18.7439 18.212 18.743 18.207 18.749L18.35 18.8339C18.549 18.9409 18.868 19.1929 19.106 19.5169C19.237 19.6989 19.381 19.869 19.406 20.098C19.447 20.48 19.328 20.7859 19.169 21.1109C19.059 21.3339 18.983 21.5839 18.898 21.7919C18.511 22.7349 18.9 23.787 19.173 24.1309L19.379 24.3859C19.433 24.4939 19.667 24.729 19.972 24.914C20.201 25.055 20.48 25.153 20.699 25.228C20.81 25.265 20.903 25.3309 20.974 25.3639C21.241 25.4869 21.408 25.7239 21.512 25.8749C21.635 26.0519 21.627 26.0889 21.636 26.2089C21.643 26.3029 21.664 26.4239 21.58 26.5929C21.518 26.7149 21.282 26.8589 21.103 26.8859C20.951 26.9069 20.933 26.9279 20.852 26.9379C20.78 26.9469 20.591 26.97 20.622 26.994C20.727 27.08 21.434 27.242 22.056 27.1559C22.733 27.0639 23.388 26.804 23.898 26.235C24.516 25.538 24.875 24.132 24.492 23.067Z"
      fill="white"
    />
    <path
      d="M27.0099 15.0684C26.5139 14.2824 25.2629 13.5494 24.1319 13.6244C23.6019 13.6604 23.1309 13.6984 22.7369 13.8434C22.4639 13.9434 22.0069 14.1014 21.5669 14.2924C21.2549 14.4274 20.6209 14.8294 20.0989 15.2944L20.1099 15.3074C19.6939 15.6094 19.1339 16.3194 18.7019 16.9744C18.2469 17.6634 18.0719 18.1454 18.0669 18.2874C18.0809 18.2304 18.0939 18.1724 18.1399 18.0984C18.4059 17.6744 18.9779 17.1464 19.4139 16.9274C20.2639 16.5024 20.9599 16.4294 21.8199 16.4054C22.0369 16.3994 22.1369 16.5084 22.1129 16.6104C22.1076 16.6272 22.0991 16.6428 22.0879 16.6564C22.0469 16.7134 21.9719 16.7634 21.8169 16.7714C21.3629 16.7974 20.2219 16.8704 19.5359 17.2804C18.9039 17.6594 18.5679 18.0034 18.3629 18.3414C18.3338 18.3903 18.2937 18.4317 18.2459 18.4624C18.2479 18.4674 18.2459 18.4714 18.2499 18.4774L18.3719 18.3624C18.5289 18.2014 18.8599 17.9644 19.2359 17.8244C19.4459 17.7464 19.6499 17.6554 19.8779 17.6944C20.2569 17.7594 20.5189 17.9594 20.7849 18.2024C20.9699 18.3694 21.1889 18.5114 21.3639 18.6494C22.1659 19.2804 23.2849 19.1964 23.6909 19.0294L23.9929 18.9004C24.1099 18.8794 24.3999 18.7184 24.6639 18.4764C24.8609 18.2944 25.0329 18.0554 25.1629 17.8654C25.2299 17.7674 25.3189 17.6974 25.3709 17.6384C25.5629 17.4154 25.8359 17.3204 26.0089 17.2614C26.2129 17.1924 26.2459 17.2104 26.3639 17.2354C26.4569 17.2544 26.5789 17.2664 26.7179 17.3944C26.8189 17.4874 26.8919 17.7544 26.8659 17.9344C26.8449 18.0864 26.8619 18.1094 26.8479 18.1894C26.8359 18.2614 26.8089 18.4484 26.8389 18.4264C26.9499 18.3484 27.3009 17.7134 27.3899 17.0914C27.4859 16.4164 27.4179 15.7154 27.0099 15.0684Z"
      fill="white"
    />
    <path
      d="M17.7901 12.6172L17.4241 13.1692L16.7971 13.0222L16.7801 13.0182L17.1911 13.5372L16.8571 14.0872L16.8481 14.1032L17.4691 13.8722L17.9021 14.3742L17.8731 13.7112L18.4671 13.4612L18.4841 13.4542L17.8451 13.2772L17.7901 12.6172ZM13.2111 16.6772L13.2091 16.6592L12.8671 17.2262L12.2151 17.1012L12.6481 17.6032L12.3381 18.1672L12.3291 18.1832L12.9401 17.9262L13.3801 18.3952L13.3931 18.4092L13.3371 17.7492L13.9201 17.4752L13.9371 17.4672L13.2921 17.3162L13.2111 16.6772ZM23.5591 16.4852L22.9161 16.3222L22.8461 15.6632L22.4931 16.2232L21.8621 16.0902L21.8451 16.0862L22.2681 16.5962L21.9451 17.1542L21.9371 17.1702L22.5521 16.9242L22.9831 17.4032L22.9961 17.4162L22.9541 16.7552L23.5421 16.4932L23.5591 16.4852ZM15.7191 22.0692L15.7171 22.0522L15.3771 22.6202L14.7451 22.5032L14.7271 22.4992L15.1621 22.9982L14.8561 23.5652L14.8471 23.5812L15.4561 23.3202L15.8991 23.7872L15.9121 23.8012L15.8521 23.1422L16.4341 22.8632L16.4501 22.8552L15.8041 22.7092L15.7191 22.0692ZM21.4961 21.5622L21.4951 21.5442L21.1221 22.0932L20.4971 21.9372L20.4791 21.9332L20.8841 22.4572L20.5431 23.0042L20.5341 23.0192L21.1571 22.7952L21.5701 23.2882L21.5821 23.3032L21.5641 22.6412L22.1601 22.3982L22.1781 22.3922L21.5421 22.2062L21.4961 21.5622Z"
      fill="#DE2910"
    />
  </svg>
);

const JapanFlagSvg = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_956)">
      <path
        d="M36.5 24.1875C36.5 27.6047 34.6027 30.375 30.875 30.375H6.125C2.39731 30.375 0.5 27.6047 0.5 24.1875V11.8125C0.5 8.39531 2.39731 5.625 6.125 5.625H30.875C34.6027 5.625 36.5 8.39531 36.5 11.8125V24.1875Z"
        fill="white"
      />
      <path
        d="M25.2338 18.3196C25.2338 21.86 22.3628 24.7321 18.8213 24.7321C15.2821 24.7321 12.4116 21.8605 12.4116 18.3196C12.4116 14.7786 15.2821 11.9082 18.8213 11.9082C22.3622 11.9082 25.2338 14.7786 25.2338 18.3196Z"
        fill="#EC1C24"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_956">
        <rect width="36" height="36" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const SwitzerlandFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.625 6.1875C1.89731 6.1875 0 8.95781 0 12.375V24.75C0 28.1672 1.89731 30.9375 5.625 30.9375H30.375C34.1027 30.9375 36 28.1672 36 24.75V12.375C36 8.95781 34.1027 6.1875 30.375 6.1875"
      fill="#EC1C24"
    />
    <path
      d="M10.6875 21.375H15.1875V25.875H20.25V21.375H24.75V16.3125H20.25V11.8125H15.1875V16.3125H10.6875V21.375Z"
      fill="white"
    />
  </svg>
);

const MaltaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1223)">
      <path
        d="M32 5H18V31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#CF142B"
      />
      <path
        d="M4 5C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H18V5H4Z"
        fill="#EEEEEE"
      />
      <path d="M1.65405 9.65625H10.3451V12.3442H1.65405V9.65625Z" fill="#CF142B" />
      <path d="M4.65601 6.6543H7.34401V15.3453H4.65601V6.6543Z" fill="#CF142B" />
      <path
        d="M4.71006 13.1916C5.21872 13.1916 5.63106 12.7793 5.63106 12.2706C5.63106 11.762 5.21872 11.3496 4.71006 11.3496C4.20141 11.3496 3.78906 11.762 3.78906 12.2706C3.78906 12.7793 4.20141 13.1916 4.71006 13.1916Z"
        fill="#CF142B"
      />
      <path
        d="M7.35508 13.1916C7.86374 13.1916 8.27608 12.7793 8.27608 12.2706C8.27608 11.762 7.86374 11.3496 7.35508 11.3496C6.84643 11.3496 6.43408 11.762 6.43408 12.2706C6.43408 12.7793 6.84643 13.1916 7.35508 13.1916Z"
        fill="#CF142B"
      />
      <path
        d="M4.71006 10.7443C5.21872 10.7443 5.63106 10.332 5.63106 9.82334C5.63106 9.31469 5.21872 8.90234 4.71006 8.90234C4.20141 8.90234 3.78906 9.31469 3.78906 9.82334C3.78906 10.332 4.20141 10.7443 4.71006 10.7443Z"
        fill="#CF142B"
      />
      <path
        d="M7.35508 10.7443C7.86374 10.7443 8.27608 10.332 8.27608 9.82334C8.27608 9.31469 7.86374 8.90234 7.35508 8.90234C6.84643 8.90234 6.43408 9.31469 6.43408 9.82334C6.43408 10.332 6.84643 10.7443 7.35508 10.7443Z"
        fill="#CF142B"
      />
      <path
        d="M4.708 12.9785C5.09902 12.9785 5.416 12.6615 5.416 12.2705C5.416 11.8795 5.09902 11.5625 4.708 11.5625C4.31698 11.5625 4 11.8795 4 12.2705C4 12.6615 4.31698 12.9785 4.708 12.9785Z"
        fill="#99AAB5"
      />
      <path
        d="M7.35497 12.9785C7.74599 12.9785 8.06297 12.6615 8.06297 12.2705C8.06297 11.8795 7.74599 11.5625 7.35497 11.5625C6.96396 11.5625 6.64697 11.8795 6.64697 12.2705C6.64697 12.6615 6.96396 12.9785 7.35497 12.9785Z"
        fill="#99AAB5"
      />
      <path
        d="M4.708 10.5312C5.09902 10.5312 5.416 10.2143 5.416 9.82323C5.416 9.43222 5.09902 9.11523 4.708 9.11523C4.31698 9.11523 4 9.43222 4 9.82323C4 10.2143 4.31698 10.5312 4.708 10.5312Z"
        fill="#99AAB5"
      />
      <path
        d="M7.35497 10.5312C7.74599 10.5312 8.06297 10.2143 8.06297 9.82323C8.06297 9.43222 7.74599 9.11523 7.35497 9.11523C6.96396 9.11523 6.64697 9.43222 6.64697 9.82323C6.64697 10.2143 6.96396 10.5312 7.35497 10.5312Z"
        fill="#99AAB5"
      />
      <path
        d="M6.03209 12.8488C7.03559 12.8488 7.84909 12.0353 7.84909 11.0318C7.84909 10.0283 7.03559 9.21484 6.03209 9.21484C5.02859 9.21484 4.21509 10.0283 4.21509 11.0318C4.21509 12.0353 5.02859 12.8488 6.03209 12.8488Z"
        fill="#CCD6DD"
      />
      <path d="M5 7H7V15H5V7Z" fill="#CCD6DD" />
      <path d="M2 10H10V12H2V10Z" fill="#CCD6DD" />
      <path
        d="M6.03188 12.2869C6.69683 12.2869 7.23588 11.7479 7.23588 11.0829C7.23588 10.418 6.69683 9.87891 6.03188 9.87891C5.36693 9.87891 4.82788 10.418 4.82788 11.0829C4.82788 11.7479 5.36693 12.2869 6.03188 12.2869Z"
        fill="#B2C0C9"
      />
      <path
        d="M6.64695 11.0222C6.66195 11.0052 6.67895 10.9902 6.69495 10.9752L6.70395 10.9682C6.74595 10.9892 6.78695 11.0152 6.82695 11.0402C6.90695 11.0892 7.16095 10.9742 7.04595 10.9032C6.94695 10.8422 6.84795 10.7712 6.72595 10.7922C6.63706 10.8107 6.55482 10.8528 6.48795 10.9142C6.47995 10.8522 6.47295 10.7912 6.45895 10.7302C6.47795 10.7102 6.48895 10.6882 6.48395 10.6612C6.47295 10.6032 6.50495 10.5392 6.52495 10.4862C6.53495 10.4602 6.52095 10.4422 6.49995 10.4312C6.50895 10.4192 6.51595 10.4072 6.52395 10.3942C6.55931 10.4067 6.59537 10.417 6.63195 10.4252C6.66628 10.4299 6.70119 10.4277 6.73466 10.4188C6.76813 10.4098 6.7995 10.3944 6.82695 10.3732C6.87295 10.3372 6.85795 10.3002 6.80495 10.2902C6.71095 10.2712 6.62395 10.2232 6.53595 10.1852C6.47795 10.1602 6.39295 10.1862 6.34195 10.2142C6.30895 10.2322 6.25795 10.2802 6.31095 10.3062C6.30495 10.3122 6.29795 10.5262 6.29495 10.5332C6.25095 10.6282 6.17695 9.99923 6.12595 10.9992H6.10795C6.09095 10.9992 5.96695 10.6542 5.97395 10.5852C6.04795 10.5702 5.99995 10.3212 5.99995 10.2702V10.2412C5.99995 10.2262 6.11295 10.2162 6.10495 10.2082C6.13495 10.1892 6.22195 10.1632 6.19495 10.1412C6.15295 10.1062 6.09495 10.1302 6.04895 10.1482C6.03495 10.1412 6.03495 10.1362 6.02095 10.1342C6.01095 10.1322 6.00795 10.1342 5.99795 10.1342C6.05195 10.1122 6.09795 10.0762 6.08395 10.0352C6.07595 10.0102 6.06995 9.99023 6.08395 9.96523C6.15095 9.84923 5.87395 9.87523 5.82695 9.95623C5.81271 9.97878 5.80378 10.0043 5.80084 10.0308C5.79789 10.0573 5.80101 10.0841 5.80995 10.1092C5.82195 10.1472 5.87095 10.1602 5.92295 10.1552C5.89442 10.1698 5.87078 10.1924 5.85495 10.2202L5.85195 10.2292C5.81111 10.2304 5.77081 10.2389 5.73295 10.2542C5.57195 10.3232 5.40195 10.3732 5.25095 10.4632C5.22595 10.4782 5.15695 10.5262 5.21995 10.5462C5.26341 10.5563 5.30881 10.5538 5.35095 10.5392C5.35295 10.5462 5.35295 10.5522 5.35695 10.5582C5.39819 10.6112 5.45082 10.6543 5.51095 10.6842C5.57195 10.7142 5.65295 10.6972 5.70695 10.6612C5.74295 10.6382 5.78195 10.5802 5.73695 10.5492C5.75395 10.5242 5.77995 10.5062 5.80495 10.4882C5.80705 10.5504 5.81611 10.6121 5.83195 10.6722C5.83593 10.6868 5.84389 10.7 5.85495 10.7102C5.82319 10.7162 5.79273 10.7277 5.76495 10.7442C5.73195 10.7642 5.69295 10.8092 5.72295 10.8402C5.65224 10.852 5.58334 10.8728 5.51795 10.9022C5.49295 10.9132 5.43795 10.9452 5.43295 10.9802L5.33695 10.9922C5.28595 11.0002 5.20195 11.0242 5.18395 11.0822C5.15966 11.0836 5.13555 11.0873 5.11195 11.0932C5.05295 11.1012 4.94195 11.1272 4.93695 11.1792C4.92895 11.2712 4.97495 11.3462 5.01495 11.4242C4.97713 11.4594 4.95126 11.5056 4.94095 11.5562C4.91695 11.6752 5.19695 11.6332 5.21795 11.5272C5.22095 11.5112 5.22295 11.4952 5.23695 11.4852C5.27195 11.4602 5.30695 11.4112 5.27595 11.3772C5.28795 11.3672 5.29595 11.3592 5.29195 11.3522C5.25695 11.2842 5.21995 11.2182 5.21495 11.1422C5.22999 11.148 5.24585 11.1514 5.26195 11.1522C5.29059 11.2545 5.35036 11.3454 5.43295 11.4122C5.45095 11.4282 5.48395 11.4302 5.51995 11.4252C5.5049 11.4358 5.49312 11.4503 5.48595 11.4672C5.45488 11.5519 5.43505 11.6404 5.42695 11.7302C5.42295 11.7672 5.45095 11.8032 5.48695 11.8122C5.59807 11.8406 5.70153 11.8932 5.78995 11.9662C5.88695 12.0402 6.12895 11.9042 6.00295 11.8072C5.91612 11.7391 5.81887 11.6854 5.71495 11.6482C5.72056 11.597 5.73231 11.5466 5.74995 11.4982C5.75631 11.4834 5.75873 11.4672 5.75695 11.4512C5.77944 11.4427 5.80118 11.4324 5.82195 11.4202C5.99995 11.3122 6.21795 11.2892 6.40895 11.2022C6.40095 11.2302 6.41795 11.2572 6.45795 11.2662C6.53995 11.2852 6.68895 11.2842 6.71595 11.3782C6.74295 11.4732 6.71095 11.5872 6.77195 11.6712C6.82795 11.7492 7.09495 11.6552 7.02795 11.5622C7.00495 11.5302 7.00895 11.4672 7.00695 11.4292C7.00395 11.3702 7.00095 11.3082 6.97295 11.2542C6.91595 11.1462 6.73095 11.1382 6.62695 11.1132C6.59095 11.1052 6.55095 11.0582 6.51295 11.0702C6.51595 11.0632 6.50995 10.9992 6.49195 10.9992H6.48595C6.48695 10.9992 6.48695 11.0472 6.48795 11.0462C6.54895 11.0422 6.60795 11.0692 6.64695 11.0222Z"
        fill="#99AAB5"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1223">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MexicoFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1255)">
      <path
        d="M4 5C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H11V5H4Z"
        fill="#006847"
      />
      <path
        d="M32 5H25V31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#CE1126"
      />
      <path d="M11 5H25V31H11V5Z" fill="#EEEEEE" />
      <path
        d="M23 18C23 19.3261 22.4732 20.5979 21.5355 21.5355C20.5979 22.4732 19.3261 23 18 23C16.6739 23 15.4021 22.4732 14.4645 21.5355C13.5268 20.5979 13 19.3261 13 18H12C12 19.5913 12.6321 21.1174 13.7574 22.2426C14.8826 23.3679 16.4087 24 18 24C19.5913 24 21.1174 23.3679 22.2426 22.2426C23.3679 21.1174 24 19.5913 24 18H23Z"
        fill="#A6D388"
      />
      <path
        d="M13.5431 20.2688C13.5134 20.2101 13.4724 20.1579 13.4225 20.1151C13.3725 20.0723 13.3146 20.0398 13.252 20.0196C13.1894 19.9993 13.1235 19.9916 13.0579 19.997C12.9924 20.0024 12.9285 20.0207 12.8701 20.0508C12.8115 20.0806 12.7593 20.1216 12.7166 20.1716C12.6738 20.2215 12.6413 20.2794 12.621 20.3419C12.6007 20.4044 12.5929 20.4703 12.598 20.5359C12.6032 20.6014 12.6212 20.6653 12.6511 20.7238C12.7411 20.9008 12.8401 21.0738 12.9471 21.2398L12.9511 21.2468L12.9591 21.2588L12.9621 21.2658L12.9631 21.2678L12.9671 21.2728L12.9701 21.2788V21.2808L12.9731 21.2858L12.9741 21.2878L12.9771 21.2928L12.9781 21.2948L12.9811 21.2988L12.9831 21.3018L12.9851 21.3048L12.9861 21.3078L12.9891 21.3128L12.9901 21.3138L12.9921 21.3168L12.9951 21.3228L12.9961 21.3248L12.9991 21.3298L13.0001 21.3318L13.0071 21.3418V21.3428L13.0121 21.3498C13.0641 21.4268 13.1171 21.5018 13.1731 21.5768C13.2121 21.6293 13.2611 21.6736 13.3174 21.7071C13.3736 21.7406 13.4358 21.7627 13.5006 21.7721C13.5653 21.7815 13.6313 21.778 13.6947 21.7618C13.7581 21.7456 13.8177 21.7171 13.8701 21.6778C13.9228 21.6388 13.9673 21.5897 14.001 21.5334C14.0347 21.477 14.057 21.4146 14.0666 21.3497C14.0761 21.2848 14.0728 21.2186 14.0568 21.155C14.0407 21.0913 14.0123 21.0315 13.9731 20.9788C13.8134 20.7525 13.6697 20.5152 13.5431 20.2688ZM13.0461 18.6868C13.0088 18.4108 12.9934 18.1323 13.0001 17.8538C13.0038 17.7214 12.9549 17.5929 12.8639 17.4965C12.773 17.4001 12.6475 17.3438 12.5151 17.3398L12.4791 17.3408C12.3529 17.3463 12.2334 17.3994 12.1447 17.4894C12.0561 17.5794 12.0047 17.6996 12.0011 17.8258C11.9987 17.9295 11.9984 18.0332 12.0001 18.1368V18.2268L12.0011 18.2318V18.2598L12.0021 18.2628L12.0011 18.2648V18.2678L12.0021 18.2698V18.2988L12.0031 18.3018V18.3128L12.0041 18.3318L12.0051 18.3408V18.3518C12.0141 18.5118 12.0301 18.6708 12.0511 18.8288C12.0697 18.9595 12.1392 19.0775 12.2445 19.1572C12.3498 19.2368 12.4823 19.2715 12.6131 19.2538C12.6788 19.2452 12.7422 19.2237 12.7996 19.1905C12.857 19.1573 12.9072 19.1131 12.9475 19.0604C12.9877 19.0077 13.0171 18.9476 13.0341 18.8835C13.051 18.8194 13.0551 18.7525 13.0461 18.6868ZM18.3401 22.9868L18.3341 22.9878L18.2101 22.9958C17.9732 23.0054 17.736 22.9984 17.5001 22.9748C17.3681 22.9616 17.2363 23.0013 17.1336 23.0852C17.031 23.1691 16.9658 23.2904 16.9526 23.4223C16.9393 23.5543 16.979 23.6861 17.0629 23.7888C17.1468 23.8915 17.2681 23.9566 17.4001 23.9698L17.5251 23.9808L17.5291 23.9818L17.5311 23.9808L17.5341 23.9818H17.5361L17.5421 23.9828H17.5481L17.5511 23.9838L17.5581 23.9828L17.5611 23.9838H17.5661L17.5721 23.9848L17.5771 23.9858H17.5901L17.5961 23.9868H17.6091C17.7611 23.9968 17.9141 24.0018 18.0681 23.9988H18.1071L18.1141 23.9978L18.1201 23.9988H18.1351L18.1401 23.9978H18.1591L18.1651 23.9968L18.1711 23.9978L18.1721 23.9968L18.1781 23.9978H18.1791L18.1841 23.9968H18.1921L18.1981 23.9958H18.2041L18.2051 23.9968L18.2111 23.9958H18.2181L18.2231 23.9948H18.2431L18.2481 23.9938H18.2521L18.2561 23.9928L18.2601 23.9938H18.2651L18.2691 23.9928H18.2741C18.3161 23.9918 18.3591 23.9878 18.4011 23.9858C18.5306 23.9754 18.6507 23.9143 18.7355 23.8158C18.8203 23.7174 18.8629 23.5895 18.8541 23.4598C18.8515 23.395 18.8361 23.3313 18.8089 23.2724C18.7817 23.2135 18.743 23.1606 18.6953 23.1166C18.6475 23.0727 18.5916 23.0386 18.5306 23.0163C18.4697 22.994 18.4049 22.984 18.3401 22.9868ZM15.9011 22.5388C15.6489 22.4219 15.4067 22.2845 15.1771 22.1278C15.0882 22.0666 14.9818 22.036 14.8741 22.0408C14.7693 22.0453 14.6687 22.0825 14.5863 22.1472C14.5038 22.212 14.4439 22.301 14.4148 22.4017C14.3857 22.5024 14.389 22.6097 14.4242 22.7084C14.4595 22.8071 14.5248 22.8923 14.6111 22.9518L14.6121 22.9528L14.6181 22.9558L14.6241 22.9618L14.6301 22.9658L14.6361 22.9708C14.9021 23.1518 15.1841 23.3108 15.4781 23.4468C15.5375 23.4746 15.6019 23.4903 15.6674 23.4931C15.733 23.4959 15.7985 23.4857 15.8601 23.4632C15.9217 23.4406 15.9782 23.4061 16.0265 23.3615C16.0747 23.317 16.1136 23.2634 16.1411 23.2038C16.1692 23.1445 16.1854 23.0801 16.1885 23.0145C16.1917 22.9488 16.1819 22.8832 16.1595 22.8214C16.1372 22.7595 16.1029 22.7028 16.0585 22.6543C16.0142 22.6058 15.9607 22.5666 15.9011 22.5388ZM20.9311 22.1408C20.8428 22.145 20.7572 22.1726 20.6831 22.2208C20.4492 22.3694 20.2038 22.4988 19.9491 22.6078C19.8391 22.6515 19.7482 22.7329 19.6928 22.8375C19.6374 22.9421 19.621 23.063 19.6466 23.1786C19.6723 23.2941 19.7382 23.3968 19.8327 23.4681C19.9271 23.5394 20.0439 23.5748 20.1621 23.5678C20.2215 23.565 20.2799 23.5522 20.3351 23.5298L20.4691 23.4698H20.4711L20.4771 23.4658L20.4791 23.4648L20.4831 23.4628H20.4871L20.4911 23.4608L20.4931 23.4588L20.4991 23.4578L20.5011 23.4558L20.5041 23.4538L20.5091 23.4518L20.5121 23.4508L20.5171 23.4488L20.5191 23.4478L20.5241 23.4458L20.5261 23.4448C20.5291 23.4428 20.5291 23.4418 20.5311 23.4418L20.5331 23.4408L20.5391 23.4378H20.5411L20.5471 23.4348L20.5531 23.4318L20.5551 23.4308L20.5601 23.4278L20.5621 23.4268L20.5681 23.4238L20.5691 23.4228L20.5761 23.4218L20.5831 23.4178L20.5851 23.4168L20.5891 23.4138H20.5911L20.5971 23.4098L20.6051 23.4078L20.6111 23.4038L20.6191 23.3998L20.6201 23.3988L20.6341 23.3928L20.6411 23.3898L20.6551 23.3818L20.6631 23.3788L20.6691 23.3758L20.6841 23.3678L20.6901 23.3648L20.7131 23.3528L20.7201 23.3508L20.7341 23.3428L20.7411 23.3388H20.7421C20.7431 23.3378 20.7451 23.3368 20.7491 23.3368C20.7511 23.3338 20.7531 23.3328 20.7551 23.3318L20.7631 23.3278L20.7691 23.3248V23.3238L20.7831 23.3178L20.7911 23.3138L20.7921 23.3128L20.7971 23.3098L20.8051 23.3058L20.8111 23.3028H20.8131L20.8191 23.2988L20.8261 23.2948L20.8271 23.2938L20.8331 23.2908L20.8391 23.2878L20.8411 23.2868L20.8451 23.2838L20.8481 23.2828L20.8531 23.2798L20.8551 23.2788L20.8601 23.2758L20.8621 23.2748L20.8681 23.2728C20.8671 23.2718 20.8681 23.2718 20.8691 23.2718L20.8751 23.2688L20.8771 23.2678L20.8811 23.2648L20.8831 23.2638L20.8891 23.2608L20.8911 23.2598C20.8911 23.2578 20.8931 23.2578 20.8951 23.2568L20.8981 23.2558L20.9021 23.2538L20.9051 23.2518L20.9091 23.2498L20.9121 23.2478L20.9151 23.2458L20.9181 23.2428L20.9231 23.2418L20.9271 23.2408L20.9291 23.2388L20.9331 23.2368L20.9371 23.2338L20.9391 23.2328L20.9431 23.2308L20.9471 23.2278L20.9501 23.2258C20.9521 23.2268 20.9531 23.2258 20.9551 23.2248L20.9571 23.2228L20.9611 23.2208L20.9641 23.2188L20.9671 23.2168L20.9711 23.2148L20.9751 23.2118L20.9771 23.2108C20.9791 23.2098 20.9831 23.2098 20.9851 23.2078C20.9831 23.2068 20.9831 23.2078 20.9851 23.2078L20.9891 23.2048L20.9961 23.1998L20.9981 23.1988L21.0051 23.1958L21.0171 23.1888L21.0251 23.1838C21.0313 23.1794 21.038 23.1757 21.0451 23.1728C21.1081 23.1348 21.1741 23.0958 21.2361 23.0558C21.3476 22.9844 21.4263 22.8717 21.4548 22.7423C21.4833 22.6129 21.4593 22.4775 21.3881 22.3658C21.3354 22.2945 21.2665 22.2369 21.187 22.1977C21.1074 22.1586 21.0197 22.1391 20.9311 22.1408ZM23.5021 17.5228L23.4781 17.5238C23.3495 17.5292 23.2279 17.584 23.1387 17.6768C23.0495 17.7695 22.9995 17.8931 22.9991 18.0218C22.9991 18.2988 22.9741 18.5788 22.9271 18.8508C22.9048 18.9817 22.9354 19.1161 23.0122 19.2244C23.089 19.3327 23.2057 19.4061 23.3366 19.4283C23.4674 19.4506 23.6018 19.42 23.7101 19.3432C23.8184 19.2664 23.8918 19.1497 23.9141 19.0188V19.0138L23.9151 19.0118L23.9161 19.0098L23.9151 19.0078L23.9161 19.0058V19.0038L23.9171 19.0018V18.9988L23.9181 18.9968V18.9878C23.9201 18.9868 23.9201 18.9848 23.9201 18.9838V18.9778C23.9415 18.8481 23.9589 18.7177 23.9721 18.5868L23.9711 18.5858L23.9721 18.5828L23.9731 18.5778V18.5668L23.9751 18.5638L23.9741 18.5598V18.5578L23.9751 18.5548V18.5508L23.9771 18.5498L23.9751 18.5468V18.5428C23.9771 18.5418 23.9771 18.5408 23.9771 18.5398V18.5208L23.9791 18.5178C23.9926 18.3532 23.9996 18.1871 24.0001 18.0218C23.9998 17.8898 23.9473 17.7631 23.854 17.6696C23.7607 17.5761 23.6342 17.5234 23.5021 17.5228ZM23.0591 20.2188C23.0016 20.187 22.9383 20.1668 22.873 20.1594C22.8077 20.1521 22.7416 20.1576 22.6784 20.1758C22.6153 20.1941 22.5563 20.2245 22.5049 20.2655C22.4536 20.3066 22.4108 20.3573 22.3791 20.4148C22.2448 20.6583 22.0899 20.8899 21.9161 21.1068C21.8344 21.2108 21.7972 21.3428 21.8126 21.474C21.828 21.6053 21.8947 21.7251 21.9982 21.8073C22.1017 21.8895 22.2335 21.9274 22.3648 21.9127C22.4962 21.898 22.6163 21.8319 22.6991 21.7288C22.8151 21.5828 22.9261 21.4298 23.0291 21.2738C23.0311 21.2668 23.0361 21.2598 23.0401 21.2538L23.0411 21.2528L23.0451 21.2468L23.0491 21.2388C23.0511 21.2368 23.0531 21.2348 23.0531 21.2328L23.0541 21.2338L23.0581 21.2278V21.2268C23.0599 21.225 23.061 21.2225 23.0611 21.2198L23.0631 21.2188L23.0671 21.2128C23.0691 21.2118 23.0691 21.2088 23.0701 21.2068L23.0711 21.2058L23.0751 21.1998L23.0761 21.1978L23.0781 21.1928L23.0811 21.1908L23.0831 21.1858H23.0851L23.0871 21.1798L23.0881 21.1778L23.0921 21.1738L23.0931 21.1718C23.0941 21.1698 23.0941 21.1678 23.0961 21.1668L23.0971 21.1638L23.1011 21.1608C23.1011 21.1598 23.1011 21.1588 23.1031 21.1578V21.1538L23.1061 21.1518L23.1091 21.1468L23.1101 21.1448L23.1131 21.1388L23.1151 21.1368L23.1171 21.1328L23.1191 21.1298C23.1191 21.1288 23.1191 21.1278 23.1211 21.1268C23.1211 21.1258 23.1211 21.1248 23.1231 21.1238L23.1261 21.1188L23.1271 21.1158L23.1291 21.1128L23.1311 21.1098C23.1331 21.1088 23.1331 21.1078 23.1331 21.1068C23.1351 21.1058 23.1351 21.1048 23.1351 21.1028L23.1371 21.0998L23.1401 21.0958L23.1431 21.0918V21.0888L23.1451 21.0858L23.1481 21.0818L23.1511 21.0788V21.0758L23.1551 21.0708V21.0678C23.1571 21.0668 23.1581 21.0658 23.1581 21.0638L23.1601 21.0618L23.1621 21.0588L23.1651 21.0538L23.1671 21.0508V21.0488L23.1711 21.0438C23.1711 21.0428 23.1711 21.0418 23.1731 21.0408L23.1741 21.0378L23.1771 21.0338L23.1791 21.0298L23.1811 21.0268C23.1821 21.0258 23.1811 21.0238 23.1831 21.0228C23.1831 21.0218 23.1831 21.0208 23.1851 21.0208L23.1871 21.0158L23.1891 21.0138L23.1911 21.0078L23.1931 21.0068L23.1951 21.0028L23.1971 21.0008L23.1991 20.9958L23.2011 20.9938L23.2031 20.9878C23.2051 20.9868 23.2031 20.9858 23.2031 20.9858L23.2071 20.9808L23.2081 20.9788L23.2121 20.9738V20.9728L23.2151 20.9668L23.2171 20.9648L23.2191 20.9588L23.2241 20.9528L23.2271 20.9468V20.9458L23.2311 20.9388L23.2331 20.9378L23.2581 20.8908C23.3201 20.7752 23.334 20.6397 23.2968 20.5139C23.2595 20.3881 23.1741 20.282 23.0591 20.2188Z"
        fill="#5C913B"
      />
      <path
        d="M18 22C19.6569 22 21 21.5523 21 21C21 20.4477 19.6569 20 18 20C16.3431 20 15 20.4477 15 21C15 21.5523 16.3431 22 18 22Z"
        fill="#55ACEE"
      />
      <path
        d="M18.5 22C19.3284 22 20 21.5523 20 21C20 20.4477 19.3284 20 18.5 20C17.6716 20 17 20.4477 17 21C17 21.5523 17.6716 22 18.5 22Z"
        fill="#FFCC4D"
      />
      <path
        d="M19.1171 21.2745C19.0307 21.2738 18.9459 21.2508 18.8709 21.2078C18.7959 21.1647 18.7333 21.1031 18.6891 21.0289C18.6449 20.9546 18.6206 20.8702 18.6185 20.7838C18.6164 20.6973 18.6366 20.6118 18.6771 20.5355C18.8371 20.2415 19.0051 19.9745 19.1791 19.7405C19.0359 19.7466 18.8925 19.7496 18.7491 19.7495C18.4731 19.7495 18.2211 19.5245 18.2211 19.2485C18.2211 18.9725 18.4161 18.7485 18.6931 18.7485L18.7751 18.7495C19.0711 18.7495 19.3751 18.7315 19.6471 18.7065C19.7229 18.6989 19.7994 18.709 19.8705 18.7361C19.9417 18.7631 20.0056 18.8064 20.0571 18.8625C20.0711 18.8515 20.0851 18.8405 20.1001 18.8315C20.2001 18.7655 20.2931 18.7125 20.3801 18.6705C20.442 18.6228 20.5143 18.5906 20.5911 18.5765L20.6271 18.5695C20.8151 18.5085 20.9471 18.5005 21.0001 18.5005C21.0784 18.5002 21.1557 18.5184 21.2257 18.5536C21.2956 18.5888 21.3563 18.64 21.4028 18.703C21.4492 18.766 21.4802 18.8391 21.4931 18.9164C21.506 18.9936 21.5005 19.0728 21.4771 19.1475C21.3951 19.4135 21.2121 19.4735 20.8911 19.5375C20.8072 19.5711 20.7274 19.614 20.6531 19.6655C20.5626 19.7243 20.4558 19.7527 20.348 19.7466C20.2403 19.7405 20.1373 19.7002 20.0541 19.6315C20.1223 19.7194 20.1591 19.8276 20.1587 19.9389C20.1584 20.0501 20.1208 20.158 20.0521 20.2455C19.8821 20.4625 19.7151 20.7205 19.5561 21.0135C19.5133 21.0926 19.4499 21.1586 19.3726 21.2046C19.2953 21.2505 19.207 21.2747 19.1171 21.2745ZM17.6971 19.6855C17.6751 19.6856 17.653 19.6843 17.6311 19.6815C17.2739 19.6352 16.9209 19.5613 16.5751 19.4605C16.5121 19.4418 16.4534 19.4109 16.4024 19.3695C16.3514 19.3281 16.309 19.2771 16.2777 19.2193C16.2464 19.1616 16.2268 19.0982 16.22 19.0329C16.2132 18.9675 16.2194 18.9015 16.2381 18.8385L16.2441 18.8185L16.2321 18.8415C16.2 18.8989 16.157 18.9493 16.1054 18.99C16.0538 19.0307 15.9947 19.0608 15.9314 19.0787C15.8682 19.0965 15.802 19.1017 15.7368 19.0939C15.6715 19.0862 15.6084 19.0657 15.5511 19.0335C15.2189 18.8493 14.9137 18.6202 14.6441 18.3525C14.553 18.2582 14.5026 18.1319 14.5038 18.0008C14.5049 17.8697 14.5575 17.7443 14.6502 17.6516C14.7429 17.5589 14.8683 17.5063 14.9994 17.5052C15.1305 17.504 15.2568 17.5544 15.3511 17.6455C15.5481 17.8425 15.7791 18.0155 16.0391 18.1605C16.141 18.2176 16.2197 18.3086 16.2615 18.4176C16.3033 18.5267 16.3057 18.6469 16.2681 18.7575C16.3206 18.6523 16.4086 18.5689 16.5165 18.5221C16.6244 18.4752 16.7454 18.468 16.8581 18.5015C17.1341 18.5835 17.4371 18.6465 17.7581 18.6895C17.8841 18.7055 17.9992 18.7689 18.0802 18.8666C18.1611 18.9644 18.2019 19.0894 18.1941 19.2161C18.1863 19.3428 18.1307 19.4618 18.0384 19.549C17.9461 19.6362 17.8241 19.685 17.6971 19.6855ZM15.2451 17.3465C14.8191 17.3465 14.2681 17.1815 13.9341 16.7875C13.4221 16.1835 13.1211 15.4085 13.1671 14.8145C13.1791 14.6555 13.0241 14.5275 12.8721 14.4875C12.7851 14.4645 12.6321 14.4505 12.5601 14.6055C12.5463 14.6353 12.5268 14.6621 12.5027 14.6844C12.4785 14.7066 12.4502 14.7239 12.4194 14.7353C12.3886 14.7466 12.3558 14.7517 12.323 14.7504C12.2902 14.7491 12.2579 14.7413 12.2281 14.7275C12.1983 14.7137 12.1715 14.6942 12.1492 14.67C12.127 14.6459 12.1097 14.6176 12.0984 14.5868C12.087 14.5559 12.0819 14.5232 12.0832 14.4904C12.0845 14.4576 12.0923 14.4253 12.1061 14.3955C12.2621 14.0565 12.6121 13.9055 12.9981 14.0035C13.3561 14.0965 13.6991 14.4185 13.6651 14.8535C13.6291 15.3155 13.8911 15.9625 14.3151 16.4635C14.5381 16.7275 14.9261 16.8345 15.1901 16.8445C15.4051 16.8555 15.5141 16.8065 15.5371 16.7855C15.4811 16.6525 14.7401 16.2625 14.4241 16.0965C14.1551 15.9555 14.0751 15.7615 14.0551 15.6245C13.9881 15.1695 14.4551 14.7085 14.9071 14.2645C15.0661 14.1075 15.2171 13.9595 15.2991 13.8505C15.3921 13.7275 15.3771 13.6455 15.3591 13.5945C15.2901 13.4075 14.9911 13.2225 14.6311 13.1425C14.2981 13.0685 14.0731 12.9075 13.9631 12.6635C13.8181 12.3425 13.8951 11.9225 14.1971 11.3785C14.2131 11.3498 14.2345 11.3245 14.2602 11.3041C14.286 11.2837 14.3155 11.2686 14.347 11.2596C14.3786 11.2506 14.4116 11.2479 14.4443 11.2516C14.4769 11.2554 14.5084 11.2656 14.5371 11.2815C14.5658 11.2975 14.5911 11.3189 14.6115 11.3446C14.6319 11.3704 14.647 11.3998 14.656 11.4314C14.665 11.463 14.6677 11.496 14.664 11.5286C14.6602 11.5613 14.6501 11.5928 14.6341 11.6215C14.3491 12.1335 14.3771 12.3655 14.4191 12.4585C14.4611 12.5505 14.5681 12.6155 14.7391 12.6535C15.1621 12.7475 15.6711 12.9985 15.8271 13.4205C15.9161 13.6615 15.8711 13.9215 15.6991 14.1505C15.5951 14.2895 15.4311 14.4505 15.2581 14.6215C15.0001 14.8755 14.5191 15.3485 14.5501 15.5525C14.5561 15.5945 14.6111 15.6315 14.6571 15.6545C15.4081 16.0485 15.9071 16.3335 16.0091 16.6825C16.027 16.7421 16.0324 16.8046 16.0252 16.8663C16.018 16.9281 15.9982 16.9877 15.9671 17.0415C15.8701 17.2105 15.6681 17.3145 15.3821 17.3405C15.3391 17.3445 15.2921 17.3465 15.2451 17.3465Z"
        fill="#5C913B"
      />
      <path
        d="M19.5 19C19.7761 19 20 18.5523 20 18C20 17.4477 19.7761 17 19.5 17C19.2239 17 19 17.4477 19 18C19 18.5523 19.2239 19 19.5 19Z"
        fill="#FFCC4D"
      />
      <path
        d="M17.292 17.1875C17.292 17.4755 16.947 17.7085 16.521 17.7085C16.096 17.7085 15.75 17.4755 15.75 17.1875C15.75 16.8995 16.095 16.6665 16.521 16.6665C16.946 16.6665 17.292 16.8995 17.292 17.1875ZM16.105 12.5605C16.155 12.7725 15.878 13.0205 15.486 13.1135C15.094 13.2065 14.736 13.1095 14.685 12.8975C14.635 12.6845 14.912 12.4365 15.303 12.3435C15.696 12.2515 16.055 12.3475 16.105 12.5605Z"
        fill="#FFCC4D"
      />
      <path
        d="M22.533 17.9559C22.623 18.0259 22.776 17.2269 22.753 16.9779C22.753 16.9609 22.724 16.4319 22.836 16.0539C22.905 15.9259 22.909 14.9709 22.803 14.7199C22.887 14.7129 22.988 14.6859 23 14.5839C22.612 14.7269 22.521 13.7669 22.148 13.2149C21.786 12.6619 21.337 12.3399 20.868 12.0039C20.9071 11.9058 20.9618 11.8146 21.03 11.7339C20.455 12.0219 19.559 10.9789 18.235 11.0569C17.938 11.0859 17.797 11.1039 17.721 11.2859C17.474 11.3059 17.223 11.3619 17.223 11.6869C17.223 11.7649 17.294 11.9069 17.452 11.9079C17.668 11.9709 17.844 11.9219 17.991 12.2239L18.03 12.5359C18.03 12.5359 17.837 12.2889 17.731 12.2499L17.796 12.1169C17.696 12.0589 17.519 12.1059 17.519 12.1059C17.519 12.1059 17.134 11.9259 16.825 11.9739L16.765 11.7239C16.711 11.8779 16.59 11.8699 16.573 12.0149C16.539 11.9109 16.494 11.7819 16.462 11.6779C16.353 11.8259 16.385 11.9859 16.346 12.1399C16.304 12.1759 16.218 12.1769 16.196 12.0779C16.185 11.9559 16.17 11.9449 16.17 11.7999C16.092 11.9369 15.998 12.0039 15.967 12.2389L15.884 11.9789C15.887 12.2859 15.623 12.4689 15.373 12.6859C15.302 12.8159 15.384 12.8169 15.39 12.8839L15.522 12.9499L15.759 12.9329C15.798 12.9819 15.766 12.9859 15.869 13.0169C16.145 13.0939 16.489 12.7629 16.759 13.2839C16.635 13.3879 16.51 13.6309 16.55 13.6769C16.6 13.6769 16.45 13.7469 16.652 13.6829C16.442 13.8869 16.3 14.1559 16.3 14.1719C16.276 14.2299 16.384 14.1639 16.362 14.2689L16.412 14.2629C15.933 14.7809 16.396 15.3379 16.345 15.6369C16.425 15.7659 16.435 15.6339 16.535 15.6209C16.619 15.9889 16.861 16.2119 17.009 16.5029L16.697 16.5059C16.704 16.6439 16.829 16.7749 16.928 16.8959L16.719 16.9619C16.5846 17.0289 16.4649 17.1221 16.367 17.2359C16.298 17.4039 16.7 17.4439 16.894 17.4739L16.887 17.6769C17.19 17.7059 17.54 17.6159 17.54 17.5989L17.616 17.5399L17.787 17.6339C17.844 17.6339 17.933 17.4059 17.892 17.2309C18.002 17.3619 18.106 17.5729 18.216 17.7049L18.319 17.6909C18.413 17.8399 18.542 17.9879 18.636 18.1369L18.741 18.1769C18.802 18.1559 18.854 18.1489 18.887 18.0289L18.935 18.1129L19.101 17.9989L19.217 17.9759L19.304 18.1179C19.355 18.0989 19.405 17.9879 19.408 17.8699C19.46 17.9729 19.474 17.9649 19.512 17.9919L19.589 17.8299L20.004 18.2179L20.318 18.2359C20.43 18.3119 20.737 18.3599 20.789 18.2369C21.041 18.3449 21.338 18.2229 21.323 18.1029C21.555 18.1949 21.912 18.1329 21.912 18.1179C21.955 18.1129 22.065 18.0049 21.961 17.9239C21.194 17.3899 20.057 16.5059 19.618 16.2929C19.618 16.1349 19.499 15.5659 19.371 15.4099L19.475 15.2359C19.774 15.5149 19.882 15.4879 20.041 15.5319C20.211 15.6669 20.27 15.8719 20.44 16.0589L20.592 16.0869C20.4681 15.7616 20.2796 15.4646 20.038 15.2139C20.202 15.2959 20.474 15.5149 20.656 15.6739C20.776 15.8749 20.811 16.0349 20.921 16.2869C21.001 16.3379 21.083 16.5249 21.072 16.3699C21.053 16.0789 20.848 15.6179 20.848 15.5849C21.174 15.8429 21.17 16.2449 21.269 16.4899C21.352 16.6139 21.394 16.7799 21.43 16.7409L21.334 15.9849L21.278 15.7079C21.519 15.8469 21.605 16.3769 21.718 17.0129C21.718 17.1139 21.759 17.2249 21.753 17.2899C21.805 17.3539 21.864 17.5309 21.863 17.4259C21.863 17.4259 21.863 16.3919 21.792 16.1549C21.774 16.0279 21.822 15.8219 21.822 15.8219C21.91 16.2509 22.004 16.7159 22.093 17.1439V17.4589L22.225 17.5919C22.25 17.3319 22.28 17.0739 22.306 16.8159L22.207 15.8909V15.6269C22.205 15.5339 22.292 15.5509 22.347 15.6569C22.36 15.8839 22.36 16.0609 22.369 16.2869C22.408 16.5449 22.435 16.7339 22.454 17.0629C22.465 17.3289 22.477 17.9669 22.533 17.9559Z"
        fill="#C1694F"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1255">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const NewZealandFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1293)">
      <path
        d="M32 5H4C3.795 5 3.593 5.015 3.396 5.045L3.392 6.799L0.662004 6.795C0.229151 7.44884 -0.00113204 8.21587 4.18442e-06 9V27C4.18442e-06 28.0609 0.421432 29.0783 1.17158 29.8284C1.92172 30.5786 2.93914 31 4 31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#00247D"
      />
      <path
        d="M29.1939 9.50084H27.9309L27.7369 8.92084L27.4999 8.21484L27.2629 8.92084L27.0689 9.50084H25.8059L26.3409 9.94384L26.8129 10.3338L26.6139 10.9208L26.3469 11.7028L27.0029 11.1988L27.4999 10.8158L27.9969 11.1988L28.6529 11.7028L28.3859 10.9208L28.1869 10.3338L28.6589 9.94384L29.1939 9.50084Z"
        fill="#EEEDED"
      />
      <path
        d="M27.5 9L27.249 9.75H26.5L27.105 10.251L26.85 11L27.5 10.5L28.15 11L27.895 10.251L28.5 9.75H27.751L27.5 9Z"
        fill="#CF1B2B"
      />
      <path
        d="M29.1939 25.7508H27.9309L27.7369 25.1708L27.4999 24.4648L27.2629 25.1708L27.0689 25.7508H25.8059L26.3409 26.1938L26.8129 26.5838L26.6139 27.1708L26.3469 27.9528L27.0029 27.4488L27.4999 27.0658L27.9969 27.4488L28.6529 27.9528L28.3859 27.1708L28.1869 26.5838L28.6589 26.1938L29.1939 25.7508Z"
        fill="#EEEDED"
      />
      <path
        d="M27.5 25.25L27.249 26H26.5L27.105 26.501L26.85 27.25L27.5 26.75L28.15 27.25L27.895 26.501L28.5 26H27.751L27.5 25.25Z"
        fill="#CF1B2B"
      />
      <path
        d="M33.1939 13.5008H31.9309L31.7369 12.9208L31.4999 12.2148L31.2629 12.9208L31.0689 13.5008H29.8059L30.3409 13.9438L30.8129 14.3338L30.6139 14.9208L30.3469 15.7028L31.0029 15.1988L31.4999 14.8158L31.9969 15.1988L32.6529 15.7028L32.3859 14.9208L32.1869 14.3338L32.6589 13.9438L33.1939 13.5008Z"
        fill="#EEEDED"
      />
      <path
        d="M31.5 13L31.249 13.75H30.5L31.105 14.251L30.85 15L31.5 14.5L32.15 15L31.895 14.251L32.5 13.75H31.751L31.5 13Z"
        fill="#CF1B2B"
      />
      <path
        d="M25.1939 15.5008H23.9309L23.7369 14.9208L23.4999 14.2148L23.2629 14.9208L23.0689 15.5008H21.8059L22.3409 15.9438L22.8129 16.3338L22.6139 16.9208L22.3469 17.7028L23.0029 17.1988L23.4999 16.8158L23.9969 17.1988L24.6529 17.7028L24.3859 16.9208L24.1869 16.3338L24.6589 15.9438L25.1939 15.5008Z"
        fill="#EEEDED"
      />
      <path
        d="M23.5 15L23.249 15.75H22.5L23.105 16.251L22.85 17L23.5 16.5L24.15 17L23.895 16.251L24.5 15.75H23.751L23.5 15Z"
        fill="#CF1B2B"
      />
      <path
        d="M19 18V5H4C3.68 5 3.396 5.045 3.396 5.045L3.392 6.799L0.662003 6.795C0.662003 6.795 0.620003 6.854 0.535003 7C0.183716 7.60795 -0.000836445 8.29786 2.84992e-06 9V18H19Z"
        fill="#00247D"
      />
      <path
        d="M19 5H16.669L12 8.269V5H7V7.569L3.396 5.045C2.79485 5.1348 2.22261 5.36239 1.724 5.71L6.426 9H4.69L0.967 6.391C0.857207 6.51933 0.755351 6.65425 0.662 6.795L3.813 9H0V14H3.885L0 16.766V18H3.332L7 15.432V18H12V14.731L16.668 18H19V15.971L16.185 14H19V9H16.186L19 7.029V5Z"
        fill="#EEEEEE"
      />
      <path d="M11 5H8V10H0V13H8V18H11V13H19V10H11V5Z" fill="#CF1B2B" />
      <path
        d="M18.9999 5H17.5389L11.9999 8.879V9H13.5709L18.9999 5.198V5ZM1.72389 5.71C1.44392 5.90427 1.18958 6.13307 0.966887 6.391L4.68989 9H6.42489L1.72389 5.71ZM6.43689 14L0.733887 18H2.46089L6.99989 14.822V14H6.43689ZM18.9999 17.802V16.582L15.3129 14H13.5699L18.9999 17.802Z"
        fill="#CF1B2B"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1293">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const NorwayFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1311)">
      <path
        d="M10 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 15H10V5ZM32 5H16V15H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5ZM10 31H4C2.93913 31 1.92172 30.5786 1.17157 29.8284C0.421427 29.0783 0 28.0609 0 27V21H10V31ZM32 31H16V21H36V27C36 28.0609 35.5786 29.0783 34.8284 29.8284C34.0783 30.5786 33.0609 31 32 31Z"
        fill="#EF2B2D"
      />
      <path
        d="M14.5 5H11.556L11.531 16.5H0V19.5H11.525L11.5 31H14.5V19.5H36V16.5H14.5V5Z"
        fill="#002868"
      />
      <path
        d="M14.5 31H16V21H36V19.5H14.5V31ZM16 5H14.5V16.5H36V15H16V5ZM11.5 5H10V15H0V16.5H11.5V5ZM0 19.5V21H10V31H11.5V19.5H0Z"
        fill="#EEEEEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1311">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PolandFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1318)">
      <path
        d="M32 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 18H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#EEEEEE"
      />
      <path
        d="M0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V18H0V27Z"
        fill="#DC143C"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1318">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RomaniaFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1325)">
      <path
        d="M4 5C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 27C0 28.0609 0.421427 29.0783 1.17157 29.8284C1.92172 30.5786 2.93913 31 4 31H12V5H4Z"
        fill="#002B7F"
      />
      <path d="M12 5H24V31H12V5Z" fill="#FCD116" />
      <path
        d="M32 5H24V31H32C33.0609 31 34.0783 30.5786 34.8284 29.8284C35.5786 29.0783 36 28.0609 36 27V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5Z"
        fill="#CE1126"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1325">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SingaporeFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12470_1334)">
      <path
        d="M36 27C36 28.0609 35.5786 29.0783 34.8284 29.8284C34.0783 30.5786 33.0609 31 32 31H4C2.93913 31 1.92172 30.5786 1.17157 29.8284C0.421427 29.0783 0 28.0609 0 27V9C0 7.93913 0.421427 6.92172 1.17157 6.17157C1.92172 5.42143 2.93913 5 4 5H32C33.0609 5 34.0783 5.42143 34.8284 6.17157C35.5786 6.92172 36 7.93913 36 9V27Z"
        fill="#EEEEEE"
      />
      <path
        d="M36 18V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 18H36Z"
        fill="#ED2939"
      />
      <path
        d="M6 11.5C6 8.915 7.624 6.752 9.81 6.164C9.38151 6.05691 8.94167 6.00185 8.5 6C7.04131 6 5.64236 6.57946 4.61091 7.61091C3.57946 8.64236 3 10.0413 3 11.5C3 12.9587 3.57946 14.3576 4.61091 15.3891C5.64236 16.4205 7.04131 17 8.5 17C8.952 17 9.389 16.94 9.81 16.836C7.624 16.248 6 14.085 6 11.5Z"
        fill="white"
      />
      <path
        d="M12.0001 7L12.2251 7.691H12.9511L12.3631 8.118L12.5881 8.809L12.0001 8.382L11.4121 8.809L11.6371 8.118L11.0491 7.691H11.7751L12.0001 7ZM10.0001 14L10.2251 14.691H10.9511L10.3631 15.118L10.5881 15.809L10.0001 15.382L9.41207 15.809L9.63707 15.118L9.04907 14.691H9.77507L10.0001 14ZM14.0001 14L14.2251 14.691H14.9511L14.3631 15.118L14.5881 15.809L14.0001 15.382L13.4121 15.809L13.6371 15.118L13.0491 14.691H13.7751L14.0001 14ZM9.00007 10L9.22507 10.691H9.95107L9.36307 11.118L9.58807 11.809L9.00007 11.382L8.41207 11.809L8.63707 11.118L8.04907 10.691H8.77507L9.00007 10ZM15.0001 10L15.2251 10.691H15.9511L15.3631 11.118L15.5881 11.809L15.0001 11.382L14.4121 11.809L14.6371 11.118L14.0491 10.691H14.7751L15.0001 10Z"
        fill="#EEEEEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_12470_1334">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SwedenFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 31H32C34.209 31 36 29.209 36 26.5V20.5H15.5V31ZM32 5H15.5V15.5H36V9C36 7.93913 35.5786 6.92172 34.8284 6.17157C34.0783 5.42143 33.0609 5 32 5ZM10.5 5H4C2.93965 5 1.92269 5.42102 1.17263 6.17051C0.422574 6.92001 0.00079526 7.93665 0 8.997L0 15.5H10.5V5ZM0 20.5V26.504C0.002 29.211 1.792 31 4 31H10.5V20.5H0Z"
      fill="#006AA7"
    />
    <path d="M15.5 5H10.5V15.5H0V20.5H10.5V31H15.5V20.5H36V15.5H15.5V5Z" fill="#FECC00" />
  </svg>
);

const ThailandFlagSvg = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 26.5176V26.9996C0 28.0604 0.421427 29.0779 1.17157 29.828C1.92172 30.5782 2.93913 30.9996 4 30.9996H32C33.0609 30.9996 34.0783 30.5782 34.8284 29.828C35.5786 29.0779 36 28.0604 36 26.9996V26.5176H0Z"
      fill="#A7122D"
    />
    <path d="M0 22.1816H36V26.6666H0V22.1816Z" fill="#EEEEEE" />
    <path d="M0 13.5137H36V22.3347H0V13.5137Z" fill="#292648" />
    <path d="M0 9.18164H36V13.6666H0V9.18164Z" fill="#EEEEEE" />
    <path
      d="M0 9.333V9C0 7.93913 0.421427 6.92172 1.17157 6.17157C1.92172 5.42143 2.93913 5 4 5H32C33.0609 5 34.0783 5.42143 34.8284 6.17157C35.5786 6.92172 36 7.93913 36 9V9.333H0Z"
      fill="#A7122D"
    />
  </svg>
);

const XIconSvg = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3193 3.09521H15.4654L10.7779 9.06396L16.3125 17.1577H11.9639L8.5753 12.2515L4.67846 17.1577H2.53238L7.55873 10.7827L2.25 3.09521H6.7116L9.78953 7.59521L13.3193 3.09521ZM12.5569 15.7202H13.7428L6.06212 4.43896H4.76318L12.5569 15.7202Z"
        fill="#222222"
      />
    </svg>
  );
};

const WalletIconSvg = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.924 12.5953H18.23C16.806 12.5953 15.749 13.6543 15.749 14.8453C15.749 16.0363 16.806 17.0953 18.229 17.0953H20.947C21.153 17.0823 21.242 16.9433 21.249 16.8593V12.8313C21.242 12.7473 21.153 12.6083 20.947 12.5963L20.924 12.5953ZM20.85 11.0953C20.9167 11.0947 20.98 11.096 21.04 11.0993C21.91 11.1523 22.681 11.8093 22.746 12.7273C22.75 12.7873 22.75 12.8523 22.75 12.9123V16.7783C22.75 16.8383 22.75 16.9033 22.746 16.9633C22.681 17.8813 21.91 18.5383 21.039 18.5923C20.9797 18.595 20.9163 18.596 20.849 18.5953H18.231C16.086 18.5953 14.25 16.9673 14.25 14.8453C14.25 12.7233 16.086 11.0953 18.23 11.0953H20.85Z"
        fill="#595959"
      />
      <path
        d="M19 14.8453C19 15.1106 18.8946 15.3649 18.7071 15.5524C18.5196 15.74 18.2652 15.8453 18 15.8453C17.7348 15.8453 17.4804 15.74 17.2929 15.5524C17.1054 15.3649 17 15.1106 17 14.8453C17 14.5801 17.1054 14.3258 17.2929 14.1382C17.4804 13.9507 17.7348 13.8453 18 13.8453C18.2652 13.8453 18.5196 13.9507 18.7071 14.1382C18.8946 14.3258 19 14.5801 19 14.8453Z"
        fill="#222222"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.85 11.0954C20.9167 11.0947 20.98 11.096 21.04 11.0994C21.265 11.1124 21.483 11.1664 21.685 11.2554C21.578 9.64936 21.283 8.41136 20.359 7.48636C19.61 6.73836 18.661 6.40636 17.489 6.24836L17.447 6.24336L17.415 6.22036L13.679 3.74336C13.0308 3.3208 12.2738 3.09583 11.5 3.09583C10.7262 3.09583 9.96918 3.3208 9.321 3.74336L5.586 6.22036L5.553 6.24336L5.511 6.24836C4.339 6.40636 3.39 6.73836 2.641 7.48636C1.893 8.23536 1.561 9.18436 1.403 10.3564C1.25 11.4964 1.25 12.9514 1.25 14.7894V14.9014C1.25 16.7394 1.25 18.1954 1.403 19.3344C1.561 20.5064 1.893 21.4554 2.641 22.2044C3.39 22.9524 4.339 23.2844 5.511 23.4424C6.651 23.5954 8.106 23.5954 9.944 23.5954H13.056C14.894 23.5954 16.35 23.5954 17.489 23.4424C18.661 23.2844 19.61 22.9524 20.359 22.2044C21.283 21.2794 21.578 20.0414 21.685 18.4344C21.4817 18.525 21.2663 18.5777 21.039 18.5924C20.9797 18.595 20.9163 18.596 20.849 18.5954H20.168C20.054 19.9374 19.797 20.6454 19.298 21.1434C18.875 21.5664 18.295 21.8204 17.289 21.9554C16.262 22.0934 14.907 22.0954 13 22.0954H10C8.093 22.0954 6.739 22.0934 5.71 21.9554C4.705 21.8204 4.125 21.5664 3.702 21.1434C3.279 20.7204 3.025 20.1404 2.89 19.1344C2.752 18.1074 2.75 16.7524 2.75 14.8454C2.75 12.9384 2.752 11.5844 2.89 10.5554C3.025 9.55036 3.279 8.97036 3.702 8.54736C4.125 8.12436 4.705 7.87036 5.711 7.73536C6.739 7.59736 8.093 7.59536 10 7.59536H13C14.907 7.59536 16.262 7.59736 17.29 7.73536C18.295 7.87036 18.875 8.12436 19.298 8.54736C19.797 9.04536 20.054 9.75436 20.168 11.0954H20.85ZM9.944 6.09536H13.056C13.5727 6.09536 14.0593 6.09636 14.516 6.09836L12.85 4.99336C12.05 4.46336 10.95 4.46336 10.15 4.99336L8.483 6.09836C8.94033 6.0957 9.427 6.0947 9.943 6.09536"
        fill="#222222"
      />
      <path
        d="M6 10.0953C5.80109 10.0953 5.61032 10.1744 5.46967 10.315C5.32902 10.4557 5.25 10.6464 5.25 10.8453C5.25 11.0442 5.32902 11.235 5.46967 11.3757C5.61032 11.5163 5.80109 11.5953 6 11.5953H10C10.1989 11.5953 10.3897 11.5163 10.5303 11.3757C10.671 11.235 10.75 11.0442 10.75 10.8453C10.75 10.6464 10.671 10.4557 10.5303 10.315C10.3897 10.1744 10.1989 10.0953 10 10.0953H6Z"
        fill="#222222"
      />
      <path
        d="M19 14.8453C19 15.1106 18.8946 15.3649 18.7071 15.5524C18.5196 15.74 18.2652 15.8453 18 15.8453C17.7348 15.8453 17.4804 15.74 17.2929 15.5524C17.1054 15.3649 17 15.1106 17 14.8453C17 14.5801 17.1054 14.3258 17.2929 14.1382C17.4804 13.9507 17.7348 13.8453 18 13.8453C18.2652 13.8453 18.5196 13.9507 18.7071 14.1382C18.8946 14.3258 19 14.5801 19 14.8453Z"
        fill="#222222"
      />
    </svg>
  );
};

const DragIconSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.375 5.25C6.77282 5.25 7.15436 5.09196 7.43566 4.81066C7.71696 4.52936 7.875 4.14782 7.875 3.75C7.875 3.35218 7.71696 2.97064 7.43566 2.68934C7.15436 2.40804 6.77282 2.25 6.375 2.25C5.97718 2.25 5.59564 2.40804 5.31434 2.68934C5.03304 2.97064 4.875 3.35218 4.875 3.75C4.875 4.14782 5.03304 4.52936 5.31434 4.81066C5.59564 5.09196 5.97718 5.25 6.375 5.25ZM6.375 10.5C6.77282 10.5 7.15436 10.342 7.43566 10.0607C7.71696 9.77936 7.875 9.39782 7.875 9C7.875 8.60218 7.71696 8.22064 7.43566 7.93934C7.15436 7.65804 6.77282 7.5 6.375 7.5C5.97718 7.5 5.59564 7.65804 5.31434 7.93934C5.03304 8.22064 4.875 8.60218 4.875 9C4.875 9.39782 5.03304 9.77936 5.31434 10.0607C5.59564 10.342 5.97718 10.5 6.375 10.5ZM7.875 14.25C7.875 14.6478 7.71696 15.0294 7.43566 15.3107C7.15436 15.592 6.77282 15.75 6.375 15.75C5.97718 15.75 5.59564 15.592 5.31434 15.3107C5.03304 15.0294 4.875 14.6478 4.875 14.25C4.875 13.8522 5.03304 13.4706 5.31434 13.1893C5.59564 12.908 5.97718 12.75 6.375 12.75C6.77282 12.75 7.15436 12.908 7.43566 13.1893C7.71696 13.4706 7.875 13.8522 7.875 14.25ZM11.625 5.25C12.0228 5.25 12.4044 5.09196 12.6857 4.81066C12.967 4.52936 13.125 4.14782 13.125 3.75C13.125 3.35218 12.967 2.97064 12.6857 2.68934C12.4044 2.40804 12.0228 2.25 11.625 2.25C11.2272 2.25 10.8456 2.40804 10.5643 2.68934C10.283 2.97064 10.125 3.35218 10.125 3.75C10.125 4.14782 10.283 4.52936 10.5643 4.81066C10.8456 5.09196 11.2272 5.25 11.625 5.25ZM13.125 9C13.125 9.39782 12.967 9.77936 12.6857 10.0607C12.4044 10.342 12.0228 10.5 11.625 10.5C11.2272 10.5 10.8456 10.342 10.5643 10.0607C10.283 9.77936 10.125 9.39782 10.125 9C10.125 8.60218 10.283 8.22064 10.5643 7.93934C10.8456 7.65804 11.2272 7.5 11.625 7.5C12.0228 7.5 12.4044 7.65804 12.6857 7.93934C12.967 8.22064 13.125 8.60218 13.125 9ZM11.625 15.75C12.0228 15.75 12.4044 15.592 12.6857 15.3107C12.967 15.0294 13.125 14.6478 13.125 14.25C13.125 13.8522 12.967 13.4706 12.6857 13.1893C12.4044 12.908 12.0228 12.75 11.625 12.75C11.2272 12.75 10.8456 12.908 10.5643 13.1893C10.283 13.4706 10.125 13.8522 10.125 14.25C10.125 14.6478 10.283 15.0294 10.5643 15.3107C10.8456 15.592 11.2272 15.75 11.625 15.75Z"
      fill="#8C8C8C"
    />
  </svg>
);

const TwitterIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TwitterSVG} {...props} />
);
const TwitterIconSm = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TwitterSVGSm} {...props} />
);
export const XIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={XIconSvg} {...props} />
);

const InstagramIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={InstagramSVG} {...props} />
);
const FacebookIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FacebookSVG} {...props} />
);
const FacebookIconSm = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FacebookSVGSm} {...props} />
);
const LinkedinIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LinkedinSVG} {...props} />
);
const YoutubeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={YoutubeSVG} {...props} />
);
const DribbleIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DribbleSVG} {...props} />
);
const BehanceIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BehanceSVG} {...props} />
);
const GithubIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GithubSVG} {...props} />
);
const GlobalIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GlobalSVG} {...props} />
);
const TwitchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TwitchSVG} {...props} />
);
const DiscordIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DiscordSVG} {...props} />
);
const TiktokIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TiktokSVG} {...props} />
);
const LoadingSpinner = <LoadingOutlined style={{fontSize: "24px"}} spin />;
const CoachliLoader = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CoachliLoaderSVG} {...props} />
);
const RecordIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={RecordSVG} {...props} />
);
const CopyIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CopySVG} {...props} />
);
const CopyIconSm = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CopySVGSm} {...props} />
);
const FlutterwaveIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FlutterwaveSvg} {...props} />
);
const PayPalIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PayPalSvg} {...props} />
);
const ProductBagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProductBagSvg} {...props} />
);
const MailIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MailIconSVGSm} {...props} />
);
const VideoCameraIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={VideoCameraSvg} {...props} />
);
const ProductIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProductSvg} {...props} />
);
const ProductNavIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProductNavSvg} {...props} />
);
const CalendarColoredIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CalendarColoredSvg} {...props} />
);
const NigeriaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NigeriaFlagSvg} {...props} />
);
const UsaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UsaFlagSvg} {...props} />
);
const GbpFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GbpFlagSvg} {...props} />
);
const EuroFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EuroFlagSvg} {...props} />
);
const CanadaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CanadaFlagSvg} {...props} />
);
export const KenyaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={KenyaFlagSvg} {...props} />
);
export const GhanaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GhanaFlagSvg} {...props} />
);
export const UgandaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UgandaFlagSvg} {...props} />
);
export const TanzaniaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TanzaniaFlagSvg} {...props} />
);
export const SouthAfricaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SouthAfricaFlagSvg} {...props} />
);
export const AustraliaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AustraliaFlagSvg} {...props} />
);
export const BrazilFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BrazilFlagSvg} {...props} />
);
export const BulgariaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BulgariaFlagSvg} {...props} />
);
export const CroatiaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CroatiaFlagSvg} {...props} />
);
export const CzechFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CzechFlagSvg} {...props} />
);
export const DenmarkFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DenmarkFlagSvg} {...props} />
);
export const GibraltarFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GibraltarFlagSvg} {...props} />
);
export const HongKongFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HongKongFlagSvg} {...props} />
);
export const JapanFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={JapanFlagSvg} {...props} />
);
export const SwitzerlandFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SwitzerlandFlagSvg} {...props} />
);
export const MaltaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MaltaFlagSvg} {...props} />
);
export const MexicoFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MexicoFlagSvg} {...props} />
);
export const NewZealandFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NewZealandFlagSvg} {...props} />
);
export const NorwayFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NorwayFlagSvg} {...props} />
);
export const PolandFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PolandFlagSvg} {...props} />
);
export const RomaniaFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={RomaniaFlagSvg} {...props} />
);
export const SingaporeFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SingaporeFlagSvg} {...props} />
);
export const SwedenFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SwedenFlagSvg} {...props} />
);
export const ThailandFlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ThailandFlagSvg} {...props} />
);
export const WalletIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WalletIconSvg} {...props} />
);

export const DragIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DragIconSvg} {...props} />
);
// const SVG2 = (props: Partial<CustomIconComponentProps>) => (
//   <Icon component={SVG2} {...props} />
// );
export {
  TwitterIcon,
  TwitterIconSm,
  InstagramIcon,
  FacebookIcon,
  FacebookIconSm,
  LinkedinIcon,
  YoutubeIcon,
  DribbleIcon,
  BehanceIcon,
  GithubIcon,
  GlobalIcon,
  TwitchIcon,
  DiscordIcon,
  TiktokIcon,
  LoadingSpinner,
  CoachliLoader,
  SVG2,
  HeartSVG,
  BookSVG,
  RecordIcon,
  CopyIcon,
  CopyIconSm,
  FlutterwaveIcon,
  PayPalIcon,
  ProductBagIcon,
  MailIcon,
  VideoCameraIcon,
  ProductIcon,
  ProductNavIcon,
  CalendarColoredIcon,
  NigeriaFlagIcon,
  UsaFlagIcon,
  GbpFlagIcon,
  EuroFlagIcon,
  CanadaFlagIcon,
};
